/* eslint-disable react/prop-types */
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import {
  addInspectionFunction,
  addOtherDocuments,
  addPipelineOtherDocuments,
  documentTypeList,
  getApiCall,
  getOtherDocuments,
  getPipelienOtherDocuments,
  getUpcomingInspection,
  Moxoseparationinlisting,
  pipelineDocumentTypeList,
  postApiCall,
  deleteApiCall,
} from 'api/apiService';
import bathroom from 'assets/svg/bathroom.svg';
import bed from 'assets/svg/bed.svg';
import carGarage from 'assets/svg/carGarage.svg';
import axios from 'axios';
import {
  ADD_EXISTINGPROPERTY_APPRAISAL,
  ADD_PIPELINE_PROPERTY,
  ADD_PROPERTY_DETAILS,
  ADD_PROPERTY_FEATURELIST,
  ADD_PROPERTY_TYPELIST,
  DELETE_INSPECTION,
  DELETE_OTHERDOC,
  DELETE_PIPELINE_OTHERDOC,
  GET_APPRAISAL_PREFILL,
  PIPELINE_ADDPROPERTY_MEDIA,
  ADD_VENUE,
  ADD_PROPERTY_MEDIA,
  Get_Venue,
  CHECK_ADDRESS,
} from 'constant/app.config';
import dayjs from 'dayjs';
import moment from 'moment';
import ImagePreviewCard from 'component/Common/ImagePreviewCard';
import VideoPreviewCard from 'component/Common/VideoPreviewCard';
import React, {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import DeleteIcon from '../../assets/images/DeleteIcon.png';
import PdfIcon from '../../assets/images/pdficon.png';
import { handleKeyDown } from './AddListingModal';
import { AirbnbSlider, AirbnbThumbComponent } from './CustomizedSlider';
import {
  checkbox_style,
  icon,
  pick_date,
  select_dropdown,
  textboxmargin,
  textboxmargin_description,
  typography_textfield,
  typography_textfield_legalrep,
  upcoming_instructions,
} from './PropertyCreation.style';
import { ToggleOff, ToggleOn } from './RetrexCampaign';
import Loading from 'assets/images/loading.png';
import timezone from 'dayjs/plugin/timezone.js';
import { poppins400, poppins500 } from 'theme/common.style';
import AddAppraisalDialog from './AppraisalPropertyPrefill';
import utc from 'dayjs/plugin/utc';
import PropertyAddressField from './PropertyAddressField';
dayjs.extend(utc);
dayjs.extend(timezone);

const mergeRefs = (dropzoneRef, customRef) => {
  return (node) => {
    if (dropzoneRef) {
      if (typeof dropzoneRef === 'function') {
        dropzoneRef(node);
      } else {
        dropzoneRef.current = node;
      }
    }
    if (customRef) {
      customRef.current = node;
    }
  };
};

const FlexBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const DropZone = styled(FlexBox)(({ isDragActive, theme }) => ({
  width: '100%',
  height: 160,
  cursor: 'pointer',
  marginBottom: '16px',
  borderRadius: '4px',
  justifyContent: 'center',
  transition: 'all 350ms ease-in-out',
  border: '2px dashed rgba(108, 42, 210, 1)',
  background: isDragActive ? 'rgb(0, 0, 0, 0.15)' : '#f0e9fa',
}));

const CancelIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="23" cy="23" r="22.5" fill="white" stroke="#C4C4C4" />
      <path
        d="M14.3761 14.3925C14.617 14.1515 14.9437 14.0161 15.2843 14.0161C15.625 14.0161 15.9516 14.1515 16.1925 14.3925L22.992 21.1978L29.7914 14.3925C29.9099 14.2697 30.0516 14.1718 30.2084 14.1044C30.3651 14.037 30.5337 14.0015 30.7042 14C30.8748 13.9986 31.044 14.0311 31.2018 14.0957C31.3597 14.1604 31.5031 14.2559 31.6237 14.3766C31.7444 14.4973 31.8397 14.6408 31.9043 14.7989C31.9689 14.9569 32.0014 15.1262 32 15.2969C31.9985 15.4676 31.963 15.6363 31.8957 15.7932C31.8284 15.95 31.7305 16.0919 31.6078 16.2105L24.8084 23.0158L31.6078 29.8211C31.8418 30.0636 31.9713 30.3883 31.9684 30.7255C31.9655 31.0626 31.8304 31.385 31.5922 31.6234C31.354 31.8618 31.0318 31.997 30.695 32C30.3582 32.0029 30.0337 31.8733 29.7914 31.6391L22.992 24.8338L16.1925 31.6391C15.9503 31.8733 15.6258 32.0029 15.289 32C14.9521 31.997 14.6299 31.8618 14.3918 31.6234C14.1536 31.385 14.0185 31.0626 14.0156 30.7255C14.0126 30.3883 14.1421 30.0636 14.3761 29.8211L21.1755 23.0158L14.3761 16.2105C14.1353 15.9694 14 15.6424 14 15.3015C14 14.9606 14.1353 14.6336 14.3761 14.3925Z"
        fill="#666666"
      />
    </svg>
  );
};

const Timeicon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.51496 1.01896C8.34401 1.00635 8.17225 1 8 1V0C8.19685 0 8.39314 0.00726199 8.58852 0.0216722L8.51496 1.01896ZM10.5193 1.46905C10.1985 1.34533 9.86912 1.2454 9.53371 1.17008L9.75282 0.194382C10.1361 0.280463 10.5126 0.394665 10.8792 0.536055L10.5193 1.46905ZM11.889 2.17971C11.7458 2.08402 11.5994 1.99388 11.4503 1.90939L11.9432 1.0393C12.1136 1.13586 12.2809 1.23888 12.4446 1.34824C12.6082 1.4576 12.7674 1.5727 12.9219 1.69322L12.3066 2.48158C12.1715 2.37612 12.0322 2.27541 11.889 2.17971ZM13.7231 3.96934C13.5252 3.68829 13.3068 3.42218 13.0697 3.17321L13.794 2.48368C14.0649 2.76821 14.3145 3.07233 14.5407 3.39353L13.7231 3.96934ZM14.4672 5.32122C14.4012 5.16208 14.3296 5.00583 14.2526 4.85271L15.1458 4.40311C15.2339 4.5781 15.3157 4.75667 15.391 4.93853C15.4664 5.12039 15.5348 5.30453 15.5962 5.49054L14.6467 5.80423C14.5929 5.64147 14.5331 5.48035 14.4672 5.32122ZM14.9979 7.82822C14.9895 7.48455 14.9557 7.14197 14.8969 6.80326L15.8822 6.63231C15.9494 7.01939 15.988 7.41092 15.9976 7.80367L14.9979 7.82822ZM14.8655 9.36563C14.8991 9.1967 14.9264 9.02699 14.9474 8.85687L15.9398 8.97929C15.9159 9.17372 15.8847 9.36766 15.8463 9.56072C15.8079 9.75378 15.7625 9.94489 15.7102 10.1337L14.7464 9.867C14.7922 9.70179 14.8319 9.53457 14.8655 9.36563ZM13.914 11.745C14.0979 11.4546 14.2602 11.151 14.3995 10.8367L15.3137 11.2419C15.1545 11.6011 14.969 11.9481 14.7588 12.28L13.914 11.745ZM12.9497 12.9497C13.0715 12.828 13.1885 12.702 13.3005 12.5722L14.0577 13.2254C13.9297 13.3737 13.796 13.5177 13.6569 13.6569L12.9497 12.9497Z"
        fill="#212529"
      />
      <path
        d="M8 1C6.84885 1 5.71545 1.2839 4.70022 1.82655C3.68499 2.3692 2.81926 3.15386 2.17971 4.11101C1.54017 5.06816 1.14654 6.16827 1.03371 7.31388C0.920876 8.45949 1.09232 9.61525 1.53285 10.6788C1.97337 11.7423 2.66939 12.6808 3.55925 13.4111C4.44911 14.1414 5.50533 14.6409 6.63437 14.8655C7.76341 15.0901 8.93041 15.0327 10.032 14.6986C11.1336 14.3644 12.1358 13.7637 12.9497 12.9497L13.6569 13.6569C12.7266 14.5871 11.5812 15.2736 10.3223 15.6555C9.06332 16.0374 7.72961 16.1029 6.43928 15.8463C5.14895 15.5896 3.94183 15.0187 2.92486 14.1841C1.90788 13.3495 1.11243 12.2769 0.608966 11.0615C0.105504 9.846 -0.0904279 8.52514 0.0385242 7.21586C0.167476 5.90659 0.617333 4.64933 1.34825 3.55544C2.07916 2.46155 3.06857 1.5648 4.22883 0.94463C5.38909 0.324457 6.68439 0 8 0V1Z"
        fill="#212529"
      />
      <path
        d="M7.5 3C7.77614 3 8 3.22386 8 3.5V8.70984L11.2481 10.5659C11.4878 10.7029 11.5711 11.0083 11.4341 11.2481C11.2971 11.4878 10.9917 11.5711 10.7519 11.4341L7.25193 9.43412C7.09615 9.3451 7 9.17943 7 9V3.5C7 3.22386 7.22386 3 7.5 3Z"
        fill="#212529"
      />
    </svg>
  );
};
function ValueLabelComponent(props) {
  const { children, open, value } = props;

  return (
    <div
      style={{
        top: -30,
        position: 'relative',
        color: 'white',
        textAlign: 'center',
      }}
    >
      <Typography variant="caption" style={{ fontWeight: 'bold' }}>
        {value}
      </Typography>
      {children}
    </div>
  );
}
const Dateicon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2V5"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 2V5"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 9.08984H20.5"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6937 13.6992H15.7027"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6937 16.6992H15.7027"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9945 13.6992H12.0035"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9945 16.6992H12.0035"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.29529 13.6992H8.30427"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.29529 16.6992H8.30427"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default function PropertyCreationAddListing({
  value,
  setValue,
  onClose,
  options,
  setMoxoagentack,
  setMoxovendorack,
  setIsmediacompleted,
  fromHeader,
  responseData,
  setResponseProp,
  setResponseTempId,
  resumeTempId,
  dashboardcount,
  legalSliderRange,
  pipelineId = 0,
  categoryId = 0,
  prefillData,
  pipelineTempId,
}) {
  const theme = useTheme();
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const matches1200 = useMediaQuery(theme.breakpoints.down(1200));
  const matches1400 = useMediaQuery(theme.breakpoints.down(1400));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const useStyles = makeStyles((theme) => ({
    noSpinArrows: {
      '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
        {
          '-webkit-appearance': 'none',
          margin: 0,
        },
    },
    TableFont: {
      fontFamily: 'Poppins !important',
    },
    MaxPdfBox: {
      justifyContent: 'start',
      alignItems: 'center',
      textAlign: 'center',
    },
    pdfUploadText: {
      fontFamily: 'Poppins !important',
      fontSize: '14px !important',
      textAlign: 'center',
    },
    PropertyTitle: {
      fontSize: '24px !important',
      fontWeight: '500px !important',
      fontFamily: 'Poppins !important',
      textAlign: 'left !important',
      color: '#687999 !important',
      fontStyle: 'Medium !important',
      padding: '10px 0px 10px 0px !important',
      [theme.breakpoints.down('md')]: {
        fontSize: '18px !important',
        fontWeight: '500px !important',
        fontFamily: 'Poppins !important',
        textAlign: 'left !important',
        fontStyle: 'Medium !important',
        padding: '10px 0px 10px 0px !important',
      },
    },
    GridRow: {
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        display: 'block',
      },
    },
    AdditionalOwner: {
      fontFamily: 'Poppins !important',
      fontSize: '16px',
      color: 'black',
      width: '351px',
      height: '48px',
      background: '#FFFFFF',
      border: '1px solid #DFDFDF',
      borderRadius: '8px',
      textTransform: 'inherit',
      padding: '12px 73px 12px 73px',
      ' &:hover': {
        backgroundColor: '#FFFFFF !important',
        color: '#6C2AD2',
        border: '1px solid #6C2AD2 !important ',
      },
      [theme.breakpoints.down('md')]: {
        width: 'auto !important',
        height: '48px',
      },
    },
    buttonBox: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    nextBtn: {
      margin: '10px !important',
      backgroundColor: '#965CF0 !important',
      fontFamily: 'Poppins !important',
      color: '#FFFFFF !important',
      fontSize: '16px',
      borderRadius: '8px !important',
      width: '210px',
      height: '48px',
      textTransform: 'none !important',
      padding: '12px 87px 12px 87px',
      border: '1px solid #AF05FF !important',
      ' &:hover': {
        backgroundColor: '#965CF0 !important',
        border: '1px solid #AF05FF !important ',
      },
    },
    cancelBtn: {
      fontSize: '16px',
      fontFamily: 'Poppins !important',
      color: '#000 !important',
      width: '210px',
      height: '48px',
      background: '#FFFFFF !important',
      border: '1px solid #DFDFDF !important',
      borderRadius: '8px',
      textTransform: 'none !important',
      padding: '12px 76px 12px 76px',
      margin: '10px !important',
      ' &:hover': {
        backgroundColor: '#FFFFFF !important',
        color: '#6C2AD2 !important',
        border: '1px solid #6C2AD2 !important ',
      },
    },
    ModalcancelBtn: {
      fontSize: '16px',
      fontFamily: 'Poppins !important',
      color: '#000 !important',
      background: '#FFFFFF !important',
      border: '1px solid #DFDFDF !important',
      borderRadius: '8px',
      textTransform: 'none !important',
      padding: '12px 87px 12px 87px',
      margin: '10px !important',
      ' &:hover': {
        backgroundColor: '#FFFFFF !important',
        color: '#6C2AD2 !important',
        border: '1px solid #6C2AD2 !important ',
      },
    },
    modalLable: {
      fontSize: '16px !important',
      color: '#000 !important',
      fontFamily: 'Poppins !important',
      fontWeight: '500px !important',
    },
    ModalnextBtn: {
      margin: '10px !important',
      backgroundColor: '#965CF0 !important',
      fontFamily: 'Poppins !important',
      color: '#FFFFFF !important',
      fontSize: '14px',
      borderRadius: '8px !important',
      textTransform: 'none !important',
      padding: '12px 87px 12px 87px',
      border: '1px solid #AF05FF !important',
      ' &:hover': {
        backgroundColor: '#965CF0 !important',
        border: '1px solid #AF05FF !important ',
      },
    },
    AdditionalOwner: {
      fontFamily: 'Poppins !important',
      fontSize: '16px',
      color: 'black',
      width: '351px',
      height: '48px',
      margin: '10px !important',
      background: '#FFFFFF',
      border: '1px solid #DFDFDF',
      borderRadius: '8px',
      textTransform: 'inherit',
      padding: '12px 73px 12px 73px',
      ' &:hover': {
        backgroundColor: '#FFFFFF !important',
        color: '#6C2AD2',
        border: '1px solid #6C2AD2 !important ',
      },
      [theme.breakpoints.down('md')]: {
        width: 'auto !important',
        height: '48px',
      },
    },
    menuItem: {
      fontFamily: 'Poppins !important',
      fontSize: '16px',
      fontWeight: '300',
    },
    inputLabel: {
      fontFamily: 'Poppins !important',
      marginTop: matchessm ? '25px' : '35px',
      marginLeft: '20px',
    },
    PropertydropDown: {
      width: 'auto',
      [theme.breakpoints.down('md')]: {
        width: 'auto',
      },
    },
    DurationdropDown: {
      width: '365px !important',
      [theme.breakpoints.down('md')]: {
        width: 'auto',
      },
    },
    MapIconButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      top: '10px',
    },
  }));
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [streetname, setStreetname] = useState('');
  const [landsize, setLandsize] = useState('');
  const [internalsize, setInternalsize] = useState('');
  const [propertyTypeCode, setPropertyTypeCode] = useState('');
  const [propertytypelist, setPropertytypelist] = useState([]);
  const [bedroomcount, setBedroomcount] = useState('');
  const [bathroomcount, setBathroomcount] = useState('');
  const [open, setOpen] = useState(false);
  const [addAddress, setAddAddress] = useState(false);
  const [newVenueAdd, setNewVenueAdd] = useState(false);
  const [feature, setFeature] = useState([]);
  const [landarea, setLandarea] = useState('');
  const [imageUrl, setImageUrl] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [saleprice, setSaleprice] = useState('');
  const [heading, setHeading] = useState('');
  const [description, setDescription] = useState('');
  const [isSelectFocusedBedroom, setSelectFocusedBedroom] = useState(false);
  const [isSelectFocusedParking, setSelectFocusedParking] = useState(false);
  const [minSliderValue, setMinSliderValue] = useState(0);
  const [maxSliderValue, setMaxSliderValue] = useState(10000000);
  const [slidervalue, setSlidervalue] = useState([100000, 1000000]);
  const [isSelectFocusedPropertyType, setSelectFocusedPropertyType] =
    useState(false);
  const [isSelectFocusedBathroom, setSelectFocusedBathroom] = useState(false);
  const [isSelectFocusedCampaign, setSelectFocusedCampaign] = useState(false);
  const [selectedState, setSelectedState] = useState('');
  const [isSelectFocusedDay, setSelectFocusedDay] = useState(false);
  const [featurelist, setFeaturelist] = useState([]);
  const [recurring, setRecurring] = useState(false);
  const [dropImgSrc, setDropImgSrc] = useState(null);
  const [filename, setFileName] = useState([]);
  const [media, setMedia] = useState([]);
  const [dragImgSrc, setDragImgSrc] = useState(null);
  const [dPorLOTSP, setDPorLOTSP] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [auction, setAuction] = useState(false);
  const [campaign, setCampaign] = useState('');
  const [inspections, setInspections] = useState([]);
  const [forSale, setForSale] = useState(false);
  const [inspection, setInspection] = React.useState([{}]);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [upcomingInspection, setUpcomingInspection] = useState([]);
  const [validateInspection, setValidateInspection] = useState(false);
  const [auctiondate, setAuctiondate] = useState('');
  const [auctiontime, setAuctiontime] = useState('');
  const [venue, setVenue] = useState('');
  const [rentalPrice, setRentalPrice] = useState('');
  const [leaseExpiry, setLeaseExpiry] = useState(null);
  const [displaysaleprice, setDisplaysaleprice] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [venueDisable, setVenueDisable] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [venueId, setVenueId] = useState();
  const [inspectionday, setInspectionday] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [inspectiontime, setInspectiontime] = useState('');
  const [inspectionduration, setInspectionduration] = useState('');
  const [inspectionstartdate, setInspectionstartdate] = useState('');
  const [inspectionenddate, setInspectionenddate] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [address3, setAddress3] = useState('');
  const [state, setState] = useState('');
  const [postCode, setPostCode] = useState('');
  const [country, setCountry] = useState('Australia');
  const [town, setTown] = useState('');
  const [yesChecked, setYesChecked] = useState(false);
  const [noChecked, setNoChecked] = useState(false);
  const [buildingSize, setBuildingSize] = useState('');
  const { bannerApiTrigger } = useContext(datacontext);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [selectedWalkScores, setSelectedWalkScores] = useState([]);

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  useEffect(() => {
    const handleDragEnter = () => setIsDragging(true);
    const handleDragLeave = (e) => {
      // Check if we are actually leaving the window
      if (!e.relatedTarget || e.relatedTarget.nodeName === 'HTML') {
        setIsDragging(false);
      }
    };
    const handleDrop = () => setIsDragging(false);

    window.addEventListener('dragenter', handleDragEnter);
    window.addEventListener('dragleave', handleDragLeave);
    window.addEventListener('drop', handleDrop);

    return () => {
      window.removeEventListener('dragenter', handleDragEnter);
      window.removeEventListener('dragleave', handleDragLeave);
      window.removeEventListener('drop', handleDrop);
    };
  }, []);

  const checkDayOccurrence = (start, end, selectedDay) => {
    if (!start || !end || !selectedDay) return false;

    const startDate = dayjs(start);
    const endDate = dayjs(end);

    const weekdayMap = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };

    const requiredDayNumber = weekdayMap[selectedDay];

    let date = startDate.clone();

    while (date.isBefore(endDate) || date.isSame(endDate)) {
      if (date.day() === requiredDayNumber) {
        return true;
      }
      date = date.add(1, 'day');
    }

    return false;
  };

  const validateOccurrence = (startDate, endDate, selectedDay, index) => {
    if (!startDate || !endDate || !selectedDay) return;

    const isPresent = checkDayOccurrence(startDate, endDate, selectedDay);

    if (!isPresent) {
      setErrorMessageEndingDate({
        helperText: `${selectedDay} is not present between ${dayjs(
          startDate
        ).format('DD-MM-YYYY')} and ${dayjs(endDate).format('DD-MM-YYYY')}`,
        error: true,
        index,
      });
    } else {
      setErrorMessageEndingDate({
        helperText: '',
        error: false,
        index,
      });
    }
  };

  const getOccurrenceCount = (start, end, selectedDay) => {
    if (!start || !end || !selectedDay) return 0;

    const weekdayMap = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };

    const requiredDay = weekdayMap[selectedDay];

    let count = 0;
    let date = dayjs(start);

    const endDate = dayjs(end);

    while (date.isBefore(endDate) || date.isSame(endDate)) {
      if (date.day() === requiredDay) {
        count++;
      }
      date = date.add(1, 'day');
    }

    return count;
  };

  const occurrenceCount = inspection.recurring
    ? getOccurrenceCount(
        inspection.startDate,
        inspection.endDate,
        inspection.day
      )
    : 0;

  const [errorMessageBuildingSize, setErrorMessageBuildingSize] = useState({
    error: false,
    helperText: '',
  });
  // const [selectedVenue, setSelectedVenue] = useState('');
  const [isSelectFocusedVenue, setSelectFocusedVenue] = useState(false);
  const [venueName, setVenueName] = useState('');
  const [venueData, setVenueData] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState('');
  const [loadingVenue, setLoadingVenue] = useState(false);
  const [errorMessageVenueName, setErrorMessageVenueName] = useState({
    helperText: '',
    error: false,
  });
  const [errorimageUrl, setErrorimageUrl] = useState({
    error: false,
    helperText: '',
  });
  const [lotNumber, setLotNumber] = useState('');
  const [sp, setSP] = useState('');
  const [errorMessageSP, setErrorMessageSP] = useState({
    error: false,
    helperText: '',
  });
  const [streetNumber, setStreetNumber] = useState('');
  const [unitNumber, setUnitNumber] = useState('');
  const [streetName, setStreetName] = useState('');
  const [errorMessageLot, setErrorMessageLot] = useState({
    error: false,
    helperText: '',
  });
  const [durationList, setDurationList] = useState([
    '15 Mins',
    '30 Mins',
    '45 Mins',
    '60 Mins',
    '75 Mins',
    '90 Mins',
    '105 Mins',
    '120 Mins',
  ]);
  const swalcontinue = useRef(null);
  let tempid =
    fromHeader == 'no' && resumeTempId != 0 && resumeTempId != undefined
      ? resumeTempId
      : localStorage.getItem('tempid');

  let ownerTempId = localStorage.getItem('ownerTempId');

  const [errorMessageDescription, setErrorMessageDescription] = useState({
    helperText: '',
    error: false,
  });
  const [carparking, setCarparking] = useState('');
  const [errorMessagePropertyType, setErrorMessagePropertyType] = useState({
    helperText: '',
    error: false,
  });
  const [errorforaddress, setErrorforaddress] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageDaySelect, setErrorMessageDaySelect] = useState({
    helperText: '',
    error: false,
    index: '',
  });
  const [errorMessageTime, setErrorMessageTime] = useState({
    helperText: '',
    error: false,
    index: '',
  });
  const [errorMessageBedroom, setErrorMessageBedroom] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageCar, setErrorMessageCar] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageBathroom, setErrorMessageBathroom] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageHeading, setErrorMessageHeading] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageSalePrice, setErrorMessageSalePrice] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageLandArea, setErrorMessageLandArea] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageLandSize, setErrorMessageLandSize] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageInternalSize, setErrorMessageInternalSize] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessagewaterrate, setErrorMessagewaterrate] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessagecouncilrate, setErrorMessagecouncilrate] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessagecampaigntype, setErrorMessagecampaigntype] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageauctiondate, setErrorMessageauctiondate] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageAuctionTime, setErrorMessageAuctionTime] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageVenue, setErrorMessageVenue] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageDPorLOTSP, setErrorMessageDPorLOTSP] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageRentalPrice, setErrorMessageRentalPrice] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageVideoUrl, setErrorMessageVideoUrl] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageDisplayPrice, setErrorMessageDisplayPrice] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageEndingDate, setErrorMessageEndingDate] = useState({
    helperText: '',
    error: false,
    index: '',
  });
  const [errorOtherDocument, setErrorOtherDocument] = useState({
    helperText: '',
    error: false,
    index: '',
  });
  const errorOtherDocumentRef = useRef(null);
  const [minEndDate, setMinEndDate] = useState('');
  let [maxValue, setMaxValue] = useState(6000000);
  let [minValue, setMinValue] = useState(0);
  const [errorMessageStartDate, setErrorMessageStartDate] = useState({
    helperText: '',
    error: false,
    index: '',
  });
  const [errorMessageDuration, setErrorMessageDuration] = useState({
    helperText: '',
    error: false,
    index: '',
  });
  const [selectedStreetType, setSelectedStreetType] = useState('');
  const [selectedStreetTypeabbrev, setSelectedStreetTypeabbrev] = useState('');
  const [selectedStreetTypeformat, setSelectedStreetTypeformat] = useState({
    label: '',
    type: 'option',
  });
  const [streetTypeError, setStreetTypeError] = useState(false);
  const [inspectionValidation, setInspectionValidation] = useState(false);
  const [docValidate, setDocValidate] = useState('');
  const [leaseVal, setLeaseVal] = useState('');
  const [typeState, setTypeState] = useState(true);
  const [isStreetTypeFocused, setStreetTypeFocused] = useState(false);
  const streetTypeErrorMessage = 'Please select a street type';
  const [copyToDisplayPrice, setCopyToDisplayPrice] = useState('');
  const [dp, setDP] = useState('');
  const [strataLevies, setStrataLevies] = useState('');
  const [councilRate, setCouncilRate] = useState('');
  const [waterRates, setWaterRates] = useState('');
  const [publishlease, setPublishlease] = useState(false);
  const [publishrent, setPublishrent] = useState(false);
  const [errorMessageDP, setErrorMessageDP] = useState({
    error: false,
    helperText: '',
  });
  const [errorMessageCopyToDisplayPrice, setErrorMessageCopyToDisplayPrice] =
    useState({
      error: false,
      helperText: '',
    });

  const propertytyperef = useRef(null);
  const addressref = useRef(null);
  const bedroomref = useRef(null);
  const bathroomref = useRef(null);
  const parkingref = useRef(null);
  const imagesref = useRef(null);
  const landsizeref = useRef(null);
  const buildingsizeref = useRef(null);
  const internalsizeref = useRef(null);
  const councilrateref = useRef(null);
  const waterrateref = useRef(null);
  const campaignttyperef = useRef(null);
  const auctiondateref = useRef(null);
  const auctiontimeref = useRef(null);
  const venueref = useRef(null);
  const salepriceref = useRef(null);
  const titleref = useRef(null);
  const descriptionref = useRef(null);
  const inspectionRef = useRef(null);
  const otherDocumentRef = useRef(null);
  const divRef = useRef();
  const secimagesref = useRef(null);
  const propertyVideoSectionRef = useRef(null);
  const tour360VideoSectionRef = useRef(null);

  const formattedstrataLevies = (strataLevies || '')
    ?.toString()
    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedcouncilRate = (councilRate || '')
    ?.toString()
    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedwaterRates = (waterRates || '')
    ?.toString()
    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedDisplaysaleprice = (displaysaleprice || '')
    ?.toString()
    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedSaleprice = (saleprice || '')
    ?.toString()
    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedRentalPrice = (rentalPrice || '')
    ?.toString()
    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const handlestrataLevies = (event) => {
    let newValue = event.target.value;
    if (typeof newValue === 'string') {
      newValue = newValue.replace(/\D/g, '');
      newValue = newValue.slice(0, 6);
      setStrataLevies(newValue);
    }
  };

  const handlecouncilRate = (event) => {
    let value = event.target.value;

    if (typeof value === 'string') {
      value = value.replace(/\D/g, '');

      value = value.slice(0, 6);

      // If current value is already '0', ignore additional zeros
      if (councilRate === '0' && value === '00') {
        return;
      }

      if (value === '') {
        setCouncilRate('');
      } else if (value === '0') {
        setCouncilRate('0');
      } else {
        // Remove leading zeros for numbers > 0
        value = value.replace(/^0+/, '');
        setCouncilRate(value);
      }
    }

    setErrorMessagecouncilrate({
      helperText: '',
      error: false,
    });
  };

  const handlewaterRates = (event) => {
    let value = event.target.value;

    if (typeof value === 'string') {
      value = value.replace(/\D/g, '');

      value = value.slice(0, 6);

      // If current value is already '0', ignore additional zeros
      if (waterRates === '0' && value === '00') {
        return;
      }

      if (value === '') {
        setWaterRates('');
      } else if (value === '0') {
        setWaterRates('0');
      } else {
        // Remove leading zeros for numbers > 0
        value = value.replace(/^0+/, '');
        setWaterRates(value);
      }
    }
    setErrorMessagewaterrate({
      helperText: '',
      error: false,
    });
  };

  const handleKey = (event) => {
    // Prevent 'e' character from being entered
    if (event.key === 'e') {
      event.preventDefault();
    }
  };

  const [documentFiles, setDocumentFiles] = useState([]);
  const handleCopyToDisplayPriceChange = () => {
    setCopyToDisplayPrice(true);
    setDisplaysaleprice(saleprice); // Copy sale price to display sale price when checkbox is checked
  };

  const handleVenueNameChange = (event) => {
    const newValue = event.target.value;
    setVenueName(newValue);
    setErrorMessageVenueName(false);
  };
  const handleChangeLotNumber = (event) => {
    const inputValue = event.target.value;
    // const alphabetOnly = inputValue.replace(/[^a-zA-Z\s]/g, '');
    const newValue = inputValue.slice(0, 5);
    setLotNumber(newValue);
  };
  const handleChangeSP = (event) => {
    let inputValue = event.target.value;

    if (!inputValue.startsWith('SP')) {
      inputValue = 'SP' + inputValue.replace(/[^0-9]/g, '');
    } else {
      inputValue = 'SP' + inputValue.slice(2).replace(/[^0-9]/g, '');
    }
    setSP(inputValue);
  };

  // const handleChangeDP = (event) => {
  //   const inputValue =(event.target.value).trimStart();
  //   // const alphabetOnly = inputValue.replace(/[^a-zA-Z\s]/g, '');
  //   setDP(inputValue);
  // };
  const handleChangeDP = (event) => {
    let value = event.target.value.trimStart();

    // Allow only digits
    value = value.replace(/[^0-9]/g, '');

    // If current value is already '0', ignore additional zeros
    if (dp === '0' && value === '00') {
      return;
    }

    if (value === '') {
      setDP('');
    } else if (value === '0') {
      // Single zero allowed
      setDP('0');
    } else {
      // Remove leading zeros for numbers > 0
      value = value.replace(/^0+/, '');
      // value = Number(value).toLocaleString('en-US');
      setDP(value);
    }
  };

  const handleChangeVenue = (event) => {
    setSelectedVenue(event.target.value);
    setErrorMessageVenue({
      helperText: '',
      error: false,
    });
  };
  function checkDifference(num1, num2) {
    const twentyPercent = Math.min(num1, num2) * 0.2;

    // Calculate the difference between the numbers
    const difference = Math.abs(num1 - num2);

    // If the difference is less than or equal to 20% of the smaller number, return true
    return difference <= twentyPercent;
  }

  const calculateMaxSliderValue = (price) => {
    if (price >= 1 && price <= 9) {
      return 10;
    } else if (price >= 10 && price <= 99) {
      return 100;
    } else if (price >= 100 && price <= 999) {
      return 1000;
    } else if (price >= 1000 && price <= 9999) {
      return 10000;
    } else if (price >= 10000 && price <= 99999) {
      return 100000;
    } else if (price >= 100000 && price <= 999999) {
      return 1000000;
    } else if (price >= 1000000 && price <= 9999999) {
      return 10000000;
    } else if (price >= 10000000 && price <= 99999999) {
      return 100000000;
    } else if (price >= 100000000 && price <= 999999999) {
      return 1000000000;
    } else {
      return 1000000000;
    }
  };

  // const [maxForSaleSliderValue, setForSaleMaxSliderValue] = useState(10000000);
  // const [sliderForSalevalue, setSliderForSalevalue] = useState([2000000, 2000000]);
  // const [maxForSaleSliderValue, setForSaleMaxSliderValue] = useState(
  //   calculateMaxSliderValue(parseInt(agencyTrueEstimatePrice))
  // );
  // const [sliderForSalevalue, setSliderForSalevalue] = useState([
  //   parseInt(agencyTrueEstimatePrice),
  //   parseInt(agencyTrueEstimatePrice),
  // ]);
  const [maxForSaleSliderValue, setForSaleMaxSliderValue] = useState(() => {
    if (legalSliderRange?.length === 2) {
      return calculateMaxSliderValue(legalSliderRange[1]);
    }
    return 0;
  });

  const [sliderForSalevalue, setSliderForSalevalue] =
    useState(legalSliderRange);

  useEffect(() => {
    setSliderForSalevalue(legalSliderRange);
  }, [legalSliderRange]);

  const calculateMaxSliderValueBasedOnDigits = (inputValue) => {
    const length = inputValue.length;

    switch (length) {
      case 1:
        return 10 + 10 * 0.1;
      case 2:
        return 100 + 100 * 0.1;
      case 3:
        return 1000 + 1000 * 0.1;
      case 4:
        return 10000 + 10000 * 0.1;
      case 5:
        return 100000 + 100000 * 0.1;
      case 6:
        return 1000000 + 1000000 * 0.1;
      case 7:
        return 10000000 + 10000000 * 0.1;
      default:
        return 10000000 + 10000000 * 0.1;
    }
  };

  const handleSliderNewChange = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (activeThumb == 0) {
      if (newValue[1] < 10000000) {
        setForSaleMaxSliderValue(10000000);
      }
      if (sliderForSalevalue[0] > newValue[0]) {
        let tenPercent = newValue[0] + newValue[0] * 0.1;
        setSliderForSalevalue([newValue[0], tenPercent]);
      } else if (sliderForSalevalue[0] < newValue[0]) {
        setSliderForSalevalue([newValue[0], sliderForSalevalue[1]]);
      }
    } else if (activeThumb == 1) {
      if (maxForSaleSliderValue == newValue[1]) {
        setForSaleMaxSliderValue(maxForSaleSliderValue + 10000000);
      }
      if (sliderForSalevalue[1] > newValue[1]) {
        setSliderForSalevalue([sliderForSalevalue[0], newValue[1]]);
      } else if (sliderForSalevalue[1] < newValue[1]) {
        let tenPercent = newValue[1] - newValue[1] * 0.1;
        setSliderForSalevalue([tenPercent, newValue[1]]);
      }
    }
  };

  function ensureForSaleMinimumLength(minLength, value) {
    let leadingZeros = '1';

    if (String(minLength) == '7') {
      if (parseInt(value) > 900000 && parseInt(value) < 3000000) {
        leadingZeros = '3000000';
      } else {
        leadingZeros = '6000000';
      }

      setForSaleMaxSliderValue(leadingZeros);

      return leadingZeros;
    } else {
      for (let i = 0; i < Number(minLength); i++) {
        leadingZeros = String(leadingZeros) + '0';
      }
      if (parseInt(value) > 6000000) {
        setForSaleMaxSliderValue(String(value) + '0');
      } else {
        setForSaleMaxSliderValue(leadingZeros);
      }

      return leadingZeros;
    }

    // Check if the length of the string is less than the minimum length
  }

  const handleForSaleChangeforslider = (event, newValue, activeThumb) => {
    ensureForSaleMinimumLength(newValue[1].toString().length, newValue[1]);
    if (checkDifference(newValue[0], newValue[1])) {
      return;
    }
    // Adjust the increment based on the slider value
    if (slidervalue[0] == newValue[0] && slidervalue[1] != newValue[1]) {
      const increment = newValue[1] <= 2000000 ? 10000 : 50000;
      const roundedValue =
        newValue[1] <= 2000000
          ? Math.round(newValue[1] / increment) * increment
          : Math.min(6000000, newValue[1]);
      setSliderForSalevalue([newValue[0], roundedValue]);
      // setSaleprice(newValue[0])
    } else {
      const increment = newValue[0] <= 2000000 ? 10000 : 50000;
      const roundedValue =
        newValue[0] <= 2000000
          ? Math.round(newValue[0] / increment) * increment
          : Math.min(6000000, newValue[0]);
      setSliderForSalevalue([roundedValue, newValue[1]]);
      // setSaleprice(newValue[0])
    }
  };

  function ensureMinimumLength(minLength, value) {
    let newMaxSliderValue = 0;

    if (minLength === 7) {
      newMaxSliderValue = maxSliderValue + 100000;
    } else {
      newMaxSliderValue = Math.max(parseInt(value) + 1000000, 6000000);
    }

    setMaxSliderValue(newMaxSliderValue);

    return newMaxSliderValue;
  }

  const handleChangeforslider = (event, newValue, activeThumb) => {
    const minLength = newValue[1].toString().length;
    const newMaxSliderValue = ensureMinimumLength(minLength, newValue[1]);

    if (checkDifference(newValue[0], newValue[1])) {
      return;
    }

    let newMax = newValue[1];

    if (newMax === maxSliderValue) {
      newMax += 1000000;
      const sliderBackAmount = 50000;
      const newMin = Math.max(newValue[0] - sliderBackAmount, 0);

      animateSliderBack(newMin, newMax);
    } else {
      const newMin =
        newValue[0] <= 2000000 ? newValue[0] : Math.min(6000000, newValue[0]);

      newMax = Math.min(newMaxSliderValue + 1000000, newMax);

      setSlidervalue([newMin, newMax]);
    }
  };

  const animateSliderBack = (newMin, newMax) => {
    const slider = document.querySelector('.slider');
    if (slider) {
      slider.classList.add('animate-back');
      setTimeout(() => {
        slider.classList.remove('animate-back');
        setSlidervalue([newMin, newMax]);
      }, 300);
    } else {
      console.error('SLIDDERRR');
    }
  };

  const valueLabelFormat = (value) => {
    return formatNumber(value);
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return '$' + parseFloat((num / 1000000).toFixed(1)) + 'M';
    }
    if (num >= 1000) {
      return '$' + parseFloat((num / 1000).toFixed(1)) + 'K';
    }
    return '$' + num.toString();
  };

  const [imageUrlSecondary, setImageUrlSecondary] = useState([]);
  const [errorimageUrlSecondary, setErrorimageUrlSecondary] = useState({
    helperText: '',
    error: false,
    duplicateNames: null,
  });

  // Callback for handling secondary dropzone
  const onDropSecondary = useCallback(
    (newFiles) => {
      // Allow only JPEG and PNG, and explicitly block .jfif
      const allowedMimeTypes = ['image/jpeg', 'image/png'];
      const disallowedExtensions = ['.jfif'];

      const allowedFiles = newFiles.filter((file) => {
        const isMimeAllowed = allowedMimeTypes.includes(file.type);
        const isJfif = disallowedExtensions.some((ext) =>
          file.name.toLowerCase().endsWith(ext)
        );
        return isMimeAllowed && !isJfif;
      });

      const rejectedFiles = newFiles.filter(
        (file) => !allowedFiles.includes(file)
      );

      if (rejectedFiles.length > 0) {
        setErrorimageUrlSecondary({
          helperText: 'Only .jpg, .jpeg, and .png formats are supported.',
          error: true,
          duplicateNames: null,
          timestamp: Date.now(), // 👈 force re-render even if same error text
        });
        return;
      }

      const updatedImageUrl = [...imageUrlSecondary];

      const duplicateFileNames = allowedFiles.filter((file) =>
        updatedImageUrl.some((existingFile) => existingFile.name === file.name)
      );

      if (duplicateFileNames.length > 0) {
        const duplicateFileNamesSet = new Set(
          duplicateFileNames.map((file) => file.name)
        );
        setErrorimageUrlSecondary({
          helperText: 'You cannot upload images with the same names',
          error: true,
          duplicateNames: duplicateFileNamesSet,
          timestamp: Date.now(), // 👈 also force update here
        });
        return;
      }

      // ✅ Add new valid files
      setImageUrlSecondary((prevFiles) => [...prevFiles, ...allowedFiles]);
      setErrorimageUrlSecondary({
        helperText: '',
        error: false,
        duplicateNames: null,
        timestamp: Date.now(),
      });

      if (inputRefSecondary.current) {
        inputRefSecondary.current.value = ''; // Clear the input
      }
    },
    [imageUrlSecondary]
  );

  // Duplicate of removeImgHandler
  const removeImgHandlerSecondary = (imageToRemove) => {
    setImageUrlSecondary((prevFiles) =>
      prevFiles.filter((file) => file.name !== imageToRemove.name)
    );

    // Reset error state after deletion
    setErrorimageUrlSecondary({
      helperText: '',
      error: false,
      duplicateNames: null,
    });
  };
  const {
    getRootProps: getRootPropsSecondary,
    getInputProps: getInputPropsSecondary,
    isDragAccept: isDragAcceptSecondary,
    isDragReject: isDragRejectSecondary,
  } = useDropzone({
    onDrop: onDropSecondary,
    accept: {
      'image/jpeg': [],
      'image/png': [],
    },
    multiple: true,
  });
  const inputRefSecondary = useRef(null);
  const handleButtonClicks = () => {
    // Trigger the file input click when the button is clicked
    if (inputRefSecondary.current) {
      inputRefSecondary.current.click();
    }
  };

  const inputRefBanner = useRef(null);

  const handleButtonClickss = () => {
    // Trigger the file input click when the button is clicked
    if (inputRefBanner.current) {
      inputRefBanner.current.click();
    }
  };

  // ---------------- Property Video & 360° Tour Video ----------------
  const [propertyVideo, setPropertyVideo] = useState(null);
  const [tour360Video, setTour360Video] = useState(null);
  const [propertyVideoUrl, setPropertyVideoUrl] = useState('');
  const [tour360VideoUrl, setTour360VideoUrl] = useState('');

  useEffect(() => {
    let url = '';
    if (propertyVideo) {
      if (propertyVideo instanceof File) {
        url = URL.createObjectURL(propertyVideo);
      } else {
        url = encodeURI(propertyVideo);
      }
    }
    setPropertyVideoUrl(url);
    return () => {
      if (url && url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    };
  }, [propertyVideo]);

  useEffect(() => {
    let url = '';
    if (tour360Video) {
      if (tour360Video instanceof File) {
        url = URL.createObjectURL(tour360Video);
      } else {
        url = encodeURI(tour360Video);
      }
    }
    setTour360VideoUrl(url);
    return () => {
      if (url && url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    };
  }, [tour360Video]);

  const [errorPropertyVideo, setErrorPropertyVideo] = useState({
    helperText: '',
    error: false,
  });
  const [errorTour360Video, setErrorTour360Video] = useState({
    helperText: '',
    error: false,
  });

  const propertyVideoRef = useRef(null);
  const tour360VideoRef = useRef(null);

  const MAX_VIDEO_SIZE_MB = 200;

  const validateVideoFile = (file) => {
    const allowedMimeTypes = [
      'video/mp4',
      'video/webm',
      'video/ogg',
      'video/quicktime',
      'video/x-msvideo',
      'video/x-matroska',
    ];
    const allowedExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv'];
    const isMimeAllowed =
      allowedMimeTypes.includes(file.type) || file.type.startsWith('video/');
    const isExtAllowed = allowedExtensions.some((ext) =>
      file.name.toLowerCase().endsWith(ext)
    );
    if (!isMimeAllowed && !isExtAllowed) {
      return 'Only video files (.mp4, .webm, .ogg, .mov, .avi, .mkv) are supported.';
    }
    if (file.size > MAX_VIDEO_SIZE_MB * 1024 * 1024) {
      return `Maximum video upload limit is ${MAX_VIDEO_SIZE_MB}MB.`;
    }
    return null;
  };

  const onDropPropertyVideo = useCallback((newFiles, fileRejections) => {
    if (fileRejections && fileRejections.length > 0) {
      setErrorPropertyVideo({
        helperText:
          'Only video files (.mp4, .webm, .ogg, .mov, .avi, .mkv) are supported.',
        error: true,
        timestamp: Date.now(),
      });
      return;
    }
    if (!newFiles || newFiles.length === 0) return;
    const file = newFiles[0];
    const errMsg = validateVideoFile(file);
    if (errMsg) {
      setErrorPropertyVideo({
        helperText: errMsg,
        error: true,
        timestamp: Date.now(),
      });
      return;
    }
    setPropertyVideo(file);
    setErrorPropertyVideo({
      helperText: '',
      error: false,
      timestamp: Date.now(),
    });
    if (propertyVideoRef.current) {
      propertyVideoRef.current.value = '';
    }
  }, []);

  const onDropTour360Video = useCallback((newFiles, fileRejections) => {
    if (fileRejections && fileRejections.length > 0) {
      setErrorTour360Video({
        helperText:
          'Only video files (.mp4, .webm, .ogg, .mov, .avi, .mkv) are supported.',
        error: true,
        timestamp: Date.now(),
      });
      return;
    }
    if (!newFiles || newFiles.length === 0) return;
    const file = newFiles[0];
    const errMsg = validateVideoFile(file);
    if (errMsg) {
      setErrorTour360Video({
        helperText: errMsg,
        error: true,
        timestamp: Date.now(),
      });
      return;
    }
    setTour360Video(file);
    setErrorTour360Video({
      helperText: '',
      error: false,
      timestamp: Date.now(),
    });
    if (tour360VideoRef.current) {
      tour360VideoRef.current.value = '';
    }
  }, []);

  const {
    getRootProps: getRootPropsPropertyVideo,
    getInputProps: getInputPropsPropertyVideo,
    isDragAccept: isDragAcceptPropertyVideo,
    isDragReject: isDragRejectPropertyVideo,
  } = useDropzone({
    onDrop: onDropPropertyVideo,
    accept: {
      'video/mp4': ['.mp4'],
      'video/webm': ['.webm'],
      'video/ogg': ['.ogg'],
      'video/quicktime': ['.mov'],
      'video/x-msvideo': ['.avi'],
      'video/x-matroska': ['.mkv'],
    },
    multiple: false,
  });

  const {
    getRootProps: getRootPropsTour360Video,
    getInputProps: getInputPropsTour360Video,
    isDragAccept: isDragAcceptTour360Video,
    isDragReject: isDragRejectTour360Video,
  } = useDropzone({
    onDrop: onDropTour360Video,
    accept: {
      'video/mp4': ['.mp4'],
      'video/webm': ['.webm'],
      'video/ogg': ['.ogg'],
      'video/quicktime': ['.mov'],
      'video/x-msvideo': ['.avi'],
      'video/x-matroska': ['.mkv'],
    },
    multiple: false,
  });

  const removePropertyVideo = () => {
    setPropertyVideo(null);
    setErrorPropertyVideo({ helperText: '', error: false });
    if (propertyVideoRef.current) {
      propertyVideoRef.current.value = '';
    }
  };

  const removeTour360Video = () => {
    setTour360Video(null);
    setErrorTour360Video({ helperText: '', error: false });
    if (tour360VideoRef.current) {
      tour360VideoRef.current.value = '';
    }
  };
  // ------------------------------------------------------------------

  const handleChange5 = (event) => {
    setCarparking(event.target.value);
    setErrorMessageCar({
      helperText: '',
      error: false,
    });
  };
  const handleChange_campaign = (event) => {
    setCampaign(event.target.value);
    setErrorMessagecampaigntype({
      helperText: '',
      error: false,
    });
  };

  const onDrop = useCallback(
    (newFiles) => {
      // ✅ Allow only JPEG and PNG, explicitly block .jfif
      const allowedMimeTypes = ['image/jpeg', 'image/png'];
      const disallowedExtensions = ['.jfif'];

      const allowedFiles = newFiles.filter((file) => {
        const isMimeAllowed = allowedMimeTypes.includes(file.type);
        const isJfif = disallowedExtensions.some((ext) =>
          file.name.toLowerCase().endsWith(ext)
        );
        return isMimeAllowed && !isJfif;
      });

      const rejectedFiles = newFiles.filter(
        (file) => !allowedFiles.includes(file)
      );

      if (rejectedFiles.length > 0) {
        setErrorimageUrl({
          helperText: 'Only .jpg, .jpeg, and .png formats are supported.',
          error: true,
          duplicateNames: null,
          timestamp: Date.now(), // 👈 force re-render for same error text
        });
        return;
      }

      const updatedImageUrl = [...imageUrl];

      const duplicateFileNames = allowedFiles.filter((file) =>
        updatedImageUrl.some((existingFile) => existingFile.name === file.name)
      );

      if (duplicateFileNames.length > 0) {
        const duplicateFileNamesSet = new Set(
          duplicateFileNames.map((file) => file.name)
        );
        setErrorimageUrl({
          helperText: 'You cannot upload images with the same names',
          error: true,
          duplicateNames: duplicateFileNamesSet, // Store the duplicate names
          timestamp: Date.now(), // 👈 also force update here
        });
        return;
      }

      // Add new files if there are no duplicates
      setImageUrl((prevFiles) => [...prevFiles, ...allowedFiles]);
      setErrorimageUrl({
        helperText: '',
        error: false,
        duplicateNames: null,
        timestamp: Date.now(),
      });

      if (inputRefBanner.current) {
        inputRefBanner.current.value = ''; // Clear the input
      }
    },
    [imageUrl]
  );

  const { getRootProps, getInputProps, isDragAccept, isDragReject } =
    useDropzone({
      onDrop,
      accept: {
        'image/jpeg': [],
        'image/png': [],
      },
      multiple: true,
    });

  const [documentTypeListArr, setDocumentTypeListArr] = useState([]);
  const [selectedDocumentType, setSelectedDocumentType] = useState('');
  const [selectedDocumentCode, setSelectedDocumentCode] = useState('');

  useEffect(() => {
    docuploadlist();
  }, []);
  const docuploadlist = () => {
    if (
      fromHeader == 'property' ||
      fromHeader == 'owner' ||
      fromHeader == 'appraisal'
    ) {
      if (fromHeader == 'property') {
        pipelineDocumentTypeList(0, 0).then((res) =>
          setDocumentTypeListArr(res?.documentType)
        );
      } else {
        const tempId = selectedProperty?.tempId || ownerTempId;
        const propertyId = selectedProperty?.propertyId || 0;
        pipelineDocumentTypeList(tempId, propertyId).then((res) =>
          setDocumentTypeListArr(res?.documentType)
        );
      }
    } else {
      documentTypeList(tempid).then((res) =>
        setDocumentTypeListArr(res?.documentType)
      );
    }
  };

  useEffect(() => {
    setMedia([]);
    // eslint-disable-next-line no-use-before-define
  }, [selectedDocumentType]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let flag = media?.length;
  let allowed =
    selectedDocumentType === 'Strata Minutes' ||
    selectedDocumentType === 'Other'
      ? 3
      : 1;
  const validate = (newFiles) => {
    if (newFiles?.length + media?.length <= allowed) {
      setMedia((prevFiles) => [...prevFiles, ...newFiles]);
    } else {
      setDocValidate('Allow only ' + `${allowed}` + ' Document!');
    }
    // if (flag >= allowed) {
    //   alert("restricted");
    //   return;
    // }
  };
  const [rejectedFiles, setRejectedFiles] = useState();
  const [pdfErrorOpen, setPdfErrorOpen] = useState(false);
  const [pdfErrorFile, setPdfErrorFile] = useState('');
  const MAX_FILE_SIZE = 20 * 1024 * 1024;

  const onDropMedia = useCallback(
    (newFiles) => {
      const validFiles = [];
      const invalidFiles = [];

      // Check each file's size
      newFiles.forEach((file) => {
        if (file.size <= MAX_FILE_SIZE) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file);
          setPdfErrorFile(file.name);
        }
      });

      // Update state
      validate(validFiles);
      setRejectedFiles(invalidFiles);

      // Alert for rejected files
      if (invalidFiles.length > 0) {
        setPdfErrorOpen(true);
      }
    },
    [validate]
  );

  const [otherDocLoading, setOtherDocLoading] = useState(false);
  const [getDocList, setGetDocList] = useState([]);
  const [getDocListlimit, setGetDocListlimit] = useState(false);
  const [filesName, setFilesName] = useState([]);
  function mergeDocuments(data) {
    const mergedDocuments = {};

    data?.docDetails?.forEach((doc) => {
      if (!mergedDocuments[doc?.documentType]) {
        mergedDocuments[doc?.documentType] = [];
      }
      mergedDocuments[doc?.documentType].push({
        docTempId: doc?.docTempId,
        document: doc?.document,
        tempId: doc?.tempId,
      });
    });

    const mergedArray = [];
    for (const [docType, documentList] of Object.entries(mergedDocuments)) {
      mergedArray.push({
        docName: docType,
        documentList: documentList,
      });
    }
    setGetDocList(mergedArray);

    return mergedArray;
  }

  const getOtherDocs = (tempId) => {
    const uploadAPI =
      fromHeader === 'owner' ||
      fromHeader === 'property' ||
      fromHeader === 'appraisal'
        ? getPipelienOtherDocuments
        : getOtherDocuments;

    const params = {
      tempId:
        fromHeader === 'owner' ||
        fromHeader === 'property' ||
        fromHeader === 'appraisal'
          ? ownerTempId
          : tempId,
      propertyId: selectedProperty ? selectedProperty.propertyId : 0,
    };
    uploadAPI(params).then((res) => {
      setGetDocList(res?.docDetails);
      const apiData = res?.docDetails?.map((item) => item?.document);
      setFilesName(
        apiData?.map((url) => {
          return url.substring(url.lastIndexOf('/') + 1);
        })
      );
      // mergeDocuments(res);
    });
  };

  const [docType, setDoctype] = useState('');

  useEffect(() => {
    if (docType != '') {
      setTimeout(() => {
        setDoctype('');
      }, 3000);
    }
  }, [docType]);

  const uploadDocument = () => {
    if (getDocList?.length == 10) {
      setGetDocListlimit(true);
      return;
    }
    if (getDocListlimit) {
      setGetDocListlimit(false);
    }
    if (selectedDocumentType == '') {
      setDoctype('Select document type to Upload !');
    } else if (selectedDocumentType != '' && media?.length > 0) {
      setOtherDocLoading(true);
      const formData = new FormData();
      if (
        fromHeader == 'property' ||
        fromHeader == 'owner' ||
        fromHeader == 'appraisal'
      ) {
        formData.append('propertyId', 0);
        if (fromHeader == 'property') {
          formData.append('tempId', 0);
        } else {
          const tempId = selectedProperty?.tempId || ownerTempId;
          const propertyId = selectedProperty?.propertyId || 0;
          formData.append('tempId', tempId);
          formData.append('propertyId', propertyId);
        }
      } else {
        formData.append('tempId', tempid);
        formData.append(
          'pipelinetempId',
          prefillData?.property?.propertyId ||
            prefillData?.propertyId ||
            pipelineTempId ||
            localStorage.getItem('pipelinePropertyId') ||
            ''
        );
      }
      formData.append('typeCode', selectedDocumentCode);
      for (let i = 0; i < media?.length; i++) {
        formData.append(`otherDocuments[]`, media[i]);
      }
      const uploadAPI =
        fromHeader === 'owner' ||
        fromHeader === 'property' ||
        fromHeader === 'appraisal'
          ? addPipelineOtherDocuments
          : addOtherDocuments;

      uploadAPI(formData)
        .then((res) => {
          if (res?.status == 1) {
            setErrorOtherDocument({
              helperText: '',
              error: false,
            });
            setOtherDocLoading(false);
            setMedia([]);
            setSelectedDocumentType('');
            if (
              fromHeader == 'property' ||
              fromHeader == 'owner' ||
              fromHeader == 'appraisal'
            ) {
              if (fromHeader == 'property') {
                getOtherDocs(0);
              } else {
                getOtherDocs(selectedProperty?.tempId || ownerTempId);
              }
            } else {
              getOtherDocs(tempid);
            }
            setTypeState(false);
            docuploadlist();
          } else {
            setOtherDocLoading(false);
          }
        })
        .catch((err) => setOtherDocLoading(false));
    }
  };
  const DeleteDoc = async (docId) => {
    const docType =
      fromHeader == 'owner' ||
      fromHeader == 'property' ||
      fromHeader == 'appraisal'
        ? DELETE_PIPELINE_OTHERDOC
        : DELETE_OTHERDOC;

    try {
      const res = await deleteApiCall(`${docType}${docId}`);

      const resData = res?.data || res;

      if (resData?.status == '1') {
        if (
          fromHeader == 'property' ||
          fromHeader == 'owner' ||
          fromHeader == 'appraisal'
        ) {
          if (fromHeader == 'property') {
            getOtherDocs(0);
          } else {
            getOtherDocs(selectedProperty?.tempId || ownerTempId);
          }
        } else {
          getOtherDocs(tempid);
        }

        setOtherDocLoading(false);
        setMedia([]);
        setSelectedDocumentType('');
        setTypeState(false);
        docuploadlist();
      } else {
        setOtherDocLoading(false);
      }
    } catch (error) {
      setOtherDocLoading(false);
    }
  };

  const DeleteIns = async (insId) => {
    setLoading(false);

    try {
      const res = await deleteApiCall(`${DELETE_INSPECTION}${insId}`);

      const resData = res?.data || res;

      if (resData?.status == '1') {
        const response = await getUpcomingInspection(tempid);

        let data = response?.scheduledInspection;

        const orderedData = [...data].sort((a, b) => {
          const dateA = new Date(`${a.date} ${a.year}`);
          const dateB = new Date(`${b.date} ${b.year}`);
          return dateA - dateB;
        });

        setUpcomingInspection(orderedData);
      } else {
        console.error('DeleteIns failed:', resData);
      }
    } catch (error) {
      console.error('DeleteIns Error:', error);
    }
  };
  const {
    getRootProps: getDocumentsFileProps,
    getInputProps: getDocumentsFileInputProps,
    isDragAccept: isDragAcceptDoc,
    isDragReject: isDragRejectDoc,
  } = useDropzone({
    onDrop: (files) => {
      setIsDragging(false); // reset
      onDropMedia(files);
    },
    onDragEnter: () => setIsDragging(true),
    onDragLeave: () => setIsDragging(false),
    accept: { 'application/pdf': [] },
    multiple:
      selectedDocumentType === 'Strata Minutes' ||
      selectedDocumentType === 'Other'
        ? true
        : false,
    preventDropOnDocument: true,
  });

  const handleYesCheckboxChange = () => {
    setYesChecked(!yesChecked);
    if (noChecked) {
      setNoChecked(false);
    }
  };

  const handleNoCheckboxChange = () => {
    setNoChecked(!noChecked);
    if (yesChecked) {
      setYesChecked(false);
    }
  };

  const handleCheckboxChange = (event, item) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setFeature((prev) => [...prev, item.fea_code]);
    } else {
      setFeature((prev) => prev.filter((code) => code !== item.fea_code));
    }
  };
  async function fetchLocationName(lat, lon) {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
      );

      if (response.data?.address) {
        return response.data?.address;
      }
    } catch (error) {
      console.error('Error fetching location name:', error);
    }

    return 'Location name not found';
  }
  const handleClickInspection = () => {
    let validate = inspection[inspection.length - 1];
    if (
      validate.duration != 1 &&
      validate.startDate != null &&
      validate.time != null
    ) {
      // initial state for add more inspection
      setInspection((prevInspection) => [
        ...prevInspection,
        { isRecurring: 0, duration: '' },
      ]);
    }
  };

  const [selectDate, setSelectDate] = useState('');
  const [greaterDate, setGreaterDate] = useState('');
  const [occurenceDay, setOccurenceDay] = useState('');
  const [addInspection, setAddInspection] = useState('');

  useEffect(() => {
    if (selectDate != '') {
      // setTimeout(() => {
      //   setSelectDate('');
      // }, 4000);
    }
  }, [selectDate]);
  useEffect(() => {
    if (greaterDate != '') {
      // setTimeout(() => {
      //   setGreaterDate('');
      // }, 4000);
    }
  }, [greaterDate]);
  useEffect(() => {
    if (occurenceDay != '') {
      // setTimeout(() => {
      //   setOccurenceDay('');
      // }, 4000);
    }
  }, [occurenceDay]);
  useEffect(() => {
    if (addInspection != '') {
      // setTimeout(() => {
      //   setAddInspection('');
      // }, 4000);
    }
  }, [addInspection]);

  useEffect(() => {
    if (resumeTempId) {
      getUpcomingInspection(tempid).then((res) => {
        let data = res?.scheduledInspection;
        const orderedData = [...data].sort((a, b) => {
          const dateA = new Date(`${a.date} ${a.year}`);
          const dateB = new Date(`${b.date} ${b.year}`);
          return dateA - dateB;
        });
        setUpcomingInspection(orderedData);
      });

      getOtherDocs(tempid);
      docuploadlist();
    }
  }, []);

  function validateSchedule(schedule) {
    let valid = true;
    const moment = require('moment');

    schedule.map((entry, index) => {
      if (!valid) return;
      if (entry.recurring === true) {
        let startDate = moment(entry.startDate);
        let endDate = moment(entry.endDate);
        let selectedDay = entry.day;

        // Check if start date, time, and duration are selected
        // if (!entry.startDate || !entry.time || !entry.duration) {
        //   setSelectDate(
        //     "Please select start date, time, and duration for recurring entry."
        //   );

        //   return false;
        // }

        if (!entry.day) {
          setErrorMessageDaySelect({
            helperText: 'Select day',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else {
          setErrorMessageDaySelect({
            helperText: '',
            error: false,
            index: index,
          });
        }
        if (!entry.startDate) {
          setErrorMessageStartDate({
            helperText: 'Select day',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else if (!dayjs(entry.startDate).isValid()) {
          setErrorMessageStartDate({
            helperText: 'Please select a valid date',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else {
          const selectedDate = dayjs.tz(
            entry.startDate,
            'YYYY-MM-DD',
            'Australia/Sydney'
          );
          const todaySydney = dayjs().tz('Australia/Sydney').startOf('day');

          if (selectedDate.isBefore(todaySydney)) {
            setErrorMessageStartDate({
              helperText: 'Past date cannot be selected',
              error: true,
              index: index,
            });
            valid = false;
            return;
          }
          if (selectedDate.isSame(todaySydney, 'day')) {
            setErrorMessageStartDate({
              helperText: "Today's date is not allowed. Choose a future date.",
              error: true,
              index: index,
            });
            valid = false;
            return;
          }

          setErrorMessageStartDate({
            helperText: '',
            error: false,
            index: index,
          });
        }

        if (!entry.duration) {
          setErrorMessageDuration({
            helperText: 'Please select inspection duration',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else {
          setErrorMessageDuration({
            helperText: '',
            error: false,
            index: index,
          });
        }
        if (!entry.time) {
          setErrorMessageTime({
            helperText: 'Select start time',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else {
          setErrorMessageTime({
            helperText: '',
            error: false,
            index: index,
          });
        }

        if (!entry.endDate) {
          setErrorMessageEndingDate({
            helperText: 'Please select end date',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else {
          setErrorMessageEndingDate({
            helperText: '',
            error: false,
            index: index,
          });
        }
        // Check if start date is less than end date
        if (entry.endDate && entry.startDate >= entry.endDate) {
          setGreaterDate(
            'Start date cannot be greater than or equal to end date for recurring entry.'
          );
          valid = false;
          return;
        }

        let currentDate = startDate.clone();
        let foundSelectedDay = false;
        while (
          currentDate.isBefore(endDate) ||
          currentDate.isSame(endDate, 'day')
        ) {
          if (currentDate.format('dddd') === selectedDay) {
            foundSelectedDay = true;
            break;
          }
          currentDate = currentDate.add(1, 'day');
        }
        if (!foundSelectedDay) {
          const formattedStart = moment(entry.startDate)?.format('DD-MM-YYYY');
          const formattedEnd = moment(entry.endDate)?.format('DD-MM-YYYY');

          Swal.fire({
            icon: 'error',
            title: 'No Occurrence Found',
            html: `
              <div style="font-size:16px; font-family:poppins;">
              There is no occurrence of <b>${selectedDay}</b><br/>
              between <b>${formattedStart}</b> and <b>${formattedEnd}</b>
              </div>
              `,
            confirmButtonText: 'Close',
            width: 360,
          });

          // setOccurenceDay(
          //   `There is no occurrence of ${selectedDay} between the Start Date and End Date`
          // );
          return false;
        }
      } else {
        if (!entry.startDate) {
          setErrorMessageStartDate({
            helperText: 'Select Date',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else if (!dayjs(entry.startDate).isValid()) {
          setErrorMessageStartDate({
            helperText: 'Please select a valid date',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else {
          const selectedDate = dayjs.tz(
            entry.startDate,
            'YYYY-MM-DD',
            'Australia/Sydney'
          );
          const todaySydney = dayjs().tz('Australia/Sydney').startOf('day');

          if (selectedDate.isBefore(todaySydney)) {
            setErrorMessageStartDate({
              helperText: 'Past date cannot be selected',
              error: true,
              index: index,
            });
            valid = false;
            return;
          }
          if (selectedDate.isSame(todaySydney, 'day')) {
            setErrorMessageStartDate({
              helperText: "Today's date is not allowed. Choose a future date.",
              error: true,
              index: index,
            });
            valid = false;
            return;
          }

          setErrorMessageStartDate({
            helperText: '',
            error: false,
            index: index,
          });
        }

        if (!entry.duration) {
          setErrorMessageDuration({
            helperText: 'Select duration',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else {
          setErrorMessageDuration({
            helperText: '',
            error: false,
            index: index,
          });
        }
        if (!entry.time) {
          setErrorMessageTime({
            helperText: 'Select start time',
            error: true,
            index: index,
          });
          valid = false;
          return;
        } else {
          setErrorMessageTime({
            helperText: '',
            error: false,
            index: index,
          });
        }
      }
    });
    return valid;
  }

  const [hideSelect, setHideSelect] = useState(false);
  const [addInspectionLoader, setAddInspectionLoader] = useState(false);

  const handleSubmitInspection = () => {
    let validateFlag = validateSchedule(inspection);
    setGreaterDate('');
    if (!validateFlag) {
      return;
    }

    let array = [];

    inspection.forEach((item) => {
      item.isRecurring = item.isRecurring === 1 ? 1 : item.recurring ? 1 : 0;
    });
    array = [...inspection];

    let input = {
      tempId:
        fromHeader == 'no' && resumeTempId != 0 && resumeTempId != undefined
          ? resumeTempId
          : tempid,

      inspection: array,
    };

    if (
      inspection[0]?.time != null &&
      inspection[0]?.duration !== '' &&
      inspection[0]?.startDate != null
    ) {
      // 🔒 Validate past date first
      const startDateStr = inspection[0]?.startDate;
      const selectedDate = dayjs.tz(
        startDateStr,
        'YYYY-MM-DD',
        'Australia/Sydney'
      );
      const todaySydney = dayjs().tz('Australia/Sydney').startOf('day');

      if (!selectedDate.isValid()) {
        setErrorMessageStartDate({
          helperText: 'Please select a valid date',
          error: true,
          index: 0,
        });
        return;
      }
      if (selectedDate.isBefore(todaySydney)) {
        setErrorMessageStartDate({
          helperText: 'Past date cannot be selected',
          error: true,
          index: 0,
        });
        return;
      }
      if (selectedDate.isSame(todaySydney, 'day')) {
        setErrorMessageStartDate({
          helperText: "Today's date is not allowed. Choose a future date.",
          error: true,
          index: 0,
        });
        return;
      } else {
        setErrorMessageStartDate({
          helperText: '',
          error: false,
          index: 0,
        });
      }

      // ✅ Continue with time parsing and validation...

      const timeStr = inspection[0]?.time;
      const parsedTime = dayjs(timeStr, ['hh:mm A', 'h:mm A', 'HH:mm']);

      if (!parsedTime.isValid()) {
        setErrorMessageTime({
          error: true,
          helperText: 'Please enter a valid time in hh:mm AM/PM format.',
          index: 0,
        });
        return;
      }

      // const selectedDateTime = dayjs.tz(
      //   `${inspection[0]?.startDate} ${parsedTime.format('HH:mm')}`,
      //   'YYYY-MM-DD HH:mm',
      //   'Australia/Sydney'
      // );

      const selectedStartDate = dayjs.tz(
        inspection[0]?.startDate,
        'YYYY-MM-DD',
        'Australia/Sydney'
      );
      if (!selectedStartDate.isValid()) {
        setErrorMessageStartDate({
          helperText: 'Please select a valid date',
          error: true,
          index: 0,
        });
        return;
      }

      const selectedDateTime = selectedStartDate
        .hour(parsedTime.hour())
        .minute(parsedTime.minute())
        .second(0)
        .millisecond(0);

      const nowSydney = dayjs().tz('Australia/Sydney');
      const threeHoursLater = nowSydney.clone().add(3, 'hour');

      // ✅ First validation: selected time should not be before current time (rounded to minute)
      // if (selectedDateTime.isBefore(nowSydney.startOf('minute'))) {
      //   setErrorMessageTime({
      //     error: true,
      //     helperText: 'Past date cannot be selected.',
      //     index: 0,
      //   });
      //   return;
      // }

      if (selectedStartDate.isSame(nowSydney, 'day')) {
        if (selectedDateTime.isBefore(nowSydney.startOf('minute'))) {
          setErrorMessageTime({
            error: true,
            helperText:
              'Selected time should be at least 3 hours ahead of current Sydney time.',
            index: 0,
          });
          return;
        }

        if (selectedDateTime.isBefore(threeHoursLater.startOf('minute'))) {
          setErrorMessageTime({
            error: true,
            helperText:
              'Selected time should be at least 3 hours ahead of current Sydney time.',
            index: 0,
          });
          return;
        }
      } else {
        if (selectedDateTime.isBefore(nowSydney.startOf('minute'))) {
          setErrorMessageTime({
            error: true,
            helperText: 'Selected time results in a past datetime.',
            index: 0,
          });
          return;
        }
      }

      // ✅ Second validation: at least 3 hours ahead
      // if (selectedDateTime.isBefore(threeHoursLater.startOf('minute'))) {
      //   setErrorMessageTime({
      //     error: true,
      //     helperText: `Selected time should be at least 3 hours ahead of current Sydney time.`,
      //     index: 0,
      //   });
      //   return;
      // }

      // ✅ Clear error once time is valid
      setErrorMessageTime({ error: false, helperText: '', index: 0 });

      // ✅ Continue with submission
      setInspectionValidation(false);
      setAddInspectionLoader(true);

      addInspectionFunction(input)
        .then((res) => {
          setInspectionValidation(false);

          if (res?.status == '1') {
            setCurrentSydneyTime(false);
            setInspection([
              {
                recurring: false,
                day: null,
                startDate: null,
                duration: '',
                time: null,
                endDate: null,
                isRecurring: 0,
              },
            ]);
            setAddInspectionLoader(false);
            setHideSelect(true);
            setRecurring(false);
            setValidateInspection(true);

            getUpcomingInspection(tempid).then((res) => {
              let data = res?.scheduledInspection;
              const orderedData = [...data].sort((a, b) => {
                const dateA = new Date(`${a.date} ${a.year}`);
                const dateB = new Date(`${b.date} ${b.year}`);
                return dateA - dateB;
              });
              setUpcomingInspection(orderedData);
            });
          } else {
            if (res?.status == -1) {
              setAddInspectionLoader(false);
              let existDate = res?.existDate?.split(',');
              const formatDate = (date) => {
                if (!date) return 'Unknown Date';

                const newDate = new Date(date);

                const day = String(newDate.getDate()).padStart(2, '0');
                const month = String(newDate.getMonth() + 1).padStart(2, '0');
                const year = newDate.getFullYear();

                return `${day}-${month}-${year}`;
              };

              let formattedDate = existDate
                ?.map((eachDate) => formatDate(eachDate))
                .join(',');

              Swal.fire({
                title: 'Inspection Duplicated',
                html: `Inspection is already scheduled for these dates at the same time <b>${formattedDate}</b>, Do you want to replace this new schedule?`,
                showConfirmButton: true,
                showCancelButton: true,
                icon: 'error',
                confirmButtonText: 'Replace',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
              }).then((result) => {
                if (result?.isDismissed) {
                  setInspection([{}]);
                }
                if (result?.isConfirmed) {
                  let obj = res?.data[0];
                  obj = [
                    {
                      ...obj,
                      isReset: 1,
                      endDate: inspection[0]?.endDate,
                      isRecurring: 1,
                    },
                  ];
                  setInspection(obj);

                  setTimeout(() => {
                    swalcontinue?.current.click();
                  }, 0);
                }
              });
            }
          }
        })
        .catch(() => setAddInspectionLoader(false))
        .finally(() => {
          setAddInspectionLoader(false);
        });
    } else {
      setAddInspectionLoader(false);
    }
  };

  const isBtnEnable = () => {
    return inspection.every((ins) => {
      const basicFields = ins.time && ins.duration && ins.startDate;

      if (ins.recurring) {
        return basicFields && ins.day && ins.endDate;
      }

      return basicFields;
    });
  };

  const [currentSydneyDate, setCurrentSydneyDate] = useState(
    dayjs().tz('Australia/Sydney').add(3, 'hour').add(5, 'minute')
  );
  const [currentSydneyTime, setCurrentSydneyTime] = useState(false);

  const sydneyNow = dayjs().tz('Australia/Sydney');
  const sydneyToday = sydneyNow.startOf('day');
  const sydneyTomorrow = sydneyToday.add(1, 'day');

  const sydneyPlusBuffer = sydneyNow.add(3, 'hour').add(5, 'minute');
  const [isNextDay, setIsNextDay] = useState(
    sydneyPlusBuffer.isAfter(sydneyNow.endOf('day'))
  );
  const minDate = currentSydneyDate;
  const minDateStart = isNextDay ? sydneyNow.add(1, 'day') : sydneyNow;

  const handleInspectionChange = (index, field, value) => {
    setHideSelect(false);
    const date2 = dayjs().tz('Australia/Sydney').format('YYYY-MM-DD');
    setGreaterDate('');
    if (field == 'startDate') {
      if (value === date2) {
        setCurrentSydneyTime(true);
        setInspection((prevInspections) => {
          const updatedInspections = [...prevInspections];
          updatedInspections[index] = {
            ...updatedInspections[index],
            time: dayjs(minDate).format('HH:mm:ss'),
          };
          return updatedInspections;
        });
      } else {
        setCurrentSydneyTime(false);
        setInspection((prevInspections) => {
          const updatedInspections = [...prevInspections];
          const { time: _, ...rest } = updatedInspections[index];
          updatedInspections[index] = rest;
          return updatedInspections;
        });
      }
    }
    setInspection((prevInspections) => {
      const updatedInspections = [...prevInspections];
      updatedInspections[index] = {
        ...updatedInspections[index],

        [field]: value,

        // isRecurring: recurring  ? 1 : 0,
      };

      return updatedInspections;
    });
  };

  const [recentlyClosed, setRecentlyClosed] = useState(false);

  const handleClickVenueOpen = () => {
    setNewVenueAdd(true);
  };

  const handleClickVenueClose = () => {
    setNewVenueAdd(false);
    // setSelectedStreetType('')
  };
  const handleClose = () => {
    setOpen(false);
    setAddAddress(false);
  };

  const handleChange3 = (event) => {
    setBedroomcount(event.target.value);
    setErrorMessageBedroom({
      helperText: '',
      error: false,
    });
  };
  const handleChange4 = (event) => {
    setBathroomcount(event.target.value);
    setErrorMessageBathroom({
      helperText: '',
      error: false,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    Propertytype();
    Featurelist();
  }, []);

  const Propertytype = () => {
    getApiCall(ADD_PROPERTY_TYPELIST).then((res) => {
      if (res?.data?.status == -1) {
        toast.error(res?.data?.message, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          progress: 0,
          theme: 'light',
          style: {
            fontFamily: 'Poppins', // 👈 Inline Poppins font
          },
        });
      } else {
        setPropertytypelist(res?.data?.propertyTypeList);
      }
    });
  };

  const Featurelist = () => {
    getApiCall(ADD_PROPERTY_FEATURELIST).then((res) => {
      if (res?.data?.status == -1) {
        toast.error(res?.data?.message, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          progress: 0,
          theme: 'light',
          style: {
            fontFamily: 'Poppins', // 👈 Inline Poppins font
          },
        });
      } else {
        setFeaturelist(res?.data?.properyFeatureList);
      }
    });
  };

  const dragWord = (item) => {
    setDragImgSrc(item);
  };

  const dropWord = (event, item) => {
    event.preventDefault();
    const newDropImgSrc = item;
    const newDragImgSrc = dragImgSrc;
    setDropImgSrc(newDropImgSrc);
    const updatedImageUrl = imageUrl.map((el) => {
      if (el === newDropImgSrc) return newDragImgSrc;
      if (el === newDragImgSrc) return newDropImgSrc;
      return el;
    });
    setImageUrl(updatedImageUrl);
    const requests = updatedImageUrl.map((blobUrl, index) => {
      const fileindex = filename[index];
      return axios.get(blobUrl, { responseType: 'blob' }).then((response) => {
        const blobData = response.data;
        const fileReader = new FileReader();
        return new Promise((resolve, reject) => {
          fileReader.onload = function () {
            const dataURL = fileReader.result;
            const fileObj = new File([blobData], fileindex, {
              type: blobData.type,
            });
            resolve(fileObj);
          };
          fileReader.onerror = reject;
          fileReader.readAsDataURL(blobData);
        });
      });
    });

    Promise.all(requests)
      .then((fileObjects) => {
        setDocmentTypeMedia(fileObjects);
      })
      .catch((error) => {
        console.error('Error occurred during requests', error);
      });
  };

  const dropWords = (event, item) => {
    event.preventDefault();
    const newDropImgSrc = item;
    const newDragImgSrc = dragImgSrc;
    setDropImgSrc(newDropImgSrc);
    const updatedImageUrl = imageUrlSecondary.map((el) => {
      if (el === newDropImgSrc) return newDragImgSrc;
      if (el === newDragImgSrc) return newDropImgSrc;
      return el;
    });
    setImageUrlSecondary(updatedImageUrl);
    const requests = updatedImageUrl.map((blobUrl, index) => {
      const fileindex = filename[index];
      return axios.get(blobUrl, { responseType: 'blob' }).then((response) => {
        const blobData = response.data;
        const fileReader = new FileReader();
        return new Promise((resolve, reject) => {
          fileReader.onload = function () {
            const dataURL = fileReader.result;
            const fileObj = new File([blobData], fileindex, {
              type: blobData.type,
            });
            resolve(fileObj);
          };
          fileReader.onerror = reject;
          fileReader.readAsDataURL(blobData);
        });
      });
    });

    Promise.all(requests)
      .then((fileObjects) => {
        setDocmentTypeMedia(fileObjects);
      })
      .catch((error) => {
        console.error('Error occurred during requests', error);
      });
  };
  const removeImgHandler = (removeImage) => {
    setImageUrl((preUploadedImages) => {
      const updatedImages = preUploadedImages.filter(
        (preImage) => preImage !== removeImage
      );

      setErrorimageUrl({ helperText: '', error: false, duplicateNames: null });
      return updatedImages;
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  };

  const handleItemClick = (item) => {
    // setSelectedVenue(item?.venue);
    let auctiontime = moment(item?.auctionTime, 'HH:mm');
    setVenueId(item?.venueId);
    setAuctiontime(auctiontime);
    setAuctiondate(item?.auctionDate);

    setSelectedItem(item);
    setSearchTerm(item?.venue);
  };
  const handleStreetTypeChange = (event) => {
    setSelectedStreetType(event.target.value);
  };

  useEffect(() => {
    if (docValidate != '') {
      setTimeout(() => {
        setDocValidate('');
      }, 3000);
    }
  }, [docValidate]);

  // to add owner property

  const [addMoreField, setAddmorefield] = React.useState(false);

  const openAddFieldConfirmBox = () => {
    setAddmorefield(true);
  };
  const closeAddFieldConfirmBox = () => {
    setAddmorefield(false);
    onClose();
  };

  const confirmAddmoreField = () => {
    setValue(0);
    setAddmorefield(false);
  };

  //states and function to select existing property for appraisal
  const [openPropPrefill, setOpenPropPrefill] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [addresses, setAddresses] = useState([]);

  const handlePropertySelect = (property) => {
    setSelectedProperty(property);
    setOpenPropPrefill(false);
  };

  const ClosePropPrefill = () => {
    setOpenPropPrefill(false);
  };

  const getPrefillData = async () => {
    try {
      const inputData = {
        vendorIds: responseData,
      };
      const response = await postApiCall(GET_APPRAISAL_PREFILL, inputData);
      if (response?.data?.status === 1) {
        const fetchedAddresses = response?.data?.propertyDetailsWithMedia || [];
        setAddresses(fetchedAddresses);
        if (fetchedAddresses.length >= 1) {
          setOpenPropPrefill(true);
        }
      } else {
        console.error('Failed to fetch data. Status not successful.');
      }
    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
  };

  useEffect(() => {
    if (prefillData?.property) {
      setSelectedProperty(prefillData.property);
    } else if (fromHeader == 'appraisal') {
      getPrefillData();
    }
  }, [prefillData, fromHeader]);

  useEffect(() => {
    if (selectedProperty) {
      setUnitNumber(selectedProperty?.addressDetails?.details?.unitNo || '');
      setStreetNumber(
        String(selectedProperty?.addressDetails?.details?.streetNo || '')
      );
      setStreetName(
        selectedProperty?.addressDetails?.details?.streetName || ''
      );
      // to set the streettype
      if (
        selectedProperty?.addressDetails?.details?.streetType &&
        options.length > 0
      ) {
        const matchedOption = options.find(
          (opt) =>
            opt.label === selectedProperty?.addressDetails?.details?.streetType
        );
        if (matchedOption) {
          setSelectedStreetTypeformat(matchedOption);
          setSelectedStreetType(matchedOption.label);
          setSelectedStreetTypeabbrev(matchedOption.streetAbbrev);
        }
      }
      setTown(selectedProperty?.addressDetails?.details?.suburb || '');
      setSelectedState(selectedProperty?.addressDetails?.details?.state || '');
      setPostCode(selectedProperty?.addressDetails?.details?.postalCode || '');
      setPropertyTypeCode(selectedProperty?.typeCode);
      setLandsize(selectedProperty?.landSize);
      setInternalsize(selectedProperty?.internalSize);
      setBuildingSize(selectedProperty?.buildingSize);
      setHeading(selectedProperty?.heading);
      setDP(selectedProperty?.DP);
      setWaterRates(selectedProperty?.waterRate);
      setCouncilRate(selectedProperty?.councilRate);
      setCarparking(selectedProperty?.carParking);
      setBathroomcount(selectedProperty?.bathRoomCount);
      setBedroomcount(selectedProperty?.bedRoomCount);
      setDescription(selectedProperty?.description);
      setFeature([...selectedProperty?.feature]);
      const mediaList = selectedProperty?.media || [];
      const imageItems = mediaList?.filter(
        (item) => item?.type === 'Banner' || item?.type === 'banner'
      );
      const bannerItems = mediaList?.filter(
        (item) => item?.type === 'Image' || item?.type === 'image'
      );
      const strataLink = mediaList?.find(
        (item) => item?.type === 'StrataLink' || item?.type === 'strataLink'
      );
      const buildingPestLink = mediaList?.find(
        (item) =>
          item?.type === 'BuildingPestLink' || item?.type === 'buildingPestLink'
      );
      const virtualTourLink = mediaList?.find(
        (item) =>
          item?.type === 'virtualTourLink' || item?.type === 'VirtualTourLink'
      );
      const propertyVideoItem = mediaList?.find(
        (item) => item?.type === 'VideoTour' || item?.type === 'videoTour'
      );
      const tour360VideoItem = mediaList?.find(
        (item) => item?.type === 'Video360' || item?.type === 'video360'
      );

      setStrata(strataLink?.path || strataLink?.mediaUrl || '');
      setBuilding(
        buildingPestLink?.path || buildingPestLink?.mediaUrl || building || ''
      );
      setVideoUrl(virtualTourLink?.path || virtualTourLink?.mediaUrl || '');
      setImageUrl(
        imageItems
          ?.map((item) =>
            typeof item === 'string' ? item : item?.path || item?.mediaUrl || ''
          )
          .filter(Boolean)
      );
      setImageUrlSecondary(
        bannerItems
          ?.map((item) =>
            typeof item === 'string' ? item : item?.path || item?.mediaUrl || ''
          )
          .filter(Boolean)
      );
      setPropertyVideo(
        propertyVideoItem?.path || propertyVideoItem?.mediaUrl || null
      );
      setTour360Video(
        tour360VideoItem?.path || tour360VideoItem?.mediaUrl || null
      );
      setCampaign(selectedProperty?.campaignType);

      if (selectedProperty?.files?.length > 0) {
        const pdfArrayName = selectedProperty?.files?.map(
          (item) => item?.document
        );
        setGetDocList(selectedProperty?.files);
        setFilesName(
          pdfArrayName?.map((url) => {
            return url.substring(url.lastIndexOf('/') + 1);
          })
        );
      }

      if (selectedProperty?.campaignType === 'For Sale') {
        setForSale(true);
        const prefilledSalePrice = selectedProperty?.salePrice
          ?.toString()
          .replace(/\D/g, '');
        setSaleprice(prefilledSalePrice || '');
        setDisplaysaleprice(selectedProperty?.displaySalePrice || '');

        if (prefilledSalePrice) {
          const minValue = parseInt(prefilledSalePrice);
          const maxValue = minValue + minValue * 0.1;
          setSliderForSalevalue([minValue, maxValue]);
          const newMaxValue =
            calculateMaxSliderValueBasedOnDigits(prefilledSalePrice);
          setForSaleMaxSliderValue(newMaxValue);
        }
      }

      if (selectedProperty?.campaignType === 'Auction') {
        setAuction(true);
        setCampaign('Auction');
        setForSale(false);
        setAuctiondate(selectedProperty?.auctionDate);
        const parsedTime = dayjs(selectedProperty?.auctionTime, 'HH:mm');
        setAuctiontime(parsedTime);
        setSelectedVenue(selectedProperty?.venueId);
      }
      setLotNumber(selectedProperty?.LOT);
      setSP(selectedProperty?.SP);
      setStrataLevies(selectedProperty?.strataLevies);

      if (selectedProperty?.rentalPrice || selectedProperty?.leaseExpiry) {
        setYesChecked(true);
        setNoChecked(false);
        setRentalPrice(
          selectedProperty?.rentalPrice
            ? String(selectedProperty.rentalPrice)
            : ''
        );
        setLeaseExpiry(selectedProperty?.leaseExpiry || null);
        setPublishlease(
          selectedProperty?.isPublishLease === 1 ||
            selectedProperty?.isPublishLease === '1'
        );
        setPublishrent(
          selectedProperty?.isPublishRent === 1 ||
            selectedProperty?.isPublishRent === '1'
        );
      } else {
        setYesChecked(false);
        setNoChecked(true);
      }
    }
    const strataLinkObj = selectedProperty?.media?.find(
      (item) => item?.type == 'StrataLink'
    );
    if (strataLinkObj && strataLinkObj.path) {
      setStrata(strataLinkObj?.path);
    }
    pipelineDocumentTypeList(
      selectedProperty?.tempId || ownerTempId,
      selectedProperty?.propertyId
    ).then((res) => setDocumentTypeListArr(res?.documentType));
  }, [selectedProperty]);
  const roundForApi = (value) => {
    if (value >= 100000000) {
      return Math.round(value / 100000) * 100000;
    } else if (value >= 10000000) {
      return Math.round(value / 10000) * 10000;
    } else if (value >= 1000000) {
      return Math.round(value / 10000) * 10000;
    } else if (value >= 10000) {
      return Math.round(value / 100) * 100;
    } else if (value >= 1000) {
      return Math.round(value / 10) * 10;
    } else if (value >= 100) {
      return Math.round(value);
    } else {
      return Math.round(value * 10) / 10;
    }
  };

  const urlToFile = async (url) => {
    if (url instanceof File) return url;
    if (typeof url === 'string' && url.startsWith('http')) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const filename = url.substring(url.lastIndexOf('/') + 1) || 'image.jpg';
        return new File([blob], filename, { type: blob.type || 'image/jpeg' });
      } catch (err) {
        console.error('Error converting URL to File:', err);
        return null;
      }
    }
    return null;
  };

  const processImageFiles = async (items) => {
    const filePromises = (items || []).map(async (item) => {
      if (item instanceof File) return item;
      if (typeof item === 'string' && item.startsWith('http')) {
        return await urlToFile(item);
      }
      return null;
    });
    const results = await Promise.all(filePromises);
    return results.filter((item) => item instanceof File);
  };

  const uploadMediaInSplits = async (
    propertyId,
    apiEndpoint,
    resData,
    isPipeline
  ) => {
    const bannerFiles = await processImageFiles(imageUrl);
    const secondaryFiles = await processImageFiles(imageUrlSecondary);
    const hasImages = bannerFiles.length > 0 || secondaryFiles.length > 0;
    const hasVideos =
      propertyVideo instanceof File || tour360Video instanceof File;

    const strataLinkValue =
      strata &&
      propertyTypeCode != '' &&
      ['type001', 'type002', 'type004', 'type005'].includes(propertyTypeCode)
        ? strata
        : '';

    const buildingPestLinkValue =
      building &&
      propertyTypeCode != '' &&
      ['type003', 'type004', 'type009'].includes(propertyTypeCode)
        ? building
        : '';

    const hasLinks = strataLinkValue !== '' || buildingPestLinkValue !== '';

    let firstResponse = null;
    let secondResponse = null;

    // 1. First API Call (Images & Links Only)
    if (hasImages || hasLinks) {
      const formDataImages = new FormData();
      formDataImages.append('propertyId', propertyId || '');
      if (isPipeline) {
        formDataImages.append('pipelinePropertyId', propertyId || '');
        formDataImages.append('tempId', propertyId || '');
      }

      bannerFiles.forEach((item) => {
        formDataImages.append('propertyMediaBanner[]', item);
      });
      secondaryFiles.forEach((item) => {
        formDataImages.append('propertyMedia[]', item);
      });

      formDataImages.append('strataLink', strataLinkValue);
      formDataImages.append('buildingPestLink', buildingPestLinkValue);

      try {
        firstResponse = await postApiCall(apiEndpoint, formDataImages);
        if (firstResponse?.data?.status === -1) {
          console.error(
            'Image/Link media upload failed:',
            firstResponse.data.message
          );
          toast.error(firstResponse.data.message || 'Failed to upload images', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: 0,
            theme: 'light',
            style: { fontFamily: 'Poppins' },
          });
          return false;
        } else {
          if (firstResponse?.data?.status == 1) {
            if (
              firstResponse &&
              isNotEmptyArray(firstResponse?.data?.dataForPropertyMediaBanner)
            ) {
              Moxoseparationinlisting(
                'dataForPropertyMedia',
                firstResponse?.data?.dataForPropertyMediaBanner
              );
            }
            if (
              firstResponse &&
              isNotEmptyArray(firstResponse?.data?.dataForPropertyMedia)
            ) {
              Moxoseparationinlisting(
                'dataForPropertyMedia',
                firstResponse?.data?.dataForPropertyMedia
              );
            }
            // Post-upload success callbacks & states
            setIsmediacompleted(true);
          }
        }
      } catch (error) {
        console.error('Error during image/link media upload:', error);
        toast.error('An error occurred during image upload.', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          progress: 0,
          theme: 'light',
          style: { fontFamily: 'Poppins' },
        });
        return false;
      }
    }

    // 2. Second API Call (Videos Only)
    if (hasVideos) {
      const formDataVideos = new FormData();
      formDataVideos.append('propertyId', propertyId || '');
      if (isPipeline) {
        formDataVideos.append('pipelinePropertyId', propertyId || '');
        formDataVideos.append('tempId', propertyId || '');
      }

      if (propertyVideo instanceof File) {
        formDataVideos.append('propertyVideo', propertyVideo);
        if (isPipeline) {
          formDataVideos.append('pipelinePropertyVideo', propertyVideo);
          formDataVideos.append('pipelineVideo', propertyVideo);
        }
      }
      if (tour360Video instanceof File) {
        formDataVideos.append('propertyVideo360', tour360Video);
        if (isPipeline) {
          formDataVideos.append('pipelinePropertyVideo360', tour360Video);
          formDataVideos.append('pipelineVideo360', tour360Video);
        }
      }

      try {
        secondResponse = await postApiCall(apiEndpoint, formDataVideos);
        if (secondResponse?.data?.status === -1) {
          console.error(
            'Video media upload failed:',
            secondResponse.data.message
          );
          toast.error(
            secondResponse.data.message || 'Failed to upload videos',
            {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              progress: 0,
              theme: 'light',
              style: { fontFamily: 'Poppins' },
            }
          );
        }
      } catch (error) {
        console.error('Error during video media upload:', error);
        toast.error('An error occurred during video upload.', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          progress: 0,
          theme: 'light',
          style: { fontFamily: 'Poppins' },
        });
      }
    }

    setIsmediacompleted(true);
    return true;
  };

  const validateAndCheckAddress = async () => {
    const hasAnyAddressData =
      streetNumber !== '' ||
      streetName !== '' ||
      selectedStreetType !== '' ||
      town !== '' ||
      postCode !== '' ||
      selectedState !== '';

    const isAddressComplete =
      streetNumber !== '' &&
      streetName !== '' &&
      selectedStreetType !== '' &&
      town !== '' &&
      postCode !== '' &&
      selectedState !== '';

    // Nothing entered
    if (!hasAnyAddressData) {
      setErrorforaddress({
        helperText: 'Please enter a property address.',
        error: true,
      });

      addressref.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });

      return false;
    }

    // Some address data entered, but address is incomplete
    if (!isAddressComplete) {
      setErrorforaddress({
        helperText:
          'The address you entered is not compatible with the property type.',
        error: true,
      });

      addressref.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });

      return false;
    }

    // Apartment/Unit requires unit number
    if (propertyTypeCode === 'type001' && unitNumber.trim() === '') {
      setErrorforaddress({
        helperText:
          'The address you entered is not compatible with the property type.',
        error: true,
      });

      addressref.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });

      return false;
    }
    // Clear previous error
    setErrorforaddress({
      helperText: '',
      error: false,
    });

    try {
      setLoading(true);

      const addressString =
        (unitNumber
          ? `${unitNumber}` + `${streetNumber == '' ? '' : '/'}`
          : '') +
        `${streetNumber}` +
        `${streetName == '' ? '' : ' '}` +
        `${streetName}` +
        `${selectedStreetType == '' ? '' : ' '}` +
        `${selectedStreetType}` +
        `${town === '' ? '' : ', '}` +
        `${town}` +
        `${postCode === '' ? '' : ', '}` +
        `${postCode}` +
        `${selectedState === '' ? '' : ', '}` +
        `${selectedState}`;

      const checkRes = await postApiCall(CHECK_ADDRESS, {
        address: addressString,
      });

      const resData = checkRes?.data;
      const isDuplicate =
        resData?.status === -1 && resData?.message === 'Address exists';

      if (isDuplicate) {
        setErrorforaddress({
          helperText:
            'Address already registered. Please use a different address.',
          error: true,
        });

        addressref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });

        return false;
      }

      return true;
    } catch (error) {
      console.error('Error checking duplicate address:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const propertydetails = async () => {
    try {
      const isBuildingRequired = ['type003', 'type004', 'type009'].includes(
        propertyTypeCode
      );
      const isStrataRequired = [
        'type001',
        'type002',
        'type004',
        'type005',
      ].includes(propertyTypeCode);

      const buildingEmpty =
        isBuildingRequired && (!building || building.trim() === '');
      const strataEmpty = isStrataRequired && (!strata || strata.trim() === '');

      let message = '';

      if (buildingEmpty && strataEmpty) {
        message =
          'The Building & Pest Report and/or Strata Report have not been uploaded to this listing.';
      }

      if (message) {
        const result = await Swal.fire({
          title: '',

          html: `
<div style="
  display:flex;
  align-items:center;
  gap:10px;
  margin-bottom:8px;
">
  <svg
    width="34"
    height="32"
    viewBox="0 0 38 36"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="37.5797"
      height="36"
      rx="18"
      fill="#F39800"
      fill-opacity="0.1"
    />
    <path
      d="M27.0817 21.4607L21.3085 11.456
         C20.7883 10.5551 19.8271 10
         18.7866 10
         C17.7462 10 16.7851 10.5551
         16.2648 11.456
         L10.3902 21.632
         C9.86994 22.5329 9.86994 23.6431
         10.3902 24.544
         C10.9104 25.4449 11.8715 26
         12.912 26
         H24.6614
         C24.6646 26 24.6677 26
         24.6677 26
         C26.276 26 27.5797 24.6962
         27.5797 23.088
         C27.5797 22.4853 27.3957 21.9239
         27.0817 21.4607ZM20.0333 22.4345
         C20.0333 23.1229 19.5036 23.6495
         18.7898 23.6495
         C18.0761 23.6495 17.5464 23.1229
         17.5464 22.4345V22.406
         C17.5464 21.7208 18.0761 21.1911
         18.7898 21.1911
         C19.5036 21.1911 20.0333 21.7177
         20.0333 22.406V22.4345ZM20.0619 14.2443
         L19.4465 19.6178
         C19.4052 20.0048 19.1483 20.2458
         18.7898 20.2458
         C18.4314 20.2458 18.1745 20.0016
         18.1332 19.6178
         L17.5178 14.2411
         C17.4766 13.8255 17.7019 13.5115
         18.0888 13.5115H19.4877
         C19.8747 13.5147 20.1031 13.8287
         20.0619 14.2443Z"
      fill="#F39800"
    />
  </svg>

  <span style="
    font-size:20px;
    font-weight:500;
    color:#112347;
  ">
    Due Diligence Documents Unavailable
  </span>
</div>

<div style="color:#4a4a4a; font-size:18px;">
  ${message}
</div>
`,
          icon: undefined,
          iconHtml: undefined,

          showCancelButton: true,
          confirmButtonText: 'Continue',
          cancelButtonText: 'Back',
          reverseButtons: true,
          didOpen: () => {
            const confirmBtn = Swal.getConfirmButton();
            const cancelBtn = Swal.getCancelButton();

            confirmBtn.style.width = '130px';
            cancelBtn.style.width = '130px';

            confirmBtn.style.height = '40px';
            cancelBtn.style.height = '40px';
          },
        });

        if (!result.isConfirmed) return;
      }
      if (propertyTypeCode == '') {
        setErrorMessagePropertyType({
          helperText: 'Select property type',
          error: true,
        });
        // propertytyperef.current.focus();
        propertytyperef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessagePropertyType({
          helperText: '',
          error: false,
        });
      }

      // property address field error check
      const isAddressValid = await validateAndCheckAddress();

      if (!isAddressValid) {
        return;
      }

      if (bedroomcount == '') {
        setErrorMessageBedroom({
          helperText: 'Select number of bedrooms',
          error: true,
        });
        bedroomref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageBedroom({
          helperText: '',
          error: false,
        });
      }
      if (media?.length > 0 && selectedDocumentType != '') {
        setErrorOtherDocument({
          helperText: 'Please upload the documents',
          error: true,
        });
        otherDocumentRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorOtherDocument({
          helperText: '',
          error: false,
        });
      }
      if (bathroomcount == '') {
        setErrorMessageBathroom({
          helperText: 'Select number of bathrooms',
          error: true,
        });
        bathroomref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageBathroom({
          helperText: '',
          error: false,
        });
      }
      if (carparking == '') {
        setErrorMessageCar({
          helperText: 'Number of parking spaces',
          error: true,
        });
        parkingref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageCar({
          helperText: '',
          error: false,
        });
      }
      if (heading == '') {
        setErrorMessageHeading({
          helperText: 'No heading entered',
          error: true,
        });
        titleref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageHeading({
          helperText: '',
          error: false,
        });
      }
      if (description == '') {
        setErrorMessageDescription({
          helperText: 'No description entered',
          error: true,
        });
        descriptionref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageDescription({
          helperText: '',
          error: false,
        });
      }
      if (imageUrl.length < 1) {
        setErrorimageUrl({ helperText: 'No images uploaded', error: true });
        imagesref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else if (imageUrlSecondary.length < 1) {
        setErrorimageUrlSecondary({
          helperText: 'No images uploaded',
          error: true,
        });
        secimagesref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorimageUrl({ helperText: '', error: false });
      }
      if (errorPropertyVideo.error) {
        propertyVideoSectionRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      }
      if (errorTour360Video.error) {
        tour360VideoSectionRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      }
      if (landsize == '' && propertyTypeCode === 'type003') {
        setErrorMessageLandSize({
          helperText: 'Enter land size',
          error: true,
        });
        landsizeref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageLandSize({
          helperText: '',
          error: false,
        });
      }
      if (internalsize == '' && propertyTypeCode === 'type001') {
        setErrorMessageInternalSize({
          helperText: 'Enter internal size',
          error: true,
        });
        internalsizeref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageInternalSize({
          helperText: '',
          error: false,
        });
      }
      if (buildingSize == '' && propertyTypeCode === 'type003') {
        setErrorMessageBuildingSize({
          helperText: 'Enter building size',
          error: true,
        });
        buildingsizeref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageBuildingSize({
          helperText: '',
          error: false,
        });
      }
      if (councilRate == '') {
        setErrorMessagecouncilrate({
          helperText: 'Enter council rates',
          error: true,
        });
        councilrateref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessagecouncilrate({
          helperText: '',
          error: false,
        });
      }
      if (waterRates == '') {
        setErrorMessagewaterrate({
          helperText: 'Enter water rates',
          error: true,
        });
        waterrateref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessagewaterrate({
          helperText: '',
          error: false,
        });
      }
      if (campaign == '') {
        setErrorMessagecampaigntype({
          helperText: 'Select campaign type',
          error: true,
        });
        campaignttyperef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessagecampaigntype({
          helperText: '',
          error: false,
        });
      }
      if (auction && auctiondate == '') {
        setTimeout(() => {
          if (auctiondateref.current) {
            auctiondateref.current.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest',
            });
          }
        }, 100);
        setErrorMessageauctiondate({
          helperText: 'Enter the auction date.',
          error: true,
        });
        return;
      } else {
        setErrorMessageauctiondate({
          helperText: '',
          error: false,
        });
      }
      if (auction && auctiontime == '') {
        setTimeout(() => {
          if (auctiontimeref.current) {
            auctiontimeref.current.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest',
            });
          }
        }, 100);
        setErrorMessageAuctionTime({
          helperText: 'Enter auction time',
          error: true,
        });
        return;
      } else {
        setErrorMessageAuctionTime({
          helperText: '',
          error: false,
        });
      }
      if (auction && selectedVenue == '') {
        setTimeout(() => {
          if (venueref.current) {
            venueref.current.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest',
            });
          }
        }, 100);
        setErrorMessageVenue({
          helperText: 'Select auction venue',
          error: true,
        });
        return;
      } else {
        setErrorMessageVenue({
          helperText: '',
          error: false,
        });
      }
      if (forSale && (saleprice.trim() === '' || /^0+$/.test(saleprice))) {
        setErrorMessageSalePrice({
          helperText: "Enter 'For Sale' price",
          error: true,
        });
        salepriceref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageSalePrice({
          helperText: '',
          error: false,
        });
      }
      if (forSale && displaysaleprice.trim() === /^0+$/.test(saleprice)) {
        setErrorMessageDisplayPrice({
          helperText: 'Enter alternative display price',
          error: true,
        });
        salepriceref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
        return;
      } else {
        setErrorMessageDisplayPrice({
          helperText: '',
          error: false,
        });
      }
      if (
        upcomingInspection?.length == 0 &&
        fromHeader !== 'owner' &&
        fromHeader !== 'property' &&
        fromHeader !== 'appraisal'
      ) {
        setTimeout(() => {
          if (inspectionRef.current) {
            inspectionRef.current.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest',
            });
          }
        }, 100);
        setGreaterDate('Inspection details are not saved');
      } else if (
        upcomingInspection?.length > 0 ||
        fromHeader == 'owner' ||
        fromHeader == 'property' ||
        fromHeader == 'appraisal'
      ) {
        setLoading(true);
        let sliderdata = `${roundForApi(sliderForSalevalue[0])} - ${roundForApi(
          sliderForSalevalue[1]
        )}`;
        const address = streetname;

        // to create existing property as appraisal
        if (selectedProperty && !prefillData) {
          const appParams = {
            appraisal: 1,
            propertyId: selectedProperty?.propertyId,
          };
          const res = await postApiCall(
            ADD_EXISTINGPROPERTY_APPRAISAL,
            appParams
          );
          if (res?.data?.status == 1) {
            Swal.fire({
              title: res?.data?.heading,
              text: res?.data?.message,
              showConfirmButton: true,
              showCancelButton: false,
              icon: 'success',
              confirmButtonText: 'Close',
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                onClose();
              }
              return;
            });
          } else {
            toast.error(res?.data?.message, {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              progress: 0,
              theme: 'light',
              style: {
                fontFamily: 'Poppins', // 👈 Inline Poppins font
              },
            });
          }
          setLoading(false);
          onClose();
          return;
        }

        const params = {
          tempId: parseInt(tempid),
          // landArea: parseInt(landarea),
          landSize: parseInt(landsize),
          buildingSize: buildingSize ? parseInt(buildingSize) : null,
          internalSize: internalsize ? parseInt(internalsize) : null,
          strataLevies:
            strataLevies && propertyTypeCode === 'type001'
              ? strataLevies
              : null,
          councilRate: councilRate,
          waterRate: waterRates,
          heading: heading,
          description: description,
          priceRange: sliderdata,
          DP: dp ? dp : null,
          LOT: lotNumber && propertyTypeCode === 'type001' ? lotNumber : null,
          SP: sp && propertyTypeCode === 'type001' ? sp : null,
          propertyTypeCode: propertyTypeCode,
          propertyAddress: {
            address: streetname
              ? streetname
              : (unitNumber
                  ? `${unitNumber}` + `${streetNumber == '' ? '' : '/'}`
                  : '') +
                `${streetNumber}` +
                `${streetName == '' ? '' : ' '}` +
                `${streetName}` +
                `${selectedStreetType == '' ? '' : ' '}` +
                `${selectedStreetType}` +
                `${town === '' ? '' : ', '}` +
                `${town}` +
                `${postCode === '' ? '' : ', '}` +
                `${postCode}` +
                `${selectedState === '' ? '' : ', '}` +
                `${selectedState}`,
            unitNo: unitNumber,
            streetNo: streetNumber,
            streetName: streetName,
            streetType: selectedStreetType,
            streetAbbrev: selectedStreetTypeabbrev,
            suburb: town,
            state: selectedState,
            country: 'Australia',
            postalCode: postCode,
            latitude: latitude,
            longitude: longitude,
          },
          features: feature,
          walkScore: selectedWalkScores,
          propertyDetails: {
            bedRoomCount: bedroomcount,
            bathRoomCount: bathroomcount,
            carParking: carparking,
            leaseExpiry: yesChecked === true ? leaseExpiry : null,
            rentalPrice: yesChecked === true ? rentalPrice : null,
            isPublishLease: publishlease === true ? 1 : 0,
            isPublishRent: publishrent === true ? 1 : 0,
          },
          generalCampaign: campaign,
          venueId: campaign === 'Auction' ? selectedVenue : 0,
          salePrice: campaign === 'For Sale' ? saleprice : 0,
          displaySalePrice:
            campaign === 'For Sale' ? displaysaleprice || saleprice : 0,
          auctionDate: campaign === 'For Sale' ? null : auctiondate,
          auctionTime:
            campaign === 'For Sale' ? null : dayjs(auctiontime).format('HH:mm'),
          vendorIds: [...responseData],
          isAppraisal: fromHeader == 'appraisal' ? 1 : 0,
          ...(prefillData
            ? {
                pipelineTempId:
                  prefillData?.property?.propertyId ||
                  prefillData?.propertyId ||
                  pipelineTempId ||
                  localStorage.getItem('pipelinePropertyId') ||
                  '',
              }
            : {}),
        };

        // updating only property details
        if (
          !prefillData &&
          (fromHeader == 'property' ||
            fromHeader == 'owner' ||
            fromHeader == 'appraisal')
        ) {
          const pipelineParams = {
            ...params,
            pipelineId: pipelineId,
            categoryId: categoryId,
            ownerTempId: ownerTempId,
          };
          const res = await postApiCall(ADD_PIPELINE_PROPERTY, pipelineParams);

          if (res?.data?.status == '1') {
            // setValue(value + 1);
            window.scrollTo(0, 0);
            localStorage.setItem('propertyId', res?.data?.propertyId || '');
            setResponseProp(res?.data?.data?.propertyId);
            setResponseTempId(res?.data?.data?.tempId);

            // if (isNotEmptyArray(res?.data?.dataForFilesBinder )) await Moxoseparationinlisting("dataForFilesBinder", res?.data?.dataForFilesBinder);//1
            // if(isNotEmptyArray(res?.data?.binderAdminData?.requestData )) await Moxoseparationinlisting("dataForVendorPipelineAdminBinder", res?.data?.binderAdminData?.requestData);//2
            // if(isNotEmptyArray(res?.data?.vsvPropertyBinder )) await Moxoseparationinlisting("dataForSolBinder", res?.data?.vsvPropertyBinder);//islinkedsolicitor
            if (isNotEmptyArray(res?.data?.binderData?.requestData))
              await Moxoseparationinlisting(
                'dataForVendorPipelineAgentBinder',
                res?.data?.binderData?.requestData
              ); //3
            // if(isNotEmptyArray(res?.data?.dataForAVSBinder )) await Moxoseparationinlisting("dataForAVSBinder", res?.data?.dataForAVSBinder); //4
            // if(isNotEmptyArray(res?.data?.dataForAVVSBinder )) await Moxoseparationinlisting("dataForAVVSBinder", res?.data?.dataForAVVSBinder);//5
            if (isNotEmptyArray(res?.data?.dataForVendorAck))
              setMoxovendorack(res?.data?.dataForVendorAck); //9
            if (isNotEmptyArray(res?.data?.dataForAgentAck))
              setMoxoagentack(res?.data?.dataForAgentAck); //10

            await uploadMediaInSplits(
              res?.data?.data?.tempId,
              PIPELINE_ADDPROPERTY_MEDIA,
              res?.data,
              true
            );
            setLoading(false);
            if (fromHeader == 'owner' || fromHeader == 'appraisal') {
              Swal.fire({
                title: res?.data?.heading,
                text: res?.data?.message,
                showConfirmButton: true,
                showCancelButton: false,
                icon: 'success',
                confirmButtonText: 'Close',
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  bannerApiTrigger();

                  onClose();
                }
              });
            } else {
              confirmAddmoreField();
              bannerApiTrigger();
            }
          } else {
            toast.error(res?.data?.message, {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              progress: 0,
              theme: 'light',
              style: {
                fontFamily: 'Poppins', // 👈 Inline Poppins font
              },
            });
            setLoading(false);
          }
          // if (!validateInspection) {
          //   setAddInspection("Please add inspection");
          //   return;
          // }
        } else {
          const res = await postApiCall(ADD_PROPERTY_DETAILS, params);

          if (res?.data?.status == '1') {
            {
              setLoading(false);
              dashboardcount?.();
              bannerApiTrigger();
              setValue(value + 1);
              localStorage.setItem('propertyId', res?.data?.propertyId || '');

              if (isNotEmptyArray(res?.data?.dataForFilesBinder))
                await Moxoseparationinlisting(
                  'dataForFilesBinder',
                  res?.data?.dataForFilesBinder
                ); //1
              if (isNotEmptyArray(res?.data?.dataForVendorAdminBinder))
                await Moxoseparationinlisting(
                  'dataForVendorAdminBinder',
                  res?.data?.dataForVendorAdminBinder
                ); //2
              if (isNotEmptyArray(res?.data?.vsvPropertyBinder))
                await Moxoseparationinlisting(
                  'dataForSolBinder',
                  res?.data?.vsvPropertyBinder
                ); //islinkedsolicitor
              if (isNotEmptyArray(res?.data?.dataForVendorAgentBinder))
                await Moxoseparationinlisting(
                  'dataForVendorAgentBinder',
                  res?.data?.dataForVendorAgentBinder
                ); //3
              if (isNotEmptyArray(res?.data?.dataForAVSBinder))
                await Moxoseparationinlisting(
                  'dataForAVSBinder',
                  res?.data?.dataForAVSBinder
                ); //4
              if (isNotEmptyArray(res?.data?.dataForAVVSBinder))
                await Moxoseparationinlisting(
                  'dataForAVVSBinder',
                  res?.data?.dataForAVVSBinder
                ); //5
              if (isNotEmptyArray(res?.data?.dataForAgreeFile)) {
                Moxoseparationinlisting(
                  'dataForAgreeFile',
                  res?.data?.dataForAgreeFile
                );
              } //6
              if (isNotEmptyArray(res?.data?.dataForConFile)) {
                Moxoseparationinlisting(
                  'dataForConFile',
                  res?.data?.dataForConFile
                );
              } //7
              if (isNotEmptyArray(res?.data?.dataForVendorGroupBinder)) {
                Moxoseparationinlisting(
                  'dataForVendorGroupBinder',
                  res?.data?.dataForVendorGroupBinder
                );
              } //8
              if (isNotEmptyArray(res?.data?.dataForVendorAck))
                setMoxovendorack(res?.data?.dataForVendorAck); //9
              if (isNotEmptyArray(res?.data?.dataForAgentAck))
                setMoxoagentack(res?.data?.dataForAgentAck); //10

              await uploadMediaInSplits(
                res?.data?.propertyId,
                ADD_PROPERTY_MEDIA,
                res?.data,
                false
              );
            }
          } else {
            toast.error(res?.data?.message, {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              progress: 0,
              theme: 'light',
              style: {
                fontFamily: 'Poppins', // 👈 Inline Poppins font
              },
            });
            setLoading(false);
          }
          // if (!validateInspection) {
          //   setAddInspection("Please add inspection");
          //   return;
          // }
        }
      } else {
      }
    } catch (error) {
      setLoading(false);
      toast.error('An unexpected error occurred. Please try again.', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        progress: 0,
        theme: 'light',
        style: {
          fontFamily: 'Poppins', // 👈 Inline Poppins font
        },
      });
    }
  };

  useEffect(() => {
    if (loading || otherDocLoading || loadingVenue || addInspectionLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading, otherDocLoading, loadingVenue, addInspectionLoader]);

  const handleInspectionDelete = (index) => {
    let result = [...inspection];
    result.splice(index, 1);
    setInspection(result);
  };

  // due diligence////

  // const [imageUrl, setImageUrl] = useState(null);
  const [strata, setStrata] = useState('');
  const [building, setBuilding] = useState('');

  // const [media, setMedia] = useState([]);

  const [errorMessageImage, setErrorMessageImage] = useState('');

  const [errorMessageStrata, setErrorMessageStrata] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageBuilding, setErrorMessageBuilding] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageDocumentType, setErrorMessageDocumentType] = useState({
    helperText: '',
    error: false,
  });

  const [docmentTypeMedia, setDocmentTypeMedia] = useState([]);

  const [isSelectFocused, setIsSelectFocused] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleDocumentTypeChange = (event) => {
    setSelectedDocumentType(event.target.value);
    setIsError(false);
  };

  const handleDocmentFileUpload = (acceptedFiles) => {
    if (selectedDocumentType) {
      setDocmentTypeMedia([
        ...docmentTypeMedia,
        { documentType: selectedDocumentType, file: acceptedFiles[0] },
      ]);
    } else {
      alert('Please select a document type.');
    }
  };

  // const onDrop = useCallback(
  //   (newFiles) => {
  //     setMedia((prevFiles) => [...prevFiles, ...newFiles]);
  //   },
  //   [setMedia]
  // );

  // const { getRootProps, getInputProps, isDragAccept, isDragReject } = useDropzone({
  //   onDrop,
  //   accept: { 'application/pdf': [], },
  //   multiple: true,
  // });
  const [uploadStatus, setUploadStatus] = useState(
    'Upload PDF file only, max size limit 15MB'
  );
  const handleFileUpload = (e) => {
    const chosenFiles = Array.prototype.slice.call(e.target.files);
    handleUploadFiles(chosenFiles);
    const selectedFiles = e.target.files;

    if (selectedFiles.length > 0) {
      const newMedia = [...media];

      for (let i = 0; i < selectedFiles.length; i++) {
        newMedia.push(selectedFiles[i]);
      }

      setMedia(newMedia);
      setUploadStatus('Document Uploaded Successfully');
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Please select a file to upload',
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      }).then((result) => {
        if (result.isConfirmed) {
        } else if (result.isDenied) {
          return;
        }
      });
      setUploadStatus('Upload PDF file only, max size limit 15MB');
    }
  };
  const handleUploadFiles = (files) => {
    const uploaded = [...media];
    files.some((file) => {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          title: 'Error',
          text: 'Please upload a PDF file',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      } else if (file.size > 15e6) {
        Swal.fire({
          title: 'Error',
          text: 'Please upload a file smaller than 15 MB',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      } else {
        uploaded.push(file);
      }
    });
    setMedia(uploaded);
  };

  const [campaignTypeRecentlySelected, setCampaignTypeRecentlySelected] =
    useState(false);

  // campaignType

  const recentlySelectedReducer = (state, action) => {
    switch (action.type) {
      case 'SET_RECENTLY_SELECTED':
        return { ...state, [action.field]: action.value };
      case 'RESET_RECENTLY_SELECTED':
        return { ...state, [action.field]: false };
      default:
        return state;
    }
  };

  const initialState = {
    propertyType: false,
    address: false,
    bedRoom: false,
    bathRoom: false,
    parkingPlace: false,
    campaignType: false,
    documentUpload: false,
    duration: false,
  };

  const [recentlySelected, dispatch] = useReducer(
    recentlySelectedReducer,
    initialState
  );

  const handleRecentlySelected = (field, value) => {
    dispatch({ type: 'SET_RECENTLY_SELECTED', field, value });

    setTimeout(() => {
      dispatch({ type: 'RESET_RECENTLY_SELECTED', field });
    }, 300); // Adjust delay as needed
  };

  // PropertyType

  const PropertyTypeHandleOpen = () => {
    if (!propertyTypeCode) {
      setSelectFocusedPropertyType(true);
    }
  };

  const PropertyTypeHandleClose = () => {
    setSelectFocusedPropertyType(false);
  };

  const handleMouseDown = (event) => {
    // Always allow mouse click to open
    event.preventDefault();
    setSelectFocusedPropertyType(true);
  };

  const PropertyTypeHandleclose = () => {
    setSelectFocusedPropertyType(false);
    handleRecentlySelected('propertyType', true);
    setTimeout(() => {
      handleRecentlySelected('propertyType', false);
    }, 100);
  };

  // BedRoom

  const BedRoomHandleOpen = () => {
    if (!recentlySelected.bedRoom) {
      setSelectFocusedBedroom(true);
    }
  };
  const BedRoomHandleclose = () => {
    setSelectFocusedBedroom(false);
    handleRecentlySelected('bedRoom', true);
    setTimeout(() => {
      handleRecentlySelected('bedRoom', false);
    }, 100);
  };

  // bathRoom

  const BathRoomHandleOpen = () => {
    if (!recentlySelected.bathRoom) {
      setSelectFocusedBathroom(true);
    }
  };
  const BathRoomHandleclose = () => {
    setSelectFocusedBathroom(false);
    handleRecentlySelected('bathRoom', true);
    setTimeout(() => {
      handleRecentlySelected('bathRoom', false);
    }, 100);
  };

  // parkingPlace

  const ParkingPlaceHandleOpen = () => {
    if (!recentlySelected.parkingPlace) {
      setSelectFocusedParking(true);
    }
  };
  const ParkingPlaceHandleclose = () => {
    setSelectFocusedParking(false);
    handleRecentlySelected('parkingPlace', true);
    setTimeout(() => {
      handleRecentlySelected('parkingPlace', false);
    }, 100);
  };

  // campaignType

  const CampaignTypeHandleOpen = () => {
    if (!recentlySelected.campaignType) {
      setSelectFocusedCampaign(true);
    }
  };
  const CampaignTypeHandleclose = () => {
    setSelectFocusedCampaign(false);
    handleRecentlySelected('campaignType', true);
    setTimeout(() => {
      handleRecentlySelected('campaignType', false);
    }, 100);
  };

  // documentUpload

  const DocumentUploadHandleOpen = (isFocusEvent = false) => {
    if (isDragging) return; // ✅ BLOCK HERE
    if (isFocusEvent && selectedDocumentType) return;
    if (!recentlySelected.documentUpload) {
      setIsSelectFocused(true);
    }
  };
  const DocumentUploadHandleclose = () => {
    setIsSelectFocused(false);
    handleRecentlySelected('documentUpload', true);
    setTimeout(() => {
      handleRecentlySelected('documentUpload', false);
    }, 100);
  };

  // duration

  const [openDurationIndex, setOpenDurationIndex] = useState(null);

  const DurationHandleOpen = (idx) => {
    if (!recentlySelected.duration) {
      setOpenDurationIndex(idx);
    }
  };

  const DurationHandleClose = () => {
    setOpenDurationIndex(null);
    handleRecentlySelected('duration', true);
    setTimeout(() => {
      handleRecentlySelected('duration', false);
    }, 100);
  };

  const CampaignData = {
    auctionDate: auctiondate,
    auctionTime: moment(auctiontime, 'HH:mm').format('HH:mm'),
    venue: selectedVenue,
  };

  const getVeneueList = async () => {
    try {
      const response = await getApiCall(`${Get_Venue}/{venue}`);

      const resData = response?.data || response;

      setVenueData(resData?.venueData || []);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const postDataWithVenueNameAndHeader = async () => {
    // setLoadingVenue(true);
    if (venueName == '') {
      setErrorMessageVenueName({
        helperText: 'Please fill this field',
        error: true,
      });
      return;
    }

    setLoadingVenue(true);

    try {
      const payload = {
        venue: venueName,
      };

      const response = await postApiCall(ADD_VENUE, payload);

      const resData = response?.data || response;

      if (resData?.venueId) {
        setSelectedVenue(resData?.venueId);
        handleClickVenueClose();
      }

      await getVeneueList();
    } catch (error) {
      console.error('Error:', error);
      setVenueName('');
    } finally {
      setLoadingVenue(false);
    }
  };

  useEffect(() => {
    getVeneueList();
  }, []);

  const setTableFocus = () => {
    const { current } = divRef;
    if (current !== null) {
      current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  useEffect(() => {
    setTableFocus();
  }, []);

  const matches = useMediaQuery(theme.breakpoints.between(900, 950));
  const matches1250 = useMediaQuery(
    '(min-width:1200px) and (max-width:1250px)'
  );
  return (
    <>
      <form>
        <Grid ref={divRef} container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography className={classes.PropertyTitle}>
              Property Configuration
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
            <FormControl style={{ display: 'flex' }}>
              <FormLabel sx={typography_textfield} variant="h6" required>
                Property Type
              </FormLabel>
              <InputLabel
                focused={false}
                shrink={false}
                variant="h4"
                htmlFor="property-count-select"
                className={classes.inputLabel}
                sx={{
                  fontFamily: 'poppins',
                  marginTop: matchessm ? '25px' : '35px',
                  marginLeft: '20px',
                  color: 'rgba(0, 0, 0, 0.30)',
                  fontWeight: 300,
                  visibility:
                    propertyTypeCode || isSelectFocusedPropertyType
                      ? 'hidden'
                      : 'visible',
                }}
              >
                Select property type
              </InputLabel>
              <Select
                inputProps={{ id: 'property-count-select' }}
                sx={{
                  fontFamily: 'poppins',
                  marginTop: '10px',
                  '.MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(0, 85, 255, 0.64)',
                  },
                }}
                ref={propertytyperef}
                required
                fullWidth
                className={classes.PropertydropDown}
                helperText={errorMessagePropertyType.helperText}
                error={errorMessagePropertyType.error}
                disableUnderline
                // sx={(select_dropdown)}
                IconComponent={ExpandMoreIcon}
                value={propertyTypeCode}
                onChange={(event) => {
                  const selectedValue = event.target.value; // Get the selected value
                  setErrorMessagePropertyType({
                    helperText: '',
                    error: false,
                  });
                  setPropertyTypeCode(selectedValue); // Set the selected value in setPropertyTypeCode
                  PropertyTypeHandleclose();
                  handleClose();
                }}
                open={isSelectFocusedPropertyType}
                onClose={PropertyTypeHandleclose}
                onMouseDown={handleMouseDown}
                onFocus={PropertyTypeHandleOpen}
                onBlur={PropertyTypeHandleclose}
              >
                {propertytypelist?.map((item) => (
                  <MenuItem
                    key={item.pt_propertyTypeCode}
                    className={classes.menuItem}
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={item?.pt_propertyTypeCode}
                  >
                    {item?.pt_propertyType}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {errorMessagePropertyType.error && (
              <FormHelperText
                style={{ color: '#d32f2f', fontFamily: 'poppins' }}
              >
                {errorMessagePropertyType.helperText}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
            <FormLabel required sx={typography_textfield} variant="h6">
              Address
            </FormLabel>
            <PropertyAddressField
              latitude={latitude}
              setLatitude={setLatitude}
              longitude={longitude}
              setLongitude={setLongitude}
              selectedWalkScores={selectedWalkScores}
              setSelectedWalkScores={setSelectedWalkScores}
              unitNumber={unitNumber}
              setUnitNumber={setUnitNumber}
              streetNumber={streetNumber}
              setStreetNumber={setStreetNumber}
              streetName={streetName}
              setStreetName={setStreetName}
              selectedStreetType={selectedStreetType}
              setSelectedStreetType={setSelectedStreetType}
              selectedStreetTypeabbrev={selectedStreetTypeabbrev}
              setSelectedStreetTypeabbrev={setSelectedStreetTypeabbrev}
              town={town}
              setTown={setTown}
              selectedState={selectedState}
              setSelectedState={setSelectedState}
              postCode={postCode}
              setPostCode={setPostCode}
              options={options}
              setErrorforaddress={setErrorforaddress}
              errorforaddress={errorforaddress}
              addressref={addressref}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <FormControl style={{ display: 'flex' }}>
              <FormLabel sx={typography_textfield} required>
                <img alt="bed" src={bed} style={icon} />
                Bedrooms
              </FormLabel>
              <InputLabel
                focused={false}
                shrink={false}
                variant="h4"
                className={classes.inputLabel}
                htmlFor="bedroom-count-select"
                sx={{
                  visibility: bedroomcount ? 'hidden' : 'visible',
                  color: 'rgba(0, 0, 0, 0.30)',
                  fontWeight: 300,
                }}
              >
                Select number of bedrooms
              </InputLabel>
              <Select
                style={{ marginTop: '10px', fontFamily: 'poppins' }}
                ref={bedroomref}
                fullWidth
                className={classes.PropertydropDown}
                inputProps={{ id: 'bedroom-count-select' }}
                error={errorMessageBedroom.error}
                disableUnderline
                sx={[
                  // select_dropdown,
                  {
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(0, 85, 255, 0.64)',
                    },
                  },
                ]}
                IconComponent={ExpandMoreIcon}
                value={bedroomcount}
                onChange={handleChange3}
              >
                <MenuItem className={classes.menuItem} value={'0'}>
                  Studio
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'1'}>
                  1
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'2'}>
                  2
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'3'}>
                  3
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'4'}>
                  4
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'5'}>
                  5
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'6'}>
                  6
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'7'}>
                  7
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'8'}>
                  8
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'9'}>
                  9
                </MenuItem>
                {/* <MenuItem className={classes.menuItem} value={'9+'}>
                  10 or more
                </MenuItem> */}
              </Select>
            </FormControl>
            {errorMessageBedroom.error && (
              <FormHelperText
                style={{ color: '#d32f2f', fontFamily: 'poppins' }}
              >
                {errorMessageBedroom.helperText}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <FormControl style={{ display: 'flex' }}>
              <FormLabel sx={typography_textfield} required>
                <img alt="bathroom" src={bathroom} style={icon} />
                Bathrooms
              </FormLabel>
              <InputLabel
                focused={false}
                shrink={false}
                variant="h4"
                htmlFor="bathroom-count-select"
                sx={{
                  fontFamily: 'poppins',
                  marginTop: matchessm ? '25px' : '35px',
                  marginLeft: '20px',
                  color: 'rgba(0, 0, 0, 0.30)',
                  fontWeight: 300,
                  visibility: bathroomcount ? 'hidden' : 'visible',
                }}
              >
                Select number of bathrooms
              </InputLabel>
              <Select
                ref={bathroomref}
                style={{ marginTop: '10px', fontFamily: 'poppins' }}
                inputProps={{
                  id: 'bathroom-count-select',
                }}
                fullWidth
                className={classes.PropertydropDown}
                error={errorMessageBathroom.error}
                disableUnderline
                sx={[
                  // select_dropdown,
                  {
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(0, 85, 255, 0.64)',
                    },
                  },
                ]}
                IconComponent={ExpandMoreIcon}
                value={bathroomcount}
                onChange={handleChange4}
              >
                <MenuItem className={classes.menuItem} value={'1'}>
                  1
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'2'}>
                  2
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'3'}>
                  3
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'4'}>
                  4
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'5'}>
                  5
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'6'}>
                  6
                </MenuItem>
                {/* <MenuItem className={classes.menuItem} value={'6+'}>
                  7 or more
                </MenuItem> */}
              </Select>
            </FormControl>
            {errorMessageBathroom.error && (
              <FormHelperText
                style={{ color: '#d32f2f', fontFamily: 'poppins' }}
              >
                {errorMessageBathroom.helperText}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <FormControl style={{ display: 'flex' }}>
              <FormLabel sx={typography_textfield} required>
                <img alt="car" src={carGarage} style={icon} />
                Parking Space
              </FormLabel>
              <InputLabel
                focused={false}
                shrink={false}
                variant="h4"
                htmlFor="parking-count-select"
                sx={{
                  fontFamily: 'poppins',
                  marginTop: matchessm ? '25px' : '35px',
                  marginLeft: '20px',
                  color: 'rgba(0, 0, 0, 0.30)',
                  fontWeight: 300,
                  visibility: carparking ? 'hidden' : 'visible',
                }}
              >
                Number of parking spaces
              </InputLabel>
              <Select
                ref={parkingref}
                inputProps={{
                  id: 'parking-count-select',
                }}
                style={{ marginTop: '10px' }}
                fullWidth
                className={classes.PropertydropDown}
                error={errorMessageCar.error}
                disableUnderline
                sx={[
                  // select_dropdown,
                  {
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(0, 85, 255, 0.64)',
                    },
                  },
                ]}
                IconComponent={ExpandMoreIcon}
                value={carparking}
                onChange={handleChange5}
              >
                <MenuItem className={classes.menuItem} value={'0'}>
                  0
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'1'}>
                  1
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'2'}>
                  2
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'3'}>
                  3{' '}
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'4'}>
                  4
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'5'}>
                  5
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'6'}>
                  6
                </MenuItem>
                {/* <MenuItem className={classes.menuItem} value={'6+'}>
                  7 or more
                </MenuItem> */}
              </Select>
            </FormControl>
            {errorMessageCar.error && (
              <FormHelperText
                style={{ color: '#d32f2f', fontFamily: 'poppins' }}
              >
                {errorMessageCar.helperText}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}></Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <FormLabel sx={typography_textfield} variant="h6" required>
              Property Title
            </FormLabel>
            {/* <Typography sx={typography_textfield} variant="h6">
              Property Title
            </Typography> */}
            <TextField
              required
              ref={titleref}
              sx={[
                textboxmargin,
                {
                  marginTop: '10px',
                  '& .MuiInputBase-input::placeholder': {
                    textTransform: 'none',
                  },
                },
              ]}
              fullWidth
              // helperText={errorMessageHeading.helperText}
              error={errorMessageHeading.error}
              placeholder="Marketplace display heading"
              id="heading"
              type="input"
              // onKeyDown={handleKeyDown}
              name="heading"
              value={heading}
              onChange={(event) => {
                const input = event.target;
                const start = input.selectionStart;
                const end = input.selectionEnd;

                let inputValue = input.value.trimStart();
                if (inputValue.length > 0) {
                  inputValue =
                    inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
                }

                setHeading(inputValue);
                setErrorMessageHeading({
                  helperText: '',
                  error: false,
                });

                window.requestAnimationFrame(() => {
                  if (input && document.activeElement === input) {
                    input.setSelectionRange(start, end);
                  }
                });
              }}
              inputProps={{
                style: {
                  fontFamily: 'poppins',
                  textTransform: 'capitalize',
                },
              }}
            />
            {errorMessageHeading.error && (
              <FormHelperText
                style={{ color: '#d32f2f', fontFamily: 'poppins' }}
              >
                {errorMessageHeading.helperText}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormLabel sx={typography_textfield} variant="h6" required>
              Property Description
            </FormLabel>
            {/* <Typography sx={typography_textfield} variant="h6">
              Property Description
            </Typography> */}
            {/* <TextField
              sx={[textboxmargin_description, { marginTop: "10px" }]}
              required
              ref={descriptionref}
              multiline={true}
              fullWidth
              rows={10}
              // helperText={errorMessageDescription.helperText}
              error={errorMessageDescription.error}
              placeholder="Enter a full property description for marketplace display"
              id="heading"
              type="input"
              name="heading"
              value={description}
              // onChange={(event) => {
              //   const inputValue = (event.target.value).trimStart();
              //   const toSentenceCase = (str) => {
              //     return str
              //       .toLowerCase()
              //       .split('. ')
              //       .map(sentence => 
              //         sentence.charAt(0).toUpperCase() + sentence.slice(1)
              //       )
              //       .join('. ');
              //   };
            
              //   const sentenceCasedValue = toSentenceCase(inputValue);

              //   setDescription(sentenceCasedValue);
              //   // setDescription(event.target.value);
              //   setErrorMessageDescription({
              //     helperText:"",
              //     error:false
              //   })
              // }}
              onChange={(event) => {
  const input = event.target;
  const start = input.selectionStart;
  const end = input.selectionEnd;

  const inputValue = event.target.value.trimStart();

  const toSentenceCase = (str) => {
    return str
      .toLowerCase()
      .split('. ')
      .map(sentence =>
        sentence.charAt(0).toUpperCase() + sentence.slice(1)
      )
      .join('. ');
  };

  const sentenceCasedValue = toSentenceCase(inputValue);

  setDescription(sentenceCasedValue);
  setErrorMessageDescription({
    helperText: "",
    error: false,
  });

  setTimeout(() => {
    input.setSelectionRange(start, end);
  }, 0);
}}

              inputProps={{
                style: {
                  fontFamily: "poppins",
                  // textTransform: "capitalize",
                },
              }}
            /> */}
            <TextField
              multiline
              fullWidth
              rows={10}
              value={description}
              ref={descriptionref}
              onChange={(e) => {
                const input = e.target;
                const start = input.selectionStart;
                const end = input.selectionEnd;

                let val = input.value;
                if (val.length > 0) {
                  val = val.charAt(0).toUpperCase() + val.slice(1);
                }

                setDescription(val); // ✅ exact text
                setErrorMessageDescription({ helperText: '', error: false });

                window.requestAnimationFrame(() => {
                  if (input && document.activeElement === input) {
                    input.setSelectionRange(start, end);
                  }
                });
              }}
              inputProps={{
                style: {
                  fontFamily: 'poppins',
                  whiteSpace: 'pre-wrap', // ✅ Important to preserve formatting visually
                },
              }}
              sx={[textboxmargin_description, { marginTop: '10px' }]}
            />
            {errorMessageDescription.error && (
              <FormHelperText
                style={{ color: '#d32f2f', fontFamily: 'poppins' }}
              >
                {errorMessageDescription.helperText}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography mb={'15px'} sx={typography_textfield} variant="h6">
              Features
            </Typography>
            <Grid
              container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '30px',
                flexWrap: 'wrap',
                height: matches450
                  ? 'min-content'
                  : matches600
                  ? '900px'
                  : '600px',
              }}
            >
              {featurelist?.map((item) => (
                <Grid item key={item.fea_code}>
                  <Stack flexDirection={'row'}>
                    <input
                      id={`feature-${item.fea_code}`}
                      type="checkbox"
                      checked={feature.includes(item.fea_code)}
                      onChange={(event) => handleCheckboxChange(event, item)}
                      style={{
                        width: '17px',
                        height: '17px',
                        position: 'relative',
                      }}
                    />

                    <label
                      htmlFor={`feature-${item.fea_code}`}
                      style={{ cursor: 'pointer' }}
                    >
                      <Typography sx={checkbox_style}>
                        &nbsp; {item.fea_Name}
                      </Typography>
                    </label>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormLabel sx={typography_textfield} required>
              Banner Images
            </FormLabel>
          </Grid>
          {!imageUrl.length > 0 && (
            <Grid
              gap={2}
              item
              xs={12}
              sm={12}
              md={2.3}
              lg={2.3}
              xl={2.3}
              ref={imagesref}
            >
              <DropZone
                {...getRootProps()}
                isDragAccept={isDragAccept}
                isDragReject={isDragReject}
                sx={{ border: errorimageUrl?.error && '1px solid #d32f2f' }}
              >
                <p className={classes.pdfUploadText}>
                  {isDragAccept ? (
                    'All files are accepted'
                  ) : isDragReject ? (
                    ''
                  ) : (
                    <>
                      <AddCircleOutlineIcon
                        style={{
                          color: errorimageUrl?.error ? '#d32f2f' : '#965CF0',
                          fontSize: '25px',
                        }}
                      />
                      <br />{' '}
                      <span
                        style={{
                          color: errorimageUrl?.error ? '#d32f2f' : '#965CF0',
                        }}
                      >
                        Upload or Drag here
                      </span>
                    </>
                  )}
                  {/* {!isDragAccept && !isDragReject && <AddIcon style={{width:'100px'}}/>} */}
                </p>
                {/* <input {...getInputProps()} /> */}

                <input {...getInputProps()} accept=".jpg,.jpeg,.png" />
                {/* Display the list of accepted files with delete buttons */}
              </DropZone>
              {/* <FormHelperText
                style={{
                  color: '#d32f2f',
                  fontFamily: 'Poppins',
                  marginTop: '-10px',
                }}
              >
                {errorimageUrl?.error && errorimageUrl?.helperText}
              </FormHelperText> */}
            </Grid>
          )}

          {imageUrl?.map(function (image, index) {
            return (
              <Grid
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '15px',
                }}
                className={classes.MaxPdfBox}
                key={index}
                item
                xs={12}
                sm={10}
                md={5}
                lg={4}
                xl={3.3}
              >
                <div
                  onDragOver={(event) => event.preventDefault()}
                  onDrop={(event) => dropWord(event, image)}
                  style={{ width: '100%', position: 'relative' }}
                >
                  <div
                    className="mover boxA"
                    draggable="true"
                    onDragStart={(e) => {
                      e.dataTransfer.setData('image', JSON.stringify(image));
                      dragWord(image);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      width: '100%',
                    }}
                  >
                    <ImagePreviewCard image={image} />

                    <div
                      onClick={() => {
                        if (loading) return;
                        removeImgHandler(image);
                      }}
                      style={{
                        position: 'absolute',
                        top: '-12px',
                        right: '-12px',
                        zIndex: 10,
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        background: 'linear-gradient(145deg, #ffffff, #e6e6e6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        opacity: loading ? 0.5 : 1,
                        boxShadow:
                          '0 8px 12px -4px rgba(0,0,0,0.3), 0 4px 8px 0 rgba(0,0,0,0.2), inset 0 -2px 2px rgba(0,0,0,0.1), inset 0 2px 2px rgba(255,255,255,0.8)',
                        border: 'none',
                        transform: 'translateY(-1px)',
                        transition: 'all 0.2s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow =
                          '0 10px 14px -4px rgba(0,0,0,0.4), 0 6px 10px 0 rgba(0,0,0,0.25), inset 0 -2px 2px rgba(0,0,0,0.1), inset 0 2px 2px rgba(255,255,255,0.8)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow =
                          '0 8px 12px -4px rgba(0,0,0,0.3), 0 4px 8px 0 rgba(0,0,0,0.2), inset 0 -2px 2px rgba(0,0,0,0.1), inset 0 2px 2px rgba(255,255,255,0.8)';
                      }}
                    >
                      <CancelIcon
                        style={{
                          width: '18px',
                          height: '18px',
                          color: '#555555',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            );
          })}

          {/* Error message container for banner images */}
          {/* Error message container for banner images */}
          {errorimageUrl?.error && (
            <Grid item xs={12}>
              <FormHelperText
                style={{
                  color: '#d32f2f',
                  fontFamily: 'Poppins',
                  margin: '-12px 0 0 0',
                  fontSize: '14px',
                  textAlign: 'left',
                }}
              >
                {errorimageUrl?.helperText}
              </FormHelperText>
            </Grid>
          )}

          {!imageUrl.length == 0 && (
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              lg={2}
              xl={2}
              display={'flex'}
              alignItems={'center'}
            >
              <Button
                style={{
                  //  marginTop: "20px",
                  // marginLeft: "15px",
                  width: '72px',
                  height: '59px',
                  fontFamily: 'Poppins',
                  // border: "1px solid rgba(175, 5, 255, 1)",
                  textTransform: 'inherit',
                  borderRadius: '5px',
                  color: '#737497',
                  background: '#f0e9fa',
                  // cursor: "not-allowed",
                  marginRight: '25px',
                  fontSize: '36px',
                  fontWeight: 300,
                }}
                onClick={handleButtonClickss}
              >
                +
              </Button>
              <div>
                <div {...getRootProps()}>
                  <input
                    {...getInputProps()}
                    ref={mergeRefs(getInputProps().ref, inputRefBanner)}
                  />
                </div>
              </div>
            </Grid>
          )}

          {/* Card Images Section */}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormLabel sx={typography_textfield} required>
              Card Images
            </FormLabel>
          </Grid>

          {!imageUrlSecondary.length > 0 && (
            <Grid
              gap={2}
              item
              xs={12}
              sm={12}
              md={2.3}
              lg={2.3}
              xl={2.3}
              ref={secimagesref}
            >
              <DropZone
                {...getRootPropsSecondary()}
                isDragAccept={isDragAcceptSecondary}
                isDragReject={isDragRejectSecondary}
                sx={{
                  border: errorimageUrlSecondary?.error && '1px solid #d32f2f',
                }}
              >
                <p className={classes.pdfUploadText}>
                  {isDragAcceptSecondary ? (
                    'All files are accepted'
                  ) : isDragRejectSecondary ? (
                    ''
                  ) : (
                    <>
                      <AddCircleOutlineIcon
                        style={{
                          color: errorimageUrlSecondary?.error
                            ? '#d32f2f'
                            : '#965CF0',
                          fontSize: '25px',
                        }}
                      />
                      <br />
                      <span
                        style={{
                          color: errorimageUrlSecondary?.error
                            ? '#d32f2f'
                            : '#965CF0',
                        }}
                      >
                        Upload or Drag here
                      </span>
                    </>
                  )}
                </p>
                <input {...getInputPropsSecondary()} />
              </DropZone>
              {/* <FormHelperText
                style={{
                  color: '#d32f2f',
                  fontFamily: 'Poppins',
                  marginTop: '-10px',
                }}
              >
                {errorimageUrlSecondary?.error &&
                  errorimageUrlSecondary?.helperText}
              </FormHelperText> */}
            </Grid>
          )}
          {imageUrlSecondary?.map(function (image, index) {
            return (
              <Grid
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: '15px',
                }}
                className={classes.MaxPdfBox}
                key={index}
                item
                xs={12}
                sm={4}
                md={3.6}
                lg={2}
                xl={2}
              >
                <div
                  onDragOver={(event) => event.preventDefault()}
                  onDrop={(event) => dropWords(event, image)}
                  style={{ width: '100%', position: 'relative' }}
                >
                  <div
                    className="mover boxA"
                    draggable="true"
                    onDragStart={(e) => {
                      e.dataTransfer.setData('image', JSON.stringify(image));
                      dragWord(image);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      width: '100%',
                    }}
                  >
                    <ImagePreviewCard image={image} />

                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (loading) return;
                        removeImgHandlerSecondary(image, index);
                      }}
                      style={{
                        position: 'absolute',
                        top: '-12px',
                        right: '-12px',
                        zIndex: 10,
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        background: 'linear-gradient(145deg, #ffffff, #e6e6e6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        opacity: loading ? 0.5 : 1,
                        boxShadow:
                          '0 8px 12px -4px rgba(0,0,0,0.3), 0 4px 8px 0 rgba(0,0,0,0.2), inset 0 -2px 2px rgba(0,0,0,0.1), inset 0 2px 2px rgba(255,255,255,0.8)',
                        border: 'none',
                        transform: 'translateY(-1px)',
                        transition: 'all 0.2s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow =
                          '0 10px 14px -4px rgba(0,0,0,0.4), 0 6px 10px 0 rgba(0,0,0,0.25), inset 0 -2px 2px rgba(0,0,0,0.1), inset 0 2px 2px rgba(255,255,255,0.8)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow =
                          '0 8px 12px -4px rgba(0,0,0,0.3), 0 4px 8px 0 rgba(0,0,0,0.2), inset 0 -2px 2px rgba(0,0,0,0.1), inset 0 2px 2px rgba(255,255,255,0.8)';
                      }}
                    >
                      <CancelIcon
                        style={{
                          width: '18px',
                          height: '18px',
                          color: '#555555',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            );
          })}

          {/* Error message container - moved outside and positioned properly */}
          {/* Error message container for card images */}
          {errorimageUrlSecondary?.error && (
            <Grid item xs={12}>
              <FormHelperText
                style={{
                  color: '#d32f2f',
                  fontFamily: 'Poppins',
                  margin: '-12px 0 0 0',
                  fontSize: '14px',
                  textAlign: 'left',
                }}
              >
                {errorimageUrlSecondary?.helperText}
              </FormHelperText>
            </Grid>
          )}

          {!imageUrlSecondary.length == 0 && (
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              lg={2}
              xl={2}
              display={'flex'}
              alignItems={'center'}
            >
              <Button
                style={{
                  width: '72px',
                  height: '59px',
                  fontFamily: 'Poppins',
                  textTransform: 'inherit',
                  borderRadius: '5px',
                  color: '#737497',
                  background: '#f0e9fa',
                  marginRight: '25px',
                  fontSize: '36px',
                  fontWeight: 300,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleButtonClicks();
                }}
              >
                +
              </Button>

              <div>
                <div {...getRootPropsSecondary()}>
                  <input
                    {...getInputPropsSecondary()}
                    ref={mergeRefs(
                      getInputPropsSecondary().ref,
                      inputRefSecondary
                    )}
                  />
                </div>
              </div>
            </Grid>
          )}

          {/* ---------------- Property Video Section ---------------- */}
          <Grid
            ref={propertyVideoSectionRef}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <FormLabel sx={typography_textfield}>Property Video</FormLabel>
          </Grid>

          {!propertyVideo && (
            <Grid gap={2} item xs={12} sm={12} md={4} lg={4} xl={4}>
              <DropZone
                {...getRootPropsPropertyVideo()}
                isDragAccept={isDragAcceptPropertyVideo}
                isDragReject={isDragRejectPropertyVideo}
                sx={{
                  border: errorPropertyVideo?.error && '1px solid #d32f2f',
                }}
              >
                <p className={classes.pdfUploadText}>
                  {isDragAcceptPropertyVideo ? (
                    'Video file accepted'
                  ) : isDragRejectPropertyVideo ? (
                    ''
                  ) : (
                    <>
                      <AddCircleOutlineIcon
                        style={{
                          color: errorPropertyVideo?.error
                            ? '#d32f2f'
                            : '#965CF0',
                          fontSize: '25px',
                        }}
                      />
                      <br />
                      <span
                        style={{
                          color: errorPropertyVideo?.error
                            ? '#d32f2f'
                            : '#965CF0',
                        }}
                      >
                        Upload or Drag video here
                      </span>
                    </>
                  )}
                </p>
                <input
                  {...getInputPropsPropertyVideo()}
                  ref={mergeRefs(
                    getInputPropsPropertyVideo().ref,
                    propertyVideoRef
                  )}
                />
              </DropZone>
            </Grid>
          )}

          {propertyVideo && (
            <Grid
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '15px',
              }}
              className={classes.MaxPdfBox}
              item
              xs={12}
              sm={10}
              md={5}
              lg={4}
              xl={4}
            >
              <div style={{ width: '100%', position: 'relative' }}>
                <VideoPreviewCard video={propertyVideo} />
                <div
                  onClick={() => {
                    if (loading) return;
                    removePropertyVideo();
                  }}
                  style={{
                    position: 'absolute',
                    top: '-12px',
                    right: '-12px',
                    zIndex: 10,
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    background: 'linear-gradient(145deg, #ffffff, #e6e6e6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.5 : 1,
                    boxShadow:
                      '0 8px 12px -4px rgba(0,0,0,0.3), 0 4px 8px 0 rgba(0,0,0,0.2), inset 0 -2px 2px rgba(0,0,0,0.1), inset 0 2px 2px rgba(255,255,255,0.8)',
                    border: 'none',
                    transition: 'all 0.2s ease',
                  }}
                >
                  <CancelIcon
                    style={{
                      width: '18px',
                      height: '18px',
                      color: '#555555',
                    }}
                  />
                </div>
              </div>
            </Grid>
          )}

          {errorPropertyVideo?.error && (
            <Grid item xs={12}>
              <FormHelperText
                style={{
                  color: '#d32f2f',
                  fontFamily: 'Poppins',
                  margin: '-12px 0 0 0',
                  fontSize: '14px',
                  textAlign: 'left',
                }}
              >
                {errorPropertyVideo?.helperText}
              </FormHelperText>
            </Grid>
          )}

          {/* ---------------- 360° Tour Video Section ---------------- */}
          <Grid
            ref={tour360VideoSectionRef}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <FormLabel sx={typography_textfield}>360° Tour Video</FormLabel>
          </Grid>

          {!tour360Video && (
            <Grid gap={2} item xs={12} sm={12} md={4} lg={4} xl={4}>
              <DropZone
                {...getRootPropsTour360Video()}
                isDragAccept={isDragAcceptTour360Video}
                isDragReject={isDragRejectTour360Video}
                sx={{
                  border: errorTour360Video?.error && '1px solid #d32f2f',
                }}
              >
                <p className={classes.pdfUploadText}>
                  {isDragAcceptTour360Video ? (
                    'Video file accepted'
                  ) : isDragRejectTour360Video ? (
                    ''
                  ) : (
                    <>
                      <AddCircleOutlineIcon
                        style={{
                          color: errorTour360Video?.error
                            ? '#d32f2f'
                            : '#965CF0',
                          fontSize: '25px',
                        }}
                      />
                      <br />
                      <span
                        style={{
                          color: errorTour360Video?.error
                            ? '#d32f2f'
                            : '#965CF0',
                        }}
                      >
                        Upload or Drag 360° video here
                      </span>
                    </>
                  )}
                </p>
                <input
                  {...getInputPropsTour360Video()}
                  ref={mergeRefs(
                    getInputPropsTour360Video().ref,
                    tour360VideoRef
                  )}
                />
              </DropZone>
            </Grid>
          )}

          {tour360Video && (
            <Grid
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '15px',
              }}
              className={classes.MaxPdfBox}
              item
              xs={12}
              sm={10}
              md={5}
              lg={4}
              xl={4}
            >
              <div style={{ width: '100%', position: 'relative' }}>
                <VideoPreviewCard video={tour360Video} />
                <div
                  onClick={() => {
                    if (loading) return;
                    removeTour360Video();
                  }}
                  style={{
                    position: 'absolute',
                    top: '-12px',
                    right: '-12px',
                    zIndex: 10,
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    background: 'linear-gradient(145deg, #ffffff, #e6e6e6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.5 : 1,
                    boxShadow:
                      '0 8px 12px -4px rgba(0,0,0,0.3), 0 4px 8px 0 rgba(0,0,0,0.2), inset 0 -2px 2px rgba(0,0,0,0.1), inset 0 2px 2px rgba(255,255,255,0.8)',
                    border: 'none',
                    transition: 'all 0.2s ease',
                  }}
                >
                  <CancelIcon
                    style={{
                      width: '18px',
                      height: '18px',
                      color: '#555555',
                    }}
                  />
                </div>
              </div>
            </Grid>
          )}

          {errorTour360Video?.error && (
            <Grid item xs={12}>
              <FormHelperText
                style={{
                  color: '#d32f2f',
                  fontFamily: 'Poppins',
                  margin: '-12px 0 0 0',
                  fontSize: '14px',
                  textAlign: 'left',
                }}
              >
                {errorTour360Video?.helperText}
              </FormHelperText>
            </Grid>
          )}

          {/* <Grid item xs={12} sm={12} md={5.7} lg={5.7} xl={5.7}></Grid> */}
          {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}></Grid> */}
          {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <Typography sx={typography_textfield} variant="h6">
              <img alt="landArea" src={landArea} style={icon_land} />
              Land Area
            </Typography>
            <TextField
              required
              sx={textboxmargin}
              placeholder="Enter Total Area"
              helperText={errorMessageLandArea.helperText}
              error={errorMessageLandArea.error}
              className={classes.noSpinArrows}
              id="land"
              type="number"
              name="land"
              onKeyPress={handleKeyPress}
              fullWidth
              value={landarea}
              onChange={(event) => {
                const inputValue = event.target.value;
                setLandarea(inputValue);
              }}
            />
            {errorMessageLandArea && (
              <div>{errorMessageLandArea.error}</div>
            )}
          </Grid> */}

          <Grid
            container
            sx={{ paddingLeft: '16px', paddingTop: '15px', gap: '16px' }}
          >
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <FormLabel
                sx={typography_textfield}
                variant="h6"
                required={propertyTypeCode === 'type003'}
              >
                Land Size{' '}
                <span style={{ fontSize: matchesmd ? '14px' : '18px' }}>
                  (sq.m.)
                </span>
              </FormLabel>
              <TextField
                required={propertyTypeCode === 'type003'}
                ref={landsizeref}
                sx={textboxmargin}
                placeholder="Example: 850"
                error={errorMessageLandSize.error}
                id="land area"
                type="text"
                // type="number"
                onKeyPress={handleKeyPress}
                name="land area"
                fullWidth
                className={classes.noSpinArrows}
                value={landsize}
                onChange={(event) => {
                  let value = event.target.value;

                  // Allow only digits
                  value = value.replace(/[^0-9]/g, '');

                  // If current value is already '0', ignore additional zeros
                  if (landsize === '0' && value === '00') {
                    return;
                  }

                  if (value === '') {
                    // Empty input
                    setLandsize('');
                  } else if (value === '0') {
                    // Single zero allowed
                    setLandsize('0');
                  } else {
                    // Remove leading zeros for any number > 0
                    value = value.replace(/^0+/, '');
                    value = Number(value).toLocaleString('en-US');
                    setLandsize(value);
                  }

                  setErrorMessageLandSize({
                    helperText: '',
                    error: false,
                  });
                }}
                onKeyDown={(event) => {
                  if (['e', 'E', '+', '-', '.'].includes(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              {errorMessageLandSize.error && (
                <FormHelperText
                  style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                >
                  {errorMessageLandSize.helperText}
                </FormHelperText>
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <FormLabel
                sx={typography_textfield}
                variant="h6"
                required={propertyTypeCode === 'type001'}
              >
                Internal Size{' '}
                <span style={{ fontSize: matchesmd ? '14px' : '18px' }}>
                  (sq.m.)
                </span>
              </FormLabel>
              <TextField
                required={propertyTypeCode === 'type001'}
                sx={textboxmargin}
                ref={internalsizeref}
                placeholder="Example: 245"
                error={errorMessageInternalSize.error}
                id="Internal size"
                type="text"
                // type="number"
                onKeyPress={handleKeyPress}
                name="internal size"
                fullWidth
                className={classes.noSpinArrows}
                value={internalsize}
                // onChange={(event) => {
                //   const inputValue = event.target.value;
                //   setInternalsize(inputValue);
                //   setErrorMessageInternalSize({
                //     helperText:"",
                //     error:false
                //   })
                // }}

                onChange={(event) => {
                  let value = event.target.value;

                  // Allow only digits
                  value = value.replace(/[^0-9]/g, '');

                  // If current value is already '0', ignore additional zeros
                  if (internalsize === '0' && value === '00') {
                    return;
                  }

                  if (value === '') {
                    setInternalsize('');
                  } else if (value === '0') {
                    setInternalsize('0');
                  } else {
                    // Remove leading zeros if the number is > 0
                    value = value.replace(/^0+/, '');
                    value = Number(value).toLocaleString('en-US');
                    setInternalsize(value);
                  }

                  setErrorMessageInternalSize({
                    helperText: '',
                    error: false,
                  });
                }}
                onKeyDown={(event) => {
                  if (['e', 'E', '+', '-', '.'].includes(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              {errorMessageInternalSize.error && (
                <FormHelperText
                  style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                >
                  {errorMessageInternalSize.helperText}
                </FormHelperText>
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <FormLabel
                sx={typography_textfield}
                variant="h6"
                required={propertyTypeCode === 'type003'}
              >
                Building Size{' '}
                <span style={{ fontSize: matchesmd ? '14px' : '18px' }}>
                  (sq.m.)
                </span>
              </FormLabel>
              <TextField
                ref={buildingsizeref}
                required={propertyTypeCode === 'type003'}
                sx={textboxmargin}
                placeholder="Example: 600"
                error={errorMessageBuildingSize.error}
                id="building-size"
                // type="number"
                type="text"
                onKeyPress={handleKeyPress}
                name="building-size"
                fullWidth
                className={classes.noSpinArrows}
                value={buildingSize}
                // onChange={(event) => {
                //   const inputValue = event.target.value;
                //   setBuildingSize(inputValue);
                //   setErrorMessageBuildingSize({
                //     helperText:"",
                //     error:false
                //   })
                // }}

                onChange={(event) => {
                  let value = event.target.value;

                  // Allow only digits
                  value = value.replace(/[^0-9]/g, '');

                  // If current value is already '0', ignore additional zeros
                  if (buildingSize === '0' && value === '00') {
                    return;
                  }

                  if (value === '') {
                    setBuildingSize('');
                  } else if (value === '0') {
                    setBuildingSize('0');
                  } else {
                    // Remove leading zeros if the number is > 0
                    value = value.replace(/^0+/, '');
                    value = Number(value).toLocaleString('en-US');
                    setBuildingSize(value);
                  }

                  setErrorMessageBuildingSize({
                    helperText: '',
                    error: false,
                  });
                }}
                onKeyDown={(event) => {
                  if (['e', 'E', '+', '-', '.'].includes(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              {errorMessageBuildingSize.error && (
                <FormHelperText
                  style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                >
                  {errorMessageBuildingSize.helperText}
                </FormHelperText>
              )}
            </Grid>

            {propertyTypeCode === 'type001' ? (
              <>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Typography sx={typography_textfield} variant="h6">
                    Lot
                  </Typography>
                  <TextField
                    sx={textboxmargin}
                    fullWidth
                    required
                    helperText={errorMessageLot.helperText}
                    error={errorMessageLot.error}
                    placeholder="Example: 600"
                    id="lot-number"
                    type="number"
                    inputProps={{ maxLength: 5 }}
                    name="lot-number"
                    value={lotNumber}
                    onChange={handleChangeLotNumber}
                  />
                  {errorMessageLot.error && (
                    <div>{errorMessageLot.helperText}</div>
                  )}
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Typography sx={typography_textfield} variant="h6">
                    SP (Strata Plan)
                  </Typography>
                  <TextField
                    sx={textboxmargin}
                    fullWidth
                    required
                    helperText={errorMessageSP.helperText}
                    error={errorMessageSP.error}
                    placeholder="Example: 427865"
                    id="sp"
                    type="input"
                    inputProps={{
                      // pattern: "[a-zA-Z]*",
                      pattern: '^SP\\d{1,10}$',
                      inputMode: 'text',
                      maxLength: 10,
                    }}
                    name="sp"
                    value={sp}
                    onChange={handleChangeSP}
                  />
                  {errorMessageSP.error && (
                    <div>{errorMessageSP.helperText}</div>
                  )}
                </Grid>
              </>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={2.55}
                lg={2.55}
                xl={2.55}
                sx={{ mt: '-3px' }}
              >
                <Typography sx={typography_textfield} variant="h6">
                  DP (Deposit Plan)
                </Typography>
                <TextField
                  sx={textboxmargin}
                  fullWidth
                  required
                  helperText={errorMessageDP.helperText}
                  error={errorMessageDP.error}
                  placeholder="Example: 5006"
                  id="dp"
                  type="input"
                  inputProps={{
                    // pattern: "[a-zA-Z]*",
                    // inputMode: "text",
                    maxLength: 10,
                  }}
                  name="dp"
                  value={dp}
                  onChange={handleChangeDP}
                  onKeyDown={(event) => {
                    if (['e', 'E', '+', '-', '.'].includes(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                {errorMessageDP.error && <div>{errorMessageDP.helperText}</div>}
              </Grid>
            )}
          </Grid>

          {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <FormLabel sx={typography_textfield} variant="h6">
              Virtual Tour link
            </FormLabel>
            <TextField
              sx={{
                ...textboxmargin,
                '& .MuiInputBase-input::placeholder': {
                  textTransform: 'none',
                },
              }}
              fullWidth
              helperText={errorMessageVideoUrl.helperText}
              error={errorMessageVideoUrl.error}
              style={{ marginTop: '8px' }}
              placeholder="Enter link to virtual tour"
              id="name"
              type="input"
              name="name"
              value={videoUrl}
              onChange={(event) => {
                const link = event.target.value.trimStart();
                event.target.value = link;
                setVideoUrl(event.target.value);
              }}
            />
            {errorMessageVideoUrl && <div>{errorMessageVideoUrl.error}</div>}
          </Grid> */}

          <Grid
            container
            sx={{
              paddingX: '16px',
              paddingTop: '15px',
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '20px',
            }}
          >
            {propertyTypeCode === 'type001' && (
              <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                <FormLabel sx={typography_textfield} variant="h6">
                  Strata Levies{' '}
                  <span style={{ fontSize: '18px' }}>(Quarterly)</span>
                </FormLabel>
                <TextField
                  sx={textboxmargin}
                  fullWidth
                  style={{ width: matches900 && '102%' }}
                  placeholder="Example: $2500"
                  id="strataLevies"
                  // type="number"
                  name="strataLevies"
                  value={formattedstrataLevies}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  onChange={handlestrataLevies}
                  onKeyPress={handleKey}
                  inputProps={{
                    maxLength: 7,
                    style: { fontFamily: 'poppins' },
                  }}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
              <FormLabel sx={typography_textfield} required variant="h6">
                Council Rates{' '}
                <span style={{ fontSize: '18px' }}>(Quarterly)</span>
              </FormLabel>
              <TextField
                required
                ref={councilrateref}
                sx={textboxmargin}
                style={{ width: matches900 && '104.8%' }}
                fullWidth
                placeholder="Example $320"
                error={errorMessagecouncilrate.error}
                id="councilRate"
                // type="number"
                name="councilRate"
                value={formattedcouncilRate}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
                onChange={handlecouncilRate}
                onKeyPress={handleKey}
                inputProps={{ maxLength: 7, style: { fontFamily: 'poppins' } }}
              />
              {errorMessagecouncilrate.error && (
                <FormHelperText
                  style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                >
                  {errorMessagecouncilrate.helperText}
                </FormHelperText>
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
              <FormLabel sx={typography_textfield} required variant="h6">
                Water Rates{' '}
                <span style={{ fontSize: '18px' }}>(Quarterly)</span>
              </FormLabel>
              <TextField
                required
                ref={waterrateref}
                sx={textboxmargin}
                style={{ width: matches900 && '104.8%' }}
                fullWidth
                placeholder="Example: $174"
                error={errorMessagewaterrate.error}
                id="waterRates"
                // type="number"
                name="waterRates"
                value={formattedwaterRates}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
                onChange={handlewaterRates}
                onKeyPress={handleKey}
                inputProps={{ maxLength: 7, style: { fontFamily: 'poppins' } }}
              />
              {errorMessagewaterrate.error && (
                <FormHelperText
                  style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                >
                  {errorMessagewaterrate.helperText}
                </FormHelperText>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}></Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography className={classes.PropertyTitle}>
              General Campaign
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
            <FormControl style={{ display: 'flex' }}>
              <FormLabel sx={typography_textfield} required>
                Campaign Type
              </FormLabel>
              <InputLabel
                focused={false}
                shrink={false}
                variant="h4"
                htmlFor="campaign-count-select"
                sx={{
                  fontFamily: 'poppins',
                  marginTop: matchessm ? '20px' : '30px',
                  marginLeft: '20px',
                  color: 'rgba(0, 0, 0, 0.30)',
                  fontWeight: 300,
                  visibility:
                    campaign || isSelectFocusedCampaign ? 'hidden' : 'visible',
                }}
              >
                Select campaign type
              </InputLabel>
              <Select
                inputProps={{
                  id: 'campaign-count-select',
                }}
                required
                fullWidth
                ref={campaignttyperef}
                error={errorMessagecampaigntype.error}
                disableUnderline
                sx={
                  (select_dropdown,
                  {
                    marginTop: '5px',
                    fontFamily: 'poppins',
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(0, 85, 255, 0.64)',
                    },
                  })
                }
                IconComponent={ExpandMoreIcon}
                value={campaign}
                onChange={handleChange_campaign}
                open={isSelectFocusedCampaign}
                onClose={() => setTimeout(() => CampaignTypeHandleclose(), 50)}
                onMouseDown={() => {
                  CampaignTypeHandleOpen();
                }}
                onFocus={CampaignTypeHandleOpen}
                onBlur={CampaignTypeHandleclose}
              >
                <MenuItem
                  className={classes.menuItem}
                  value={'Auction'}
                  onClick={() => {
                    setAuction(true);
                    setCampaign('Auction');
                    setForSale(false);
                  }}
                >
                  Auction
                </MenuItem>
                <MenuItem
                  className={classes.menuItem}
                  value={'For Sale'}
                  onClick={() => {
                    setAuction(false);
                    setCampaign('For Sale');
                    setForSale(true);
                  }}
                >
                  For Sale
                </MenuItem>
              </Select>
            </FormControl>
            {errorMessagecampaigntype.error && (
              <FormHelperText
                style={{ color: '#d32f2f', fontFamily: 'poppins' }}
              >
                {errorMessagecampaigntype.helperText}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={9} xl={9}></Grid>

          {auction && (
            <>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <FormLabel sx={typography_textfield} required>
                  Auction Date
                </FormLabel>
                <div style={{ marginTop: '5px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                      <DatePicker
                        sx={pick_date}
                        ref={auctiondateref}
                        format="DD-MM-YYYY"
                        minDate={dayjs().add(1, 'day')}
                        slotProps={{
                          textField: {
                            // required: true,
                            fullWidth: true,
                            error: errorMessageauctiondate.error,
                          },
                        }}
                        renderInput={(params) => <TextField {...params} />}
                        value={auctiondate ? dayjs(auctiondate) : null}
                        onChange={(newValue) => {
                          let val = newValue
                            ? newValue.format('YYYY-MM-DD')
                            : null;

                          setAuctiondate(val);
                          setErrorMessageauctiondate({
                            helperText: '',
                            error: false,
                          });
                        }}
                        slots={{
                          openPickerIcon: Dateicon,
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                {errorMessageauctiondate.error && (
                  <FormHelperText
                    style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                  >
                    {errorMessageauctiondate.helperText}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <FormLabel sx={typography_textfield} required>
                  Time
                </FormLabel>
                <div style={{ marginTop: '13px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      slotProps={{
                        textField: {
                          // fullWidth: true,
                          placeholder: 'hh:mm',
                          required: false,
                          error: errorMessageAuctionTime.error,
                          // helperText: errorMessageAuctionTime
                          //   ? "Field is required"
                          //   : null,
                        },
                      }}
                      ref={auctiontimeref}
                      fullWidth
                      sx={pick_date}
                      views={['hours', 'minutes']}
                      value={
                        auctiontime
                          ? dayjs(auctiontime)
                          : auctiondate &&
                            dayjs(auctiondate).isSame(dayjs(), 'day')
                          ? dayjs(minDate)
                          : null
                      }
                      onChange={(newValue) => {
                        setAuctiontime(newValue);
                        setErrorMessageAuctionTime({
                          helperText: '',
                          error: false,
                        });
                      }}
                      slots={{
                        openPickerIcon: Timeicon,
                      }}
                      minTime={
                        auctiondate && dayjs(auctiondate).isSame(dayjs(), 'day')
                          ? dayjs(minDate)
                          : dayjs().startOf('day')
                      }
                    />
                  </LocalizationProvider>
                </div>
                {errorMessageAuctionTime.error && (
                  <FormHelperText
                    style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                  >
                    {errorMessageAuctionTime.helperText}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}></Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}></Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                <FormControl style={{ display: 'flex' }}>
                  <FormLabel sx={typography_textfield} required>
                    Venue
                  </FormLabel>
                  <InputLabel
                    variant="h4"
                    htmlFor="venue-select"
                    sx={{
                      fontFamily: 'poppins',
                      marginTop: matchesmd ? '21px' : '30px',
                      marginLeft: matchesmd ? '14px' : '20px',
                      visibility:
                        selectedVenue || isSelectFocusedVenue
                          ? 'hidden'
                          : 'visible',
                    }}
                  >
                    Select auction venue
                  </InputLabel>
                  <Select
                    inputProps={{ id: 'venue-select' }}
                    required
                    ref={venueref}
                    fullWidth
                    disableUnderline
                    error={errorMessageVenue.error}
                    sx={{
                      marginTop: '5px',
                      fontFamily: 'poppins',
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 85, 255, 0.64)',
                      },
                    }}
                    IconComponent={ExpandMoreIcon}
                    value={selectedVenue}
                    onChange={handleChangeVenue}
                    onFocus={() => setSelectFocusedVenue(true)}
                    onBlur={() => setSelectFocusedVenue(false)}
                  >
                    {venueData?.map((venue) => (
                      <MenuItem key={venue.venueId} value={venue.venueId}>
                        {venue.venue}
                      </MenuItem>
                    ))}
                    <MenuItem
                      onClick={handleClickVenueOpen}
                      sx={{
                        fontSize: '16px',
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        color: 'blue',
                      }}
                    >
                      + Add New Venue
                    </MenuItem>
                  </Select>
                </FormControl>
                {errorMessageVenue.error && (
                  <FormHelperText
                    style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                  >
                    {errorMessageVenue.helperText}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dialog
                  open={newVenueAdd}
                  onClose={handleClickVenueClose}
                  maxWidth="sm"
                  fullWidth
                >
                  <DialogTitle sx={{ fontFamily: 'Poppins', fontSize: '24px' }}>
                    Add New Venue
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <FormLabel sx={typography_textfield} variant="h6">
                            Venue Name
                          </FormLabel>
                          <TextField
                            required
                            sx={{
                              ...textboxmargin,
                              '& .MuiInputBase-input::placeholder': {
                                textTransform: 'none',
                              },
                            }}
                            fullWidth
                            placeholder="Enter venue name"
                            id="venueName"
                            type="input"
                            name="venueName"
                            value={venueName}
                            onChange={handleVenueNameChange}
                            error={errorMessageVenueName.error}
                            helperText={errorMessageVenueName.helperText}
                          />
                        </Grid>
                      </Grid>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      size="small"
                      className={classes.ModalcancelBtn}
                      sx={{ fontFamily: 'Poppins', fontSize: '16px' }}
                      onClick={handleClickVenueClose}
                      color="primary"
                    >
                      Close
                    </Button>
                    <Button
                      size="small"
                      className={classes.ModalnextBtn}
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: '16px',
                      }}
                      onClick={postDataWithVenueNameAndHeader}
                      color="primary"
                      disabled={loadingVenue}
                    >
                      Confirm
                    </Button>
                    {loadingVenue && (
                      <img
                        alt="Logo"
                        src={Loading}
                        className="loaderImage"
                        style={{
                          height: '40px',
                          width: '40px',
                          marginLeft: '10px',
                        }}
                      />
                    )}
                  </DialogActions>
                </Dialog>
              </Grid>
            </>
          )}

          {forSale && (
            <>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} mt={'3px'}>
                <FormLabel required sx={typography_textfield} variant="h6">
                  {' '}
                  For Sale Price ($){' '}
                </FormLabel>
                <TextField
                  required
                  sx={textboxmargin}
                  placeholder="Example: $2,500,000"
                  ref={salepriceref}
                  error={errorMessageSalePrice.error}
                  // type="number"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  fullWidth
                  className={classes.noSpinArrows}
                  value={formattedSaleprice}
                  inputProps={{
                    inputProps: {
                      style: {
                        marginLeft: '10px',
                      },
                    },
                  }}
                  onChange={(event) => {
                    const input = event.target;
                    const selectionStart = input.selectionStart;
                    const oldValue = input.value;

                    let inputValue = oldValue ?? '';

                    if (typeof inputValue === 'string') {
                      // Extract raw digits and limit to 9
                      inputValue = inputValue.replace(/\D/g, '').slice(0, 9);

                      if (inputValue === '') {
                        setSaleprice('');
                        const [minValue, maxValue] = legalSliderRange;
                        setSliderForSalevalue([minValue, maxValue]);
                        setForSaleMaxSliderValue(
                          calculateMaxSliderValue(maxValue)
                        );
                        // setSliderForSalevalue([
                        //   parseInt(agencyTrueEstimatePrice),
                        //   parseInt(agencyTrueEstimatePrice),
                        // ]);
                        // setForSaleMaxSliderValue(
                        //   calculateMaxSliderValue(
                        //     parseInt(agencyTrueEstimatePrice)
                        //   )
                        // );
                        setErrorMessageSalePrice({
                          helperText: '',
                          error: false,
                        });
                        return;
                      }

                      if (/^0+$/.test(inputValue)) {
                        setErrorMessageSalePrice({
                          helperText: 'Value cannot be all zeros',
                          error: true,
                        });
                        setSaleprice(inputValue); // Keep showing input for user to correct
                        return;
                      }

                      if (inputValue.length <= 9) {
                        setSaleprice(inputValue);
                        const parsedValue = parseInt(inputValue);
                        if (parsedValue) {
                          const minValue = parsedValue - parsedValue * 0.1;
                          const maxValue = parsedValue + parsedValue * 0.1;

                          setSliderForSalevalue([minValue, maxValue]);
                          setForSaleMaxSliderValue(maxValue + maxValue * 0.1);
                        }

                        if (copyToDisplayPrice === true) {
                          setDisplaysaleprice(inputValue);
                        }
                      }

                      setErrorMessageSalePrice({
                        helperText: '',
                        error: false,
                      });

                      // ⏱ Cursor fix logic (after render)
                      requestAnimationFrame(() => {
                        if (
                          input &&
                          typeof input.setSelectionRange === 'function' &&
                          document.activeElement === input
                        ) {
                          // Count digits before cursor from the original input
                          const digitsBeforeCursor = oldValue
                            .slice(0, selectionStart)
                            .replace(/\D/g, '').length;

                          // Create formatted version
                          const formattedValue =
                            inputValue === ''
                              ? ''
                              : Number(inputValue).toLocaleString('en-US');

                          // Find correct cursor position
                          let cursorPos = 0;
                          let digitCount = 0;

                          for (let i = 0; i < formattedValue.length; i++) {
                            if (/\d/.test(formattedValue[i])) {
                              digitCount++;
                            }
                            if (digitCount === digitsBeforeCursor) {
                              cursorPos = i + 1;
                              break;
                            }
                          }

                          if (digitCount < digitsBeforeCursor) {
                            cursorPos = formattedValue.length;
                          }

                          input.setSelectionRange(cursorPos, cursorPos);
                        }
                      });
                    }
                  }}
                />
                {errorMessageSalePrice.error && (
                  <FormHelperText
                    style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                  >
                    {errorMessageSalePrice.helperText}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <Typography
                  sx={{
                    ...typography_textfield,
                    fontSize: matches ? '19px' : typography_textfield.fontSize,
                  }}
                  variant="h6"
                >
                  Alternative display price ($)
                </Typography>
                <TextField
                  required
                  sx={textboxmargin}
                  placeholder="Example: All offers considered"
                  helperText={errorMessageDisplayPrice.helperText}
                  error={errorMessageDisplayPrice.error}
                  // type="number"
                  className={classes.noSpinArrows}
                  fullWidth
                  value={formattedDisplaysaleprice}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  inputProps={{
                    inputProps: {
                      style: {
                        marginLeft: '10px',
                      },
                    },
                  }}
                  onChange={(e) => {
                    const input = e.target;
                    const selectionStart = input.selectionStart;
                    const oldValue = input.value ?? '';

                    let rawValue = oldValue.replace(/\D/g, '').slice(0, 9);

                    if (/^0+$/.test(rawValue)) {
                      setErrorMessageDisplayPrice({
                        helperText: 'Value cannot be all zeros',
                        error: true,
                      });
                    } else {
                      setErrorMessageDisplayPrice({
                        helperText: '',
                        error: false,
                      });
                    }

                    const formattedValue =
                      rawValue === ''
                        ? ''
                        : Number(rawValue).toLocaleString('en-US');
                    // setDisplaysaleprice(formattedValue); // or rawValue if you don't want to display commas
                    setDisplaysaleprice(rawValue); // or rawValue if you don't want to display commas

                    requestAnimationFrame(() => {
                      if (
                        input &&
                        typeof input.setSelectionRange === 'function' &&
                        document.activeElement === input
                      ) {
                        const digitsBeforeCursor = oldValue
                          .slice(0, selectionStart)
                          .replace(/\D/g, '').length;

                        let cursorPos = 0;
                        let digitCount = 0;

                        for (let i = 0; i < formattedValue.length; i++) {
                          if (/\d/.test(formattedValue[i])) {
                            digitCount++;
                          }
                          if (digitCount === digitsBeforeCursor) {
                            cursorPos = i + 1;
                            break;
                          }
                        }

                        if (digitCount < digitsBeforeCursor) {
                          cursorPos = formattedValue.length;
                        }

                        input.setSelectionRange(cursorPos, cursorPos);
                      }
                    });
                  }}
                />

                {errorMessageDisplayPrice && (
                  <div>{errorMessageDisplayPrice.error}</div>
                )}
                <Grid mt={2} onClick={handleCopyToDisplayPriceChange}>
                  <Stack flexDirection={'row'} style={{ cursor: 'pointer' }}>
                    <Typography
                      sx={{
                        ...checkbox_style,
                        ...textboxmargin,
                        '&:hover': {
                          color: '#6d2ad1ff', // Dark purple only when hovering this text
                        },
                        cursor: 'pointer', // Optional: shows pointer cursor on hover
                        transition: 'color 0.2s ease-in-out',
                      }}
                    >
                      &nbsp; Copy to Display For Sale Price
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <FormLabel sx={typography_textfield} variant="h6">
              Market Place Price Range
            </FormLabel>
            {/* {forSale ? ( 
            <Box sx={{ width: 1109, marginTop: "-12px" }}>
              <Box sx={{ m: 3 }} />
              <AirbnbSlider
                required
                slots={{ thumb: AirbnbThumbComponent }}
                value={sliderForSalevalue} // Use value instead of default
                disable={
                  !sliderForSalevalue.includes(sliderForSalevalue[0]) && 
                  !sliderForSalevalue.includes(sliderForSalevalue[1])}
                min={0}
                step={(sliderForSalevalue[0] == 2000000 || sliderForSalevalue[1] == 2000000) 
                  ? 50000 : 10000}
                max={maxForSaleSliderValue}
                valueLabelDisplay="on"
                ValueLabelComponent={ValueLabelComponent}
                getAriaValueText={valueLabelFormat}
                valueLabelFormat={valueLabelFormat}
                onChangeCommitted={handleForSaleChangeforslider }
                // disableSwap
              />
            </Box>) : (<Box sx={{ width: 1109, marginTop: "-12px" }}>
              <Box sx={{ m: 3 }} />
              <AirbnbSlider
                required
                slots={{ thumb: AirbnbThumbComponent }}
                value={slidervalue} // Use value instead of default
                disable={
                  !slidervalue.includes(slidervalue[0]) && 
                  !slidervalue.includes(slidervalue[1])}
                min={100000}
                step={(slidervalue[0] == 2000000 || slidervalue[1] == 2000000) 
                  ? 50000 : 10000}
                max={maxSliderValue}
                valueLabelDisplay="on"
                ValueLabelComponent={ValueLabelComponent}
                getAriaValueText={valueLabelFormat}
                valueLabelFormat={valueLabelFormat}
                onChangeCommitted={handleChangeforslider}
                // disableSwap
              />
            </Box>)} */}
            <Box
              // sx={{ width: "95%", marginTop: "-12px" }}
              sx={{
                position: 'relative',
                paddingTop: '20px',
                width: matches1200 ? '75%' : '97%',
                margin: '0 auto',
              }}
            >
              <Box sx={{ m: 3 }} />
              <AirbnbSlider
                required
                slots={{ thumb: AirbnbThumbComponent }}
                value={sliderForSalevalue} // Use value instead of default
                disable={
                  !sliderForSalevalue.includes(sliderForSalevalue[0]) &&
                  !sliderForSalevalue.includes(sliderForSalevalue[1])
                }
                min={0}
                step={
                  sliderForSalevalue[0] == 2000000 ||
                  sliderForSalevalue[1] == 2000000
                    ? 50000
                    : 10000
                }
                max={maxForSaleSliderValue}
                valueLabelDisplay="off"
                ValueLabelComponent={ValueLabelComponent}
                getAriaValueText={valueLabelFormat}
                valueLabelFormat={valueLabelFormat}
                onChange={handleSliderNewChange}
                // onChangeCommitted={handleForSaleChangeforslider }
                // disableSwap
              />
              {sliderForSalevalue[0] == sliderForSalevalue[1] ? (
                <Typography
                  sx={{
                    position: 'absolute',
                    left: `calc(${
                      (sliderForSalevalue[0] / maxForSaleSliderValue) * 100
                    }% - 20px)`,
                    fontWeight: 500,
                    color: '#000000',
                    fontFamily: 'poppins',
                  }}
                >
                  {valueLabelFormat(sliderForSalevalue[0])}
                </Typography>
              ) : (
                <>
                  <Typography
                    sx={{
                      position: 'absolute',
                      left: `calc(${
                        (sliderForSalevalue[0] / maxForSaleSliderValue) * 100
                      }%)`,
                      transform: 'translateX(-100%)',
                      fontWeight: 500,
                      color: '#000000',
                      fontFamily: 'poppins',
                    }}
                  >
                    {valueLabelFormat(sliderForSalevalue[0])}
                  </Typography>
                  <Typography
                    sx={{
                      position: 'absolute',
                      left: `calc(${
                        (sliderForSalevalue[1] / maxForSaleSliderValue) * 100
                      }%)`,
                      transform: 'translateX(0%)',
                      fontWeight: 500,
                      color: '#000000',
                      fontFamily: 'poppins',
                    }}
                  >
                    {valueLabelFormat(sliderForSalevalue[1])}
                  </Typography>
                </>
              )}
            </Box>
          </Grid>

          <Grid mt={2} container spacing={2} sx={{ marginLeft: '0px' }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className={classes.PropertyTitle}>
                Due Diligence
              </Typography>
            </Grid>
            <Grid
              container
              sx={{ paddingX: '16px', paddingTop: '15px', gap: '15px' }}
            >
              {(propertyTypeCode == '' ||
                (propertyTypeCode != '' &&
                  ['type001', 'type002', 'type004', 'type005'].includes(
                    propertyTypeCode
                  ))) && (
                <Grid item xs={12} sm={12} md={5.5} lg={5.5} xl={5.5}>
                  <FormLabel sx={typography_textfield} variant="h6">
                    Strata Report Link
                  </FormLabel>
                  <div style={{ position: 'relative', width: '100%' }}>
                    <TextField
                      sx={[
                        textboxmargin,
                        {
                          '& .MuiInputBase-root': {
                            height: matches400 ? '70px' : '56px',
                          },
                          marginTop: '10px',
                        },
                      ]}
                      fullWidth
                      style={{ width: matches900 && '102%' }}
                      helperText={errorMessageStrata.helperText}
                      error={errorMessageStrata.error}
                      placeholder={
                        matches1200
                          ? ''
                          : 'Example: https://www.examplestratareport.com.au/report'
                      }
                      id="name"
                      type="input"
                      name="name"
                      value={strata}
                      onChange={(event) => {
                        const link = event.target.value.trimStart();
                        event.target.value = link;
                        setStrata(event.target.value);
                      }}
                    />
                    {!strata && matches1200 && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '18px',
                          left: '14px',
                          color: 'rgba(0, 0, 0, 0.54)',
                          pointerEvents: 'none',
                          whiteSpace: 'pre-wrap',
                          fontWeight: 200,
                        }}
                      >
                        Example:{'\n'}www.examplestratareport.com.au
                        {matches400 ? '\n/report' : '/report'}
                      </div>
                    )}
                  </div>
                  {errorMessageStrata && <div>{errorMessageStrata.error}</div>}
                </Grid>
              )}

              <Grid
                item
                xs={12}
                sm={12}
                md={5.5}
                lg={5.5}
                xl={5.5}
                sx={{
                  order: ['type003', 'type009'].includes(propertyTypeCode)
                    ? 2
                    : 1,
                }}
              >
                <FormControl style={{ display: 'flex' }}>
                  <Typography sx={typography_textfield} variant="h6">
                    Document Upload{' '}
                    {getDocListlimit && (
                      <span
                        style={{
                          color: 'red',
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          marginLeft: '20px',
                        }}
                      >
                        ( Maximum Document Upload Reached! )
                      </span>
                    )}
                  </Typography>
                  <InputLabel
                    focused={false}
                    shrink={false}
                    variant="h4"
                    // style={{maxWidth:"90%"}}
                    htmlFor="bathroom-count-select"
                    sx={{
                      fontFamily: 'poppins',
                      marginTop: matchessm ? '25px' : '35px',
                      marginLeft: '15px',
                      color: 'rgba(0, 0, 0, 0.30)',
                      fontWeight: 300,
                      opacity: getDocList?.length == 11 && 0.5,
                      pointerEvents: getDocList?.length == 11 && 'none',
                      visibility:
                        selectedDocumentType || isSelectFocused
                          ? 'hidden'
                          : 'visible',
                    }}
                  >
                    Type of additional document
                  </InputLabel>
                  <Select
                    // required={typeState}
                    error={docType != ''}
                    style={{
                      marginTop: '6px',
                      fontFamily: 'poppins',
                      width: matches900 && '99.5%',
                      opacity: getDocList?.length == 11 && 0.5,
                      pointerEvents: getDocList?.length == 11 && 'none',
                    }}
                    inputProps={{
                      id: 'timer-count-select',
                    }}
                    fullWidth
                    className={classes.PropertydropDown}
                    // helperText={errorMessageBathroom.helperText}
                    // error={errorMessageBathroom.error}
                    disableUnderline
                    sx={[
                      // select_dropdown,
                      {
                        '.MuiOutlinedInput-notchedOutline': {
                          borderColor: 'rgba(0, 85, 255, 0.64)',
                        },
                      },
                    ]}
                    IconComponent={ExpandMoreIcon}
                    value={selectedDocumentType}
                    onChange={handleDocumentTypeChange}
                    open={isSelectFocused}
                    onClose={() =>
                      setTimeout(() => DocumentUploadHandleclose(), 50)
                    }
                    onMouseDown={(e) => {
                      e.preventDefault(); // ✅ This prevents the dropdown from opening on drag end
                      if (isDragging) return;
                      DocumentUploadHandleOpen(false);
                    }}
                    onFocus={() => {
                      DocumentUploadHandleOpen(true);
                    }}
                    onKeyDown={(event) => {
                      if (event.key === 'Tab') {
                        DocumentUploadHandleOpen(true);
                      }
                    }}
                    onClick={(e) => {
                      if (isDragging) {
                        e.preventDefault();
                        e.stopPropagation();
                      }
                    }}
                    onBlur={DocumentUploadHandleclose}
                  >
                    {documentTypeListArr?.map((item, index) => (
                      <MenuItem
                        disabled={
                          item?.documentType === 'Strata Minutes' ||
                          item?.documentType === 'Other'
                            ? item?.tempDocCount == 3
                            : item?.tempDocCount == 1
                        }
                        onClick={() =>
                          setSelectedDocumentCode(item?.documentTypeCode)
                        }
                        key={index}
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontSize: '16px',
                          fontWeight: '300',
                        }}
                        value={item?.documentType}
                      >
                        {item?.documentType}
                      </MenuItem>
                    ))}
                  </Select>
                  {docType != '' && (
                    <FormHelperText
                      style={{
                        color: 'red',
                        fontSize: '15px',
                        fontFamily: 'poppins',
                      }}
                    >
                      {docType}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {(propertyTypeCode == '' ||
                (propertyTypeCode != '' &&
                  ['type003', 'type004', 'type009'].includes(
                    propertyTypeCode
                  ))) && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={5.5}
                  lg={5.5}
                  xl={5.5}
                  sx={{ order: { xs: 2, sm: 2, md: 1, lg: 1, xl: 1 } }}
                >
                  <FormLabel sx={typography_textfield} variant="h6">
                    Building & Pest Report Link
                  </FormLabel>
                  <div style={{ position: 'relative', width: '100%' }}>
                    <TextField
                      sx={[
                        textboxmargin,
                        {
                          '& .MuiInputBase-root': {
                            height: '56px',
                            width: matches900 ? '99%' : '100%',
                          },
                          marginTop: '10px',
                        },
                      ]}
                      fullWidth
                      style={{ width: matches900 && '102%' }}
                      // required
                      helperText={errorMessageBuilding.helperText}
                      error={errorMessageBuilding.error}
                      // placeholder="Example: https://pestinspection.au/report"
                      placeholder={
                        matches600
                          ? ''
                          : 'Example: https://pestinspection.au/report'
                      }
                      id="name"
                      type="input"
                      name="name"
                      value={building}
                      onChange={(event) => {
                        setBuilding(event.target.value);
                      }}
                    />
                    {!building && matches600 && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '18px',
                          left: '14px',
                          color: 'rgba(0, 0, 0, 0.54)',
                          pointerEvents: 'none',
                          whiteSpace: 'pre-wrap',
                          fontWeight: 200,
                          lineHeight: '1.2',
                        }}
                      >
                        Example:{'\n'}https://pestinspection.au/report
                      </div>
                    )}
                  </div>
                  {errorMessageBuilding && (
                    <div>{errorMessageBuilding.error}</div>
                  )}
                </Grid>
              )}

              <Grid
                item
                xs={12}
                sm={12}
                md={5.5}
                lg={5.5}
                xl={5.5}
                sx={{ order: { xs: 1, sm: 1, md: 2, lg: 2, xl: 2 } }}
              >
                {/* {(selectedDocumentType != '' && media.length != allowed) && (
              <Grid mb={'10px'} item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography sx={typography_textfield} >Other Documents</Typography>
              </Grid>
            )} */}

                <Grid
                  container
                  ref={otherDocumentRef}
                  style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}
                >
                  {selectedDocumentType != '' && media.length != allowed && (
                    <Grid
                      item
                      sx={{
                        pointerEvents: flag >= allowed ? 'none' : 'auto',
                        cursor: flag >= allowed ? 'not-allowed' : 'auto',
                        opacity: flag >= allowed ? 0.5 : 1,
                      }}
                    >
                      <DropZone
                        {...getDocumentsFileProps()}
                        isDragActive={isDragAcceptDoc || isDragRejectDoc}
                        isDragAccept={isDragAcceptDoc}
                        isDragReject={isDragRejectDoc}
                      >
                        <p
                          className={classes.pdfUploadText}
                          style={{ padding: '0px 20px' }}
                        >
                          {isDragAcceptDoc ? (
                            'All files are accepted'
                          ) : isDragRejectDoc ? (
                            'Some files are rejected'
                          ) : (
                            <>
                              <AddCircleOutlineIcon
                                style={{ color: '#965CF0', fontSize: '25px' }}
                              />
                              <br /> Upload or Drag here
                            </>
                          )}
                        </p>
                        <input {...getDocumentsFileInputProps()} />
                      </DropZone>
                    </Grid>
                  )}
                  <Grid item>
                    {media.length > 0 && (
                      <Grid
                        sx={{
                          display: 'flex',
                          margin: '20px 0',
                          gap: '10px',
                          flexWrap: 'wrap',
                        }}
                      >
                        {media.map((file) => (
                          <Grid
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              flexDirection: 'row',
                              position: 'relative',
                              fontFamily: 'poppins',
                            }}
                            className={classes.MaxPdfBox}
                          >
                            <Box
                              sx={{
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                              }}
                              key={file.name}
                              title={file.name}
                            >
                              <img
                                src={PdfIcon}
                                style={{ width: '140px', height: 'auto' }}
                                alt="pdficon"
                              />
                              <IconButton
                                disabled={loading}
                                onClick={() =>
                                  setMedia((prevFiles) =>
                                    prevFiles.filter(
                                      (f) => f.name !== file.name
                                    )
                                  )
                                }
                                style={{
                                  width: '33px',
                                  height: '33px',
                                  cursor: 'pointer',
                                  position: 'absolute',
                                  top: '0',
                                  right: '25px',
                                  backgroundColor: 'transparent',
                                  padding: '9px',
                                }}
                                disableRipple
                                disableFocusRipple
                              >
                                <CancelIcon style={{ fontSize: '9px' }} />
                              </IconButton>
                              {/* <br /> */}
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: '14px',
                                  fontFamily: 'poppins',
                                  fontWeight: 400,
                                  wordBreak: 'break-all',
                                  maxWidth: '140px',
                                  textAlign: 'center',
                                  lineHeight: '1.2',
                                  marginTop: '5px',
                                }}
                              >
                                {file.name}
                              </Typography>
                            </Box>
                          </Grid>
                        ))}
                        <Grid
                          sx={{
                            display: 'flex',
                            margin: '20px 0px 20px 10px',
                            gap: '15px',
                            alignItems: 'center',
                          }}
                        >
                          <Button
                            disabled={otherDocLoading}
                            onClick={uploadDocument}
                            variant="contained"
                            sx={{
                              background: 'rgb(108, 42, 210)',
                              boxShadow: 'none',
                              padding: '10px 20px',
                              fontSize: '12px',
                              textTransform: 'capitalize',
                              '&:hover': {
                                backgroundColor: 'rgb(108, 42, 210)',
                                boxShadow: 'none',
                              },
                            }}
                          >
                            Confirm Upload
                          </Button>
                          {otherDocLoading && (
                            <img
                              alt="Logo"
                              src={Loading}
                              className="loaderImage"
                              style={{
                                height: '40px',
                                width: '40px',
                                marginLeft: '10px',
                              }}
                            />
                          )}
                          {errorOtherDocument.error && (
                            <Box ref={errorOtherDocumentRef}>
                              <Typography
                                sx={{
                                  fontFamily: 'poppins',
                                  color: 'red',
                                  fontSize: '12px',
                                }}
                              >
                                {errorOtherDocument.helperText}
                              </Typography>
                            </Box>
                          )}
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>

                {docValidate != '' && (
                  <Box
                    sx={{
                      color: 'red',
                      fontSize: '16px',
                      fontFamily: 'poppins',
                    }}
                  >
                    {docValidate}
                    {/* Select and Upload Documents ! */}
                  </Box>
                )}
              </Grid>
            </Grid>

            {getDocList?.length > 0 && (
              <Grid sx={{ margin: '15px 0 15px 15px', width: '100%' }}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: '100%' }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ fontSize: '14px' }}
                          className={classes.TableFont}
                        >
                          S No
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: '14px' }}
                          className={classes.TableFont}
                        >
                          Document Type
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: '14px' }}
                          className={classes.TableFont}
                        >
                          Document Name
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: '14px' }}
                          className={classes.TableFont}
                        >
                          Remove
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {getDocList?.map((row, index) => {
                        return (
                          <TableRow
                            key={index}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                            }}
                          >
                            <TableCell
                              sx={{ fontSize: '12px' }}
                              className={classes.TableFont}
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              sx={{ fontSize: '12px' }}
                              className={classes.TableFont}
                            >
                              {row?.documentType}
                            </TableCell>
                            <TableCell
                              sx={{ fontSize: '12px' }}
                              className={classes.TableFont}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 0.5,
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <Box
                                  component="img"
                                  src={PdfIcon}
                                  alt="pdficon"
                                  sx={{ width: '50px', height: 'auto' }}
                                />

                                <Box sx={{ fontFamily: 'poppins' }}>
                                  {filesName?.map(
                                    (item, i) => index == i && item
                                  )}
                                </Box>
                              </Box>
                            </TableCell>
                            {/* <Stack gap={10} direction={"row"} justifyContent={"flex-start"} alignItems={"center"}>
                              {row?.documentList?.length > 0 && row?.documentList?.slice(0,3)?.map((item, i) => {
                                let docLink = item?.document.split("/")
                                let fileName = docLink[docLink?.length-1]
                                return (<Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
                                  <img src={PdfIcon} style={{ width: '60px', height: 'auto' }} alt="pdficon" />
                                  <Typography>{docLink}</Typography>

                                </Stack>
                                )
                              })}
                            </Stack>

                          </TableCell> */}
                            <TableCell>
                              <IconButton
                                disabled={loading}
                                onClick={() => DeleteDoc(row?.docTempId)}
                              >
                                <ClearIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}

            {/*  */}

            {/* <Grid item xs={12} sm={12} md={1.7} lg={1.7} xl={1.7}></Grid> */}

            {/* start */}

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              sx={
                fromHeader != 'no'
                  ? { filter: 'blur(1px)', pointerEvents: 'none', opacity: 1 }
                  : {}
              }
            >
              <Typography className={classes.PropertyTitle}>
                {' '}
                Open for Inspections
              </Typography>
            </Grid>

            {inspection.map((inspection, index) => (
              <>
                <>
                  <Grid
                    key={index}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    sx={{
                      marginRight: '10%',
                      ...(fromHeader !== 'no' && {
                        filter: 'blur(1px)',
                        pointerEvents: 'none',
                        opacity: 1,
                      }),
                    }}
                  >
                    <Stack flexDirection={'row'} alignItems={'center'}>
                      {/* <Typography>
          <input
            type="checkbox"
            checked={inspection.recurring}
            // onClick={() => setRecurring(!recurring)}
            onChange={() => {
              handleInspectionChange(index, "recurring", !inspection.recurring);
              setRecurring(!recurring);
            }}
          ></input>

         Recurring   Single<ToggleOn/>Reoccuring
        </Typography> */}
                      <Typography sx={checkbox_style}>
                        &nbsp; One Off &nbsp;
                      </Typography>
                      {inspection.recurring ? (
                        <IconButton
                          onClick={() => {
                            handleInspectionChange(
                              index,
                              'recurring',
                              !inspection.recurring
                            );
                            setRecurring(!recurring);
                          }}
                        >
                          <ToggleOn />
                        </IconButton>
                      ) : (
                        <IconButton
                          onClick={() => {
                            handleInspectionChange(
                              index,
                              'recurring',
                              !inspection.recurring
                            );
                            setRecurring(!recurring);
                          }}
                        >
                          <ToggleOff />
                        </IconButton>
                      )}
                      <Typography sx={checkbox_style}>
                        &nbsp; Reoccurring
                      </Typography>
                    </Stack>
                  </Grid>

                  {inspection.recurring ? (
                    <>
                      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                        <FormControl style={{ display: 'flex', width: '96%' }}>
                          <FormLabel
                            sx={typography_textfield}
                            required={
                              upcomingInspection?.length > 0 ? false : true
                            }
                          >
                            Day Select
                          </FormLabel>
                          <InputLabel
                            variant="h4"
                            htmlFor="day-count-select"
                            sx={{
                              marginTop: matchessm ? '20px' : '30px',
                              marginLeft: '20px',
                              color: 'rgba(0, 0, 0, 0.30)',
                              fontWeight: 300,
                              visibility: 'visible',
                              fontFamily: 'poppins',
                              visibility:
                                inspection?.day || isSelectFocusedDay
                                  ? 'hidden'
                                  : 'visible',
                            }}
                          >
                            Select day
                          </InputLabel>
                          <Select
                            // required
                            fullWidth
                            inputProps={{
                              id: 'day-count-select',
                            }}
                            disableUnderline
                            sx={
                              (select_dropdown,
                              {
                                marginTop: '5px',
                                fontFamily: 'poppins',
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'rgba(0, 85, 255, 0.64)',
                                },
                              })
                            }
                            helperText={errorMessageDaySelect.helperText}
                            error={
                              errorMessageDaySelect.index == index &&
                              errorMessageDaySelect.error
                            }
                            IconComponent={ExpandMoreIcon}
                            value={inspection?.day}
                            onChange={(event) => {
                              const selectedDay = event.target.value;
                              setInspectionday(
                                handleInspectionChange(
                                  index,
                                  'day',
                                  event.target.value
                                )
                              );
                              setErrorMessageDaySelect({
                                helperText: '',
                                error: false,
                                index: index,
                              });
                              validateOccurrence(
                                inspection.startDate,
                                inspection.endDate,
                                selectedDay,
                                index
                              );
                              const count = getOccurrenceCount(
                                inspection.startDate,
                                inspection.endDate,
                                selectedDay
                              );
                              handleInspectionChange(
                                index,
                                'occurrence',
                                count
                              );
                            }}
                            onFocus={() => setSelectFocusedDay(true)}
                            onBlur={() => setSelectFocusedDay(false)}
                          >
                            <MenuItem
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontSize: '16px',
                                fontWeight: '300',
                              }}
                              value="Sunday"
                            >
                              Sunday
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontSize: '16px',
                                fontWeight: '300',
                              }}
                              value="Monday"
                            >
                              Monday
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontSize: '16px',
                                fontWeight: '300',
                              }}
                              value="Tuesday"
                            >
                              Tuesday
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontSize: '16px',
                                fontWeight: '300',
                              }}
                              value="Wednesday"
                            >
                              Wednesday
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontSize: '16px',
                                fontWeight: '300',
                              }}
                              value="Thursday"
                            >
                              Thursday
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontSize: '16px',
                                fontWeight: '300',
                              }}
                              value="Friday"
                            >
                              Friday
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontSize: '16px',
                                fontWeight: '300',
                              }}
                              value="Saturday"
                            >
                              Saturday
                            </MenuItem>
                          </Select>
                        </FormControl>
                        {errorMessageDaySelect.error &&
                          errorMessageDaySelect.index == index && (
                            <FormHelperText
                              style={{
                                color: '#d32f2f',
                                fontFamily: 'poppins',
                              }}
                            >
                              {errorMessageDaySelect.helperText}
                            </FormHelperText>
                          )}
                      </Grid>
                      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}></Grid>
                      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}></Grid>
                    </>
                  ) : null}

                  <Grid
                    container
                    sx={{ paddingX: '16px', paddingTop: '15px', gap: '15px' }}
                  >
                    <Grid
                      ref={inspectionRef}
                      item
                      xs={12}
                      sm={12}
                      md={3}
                      lg={3}
                      xl={3}
                      sx={
                        fromHeader != 'no'
                          ? {
                              filter: 'blur(1px)',
                              pointerEvents: 'none',
                              opacity: 1,
                            }
                          : {}
                      }
                    >
                      <FormLabel
                        sx={typography_textfield}
                        required={upcomingInspection?.length > 0 ? false : true}
                      >
                        {inspection.recurring ? 'Start Date' : 'Date'}
                      </FormLabel>
                      <div style={{ marginTop: '5px' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            // required
                            sx={
                              (pick_date,
                              {
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'rgba(0, 85, 255, 0.64)',
                                },
                                '& .MuiInputBase-input': {
                                  fontFamily: 'poppins',
                                },
                              })
                            }
                            // slotProps={{ textField: { fullWidth: true } }}
                            value={
                              inspection?.startDate
                                ? dayjs(inspection?.startDate)
                                : null
                            }
                            format="DD-MM-YYYY"
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error:
                                  errorMessageStartDate.index == index &&
                                  errorMessageStartDate.error,
                              },
                            }}
                            // minDate={
                            //   isNextDay ? sydneyNow.add(1, "day") : minDate
                            // }
                            minDate={sydneyTomorrow}
                            shouldDisableDate={(date) => {
                              const localTodayStr =
                                dayjs().format('YYYY-MM-DD');
                              const sydneyTodayStr =
                                sydneyToday.format('YYYY-MM-DD');
                              const cellDateStr = date.format('YYYY-MM-DD');
                              return (
                                cellDateStr === localTodayStr ||
                                cellDateStr === sydneyTodayStr ||
                                date.isBefore(dayjs(), 'day')
                              );
                            }}
                            onChange={(newValue) => {
                              const newStartDate = newValue
                                ? newValue.format('YYYY-MM-DD')
                                : null;
                              let val = newValue
                                ? newValue.format('YYYY-MM-DD')
                                : null;

                              setInspectionstartdate(
                                handleInspectionChange(index, 'startDate', val)
                              );
                              if (val && dayjs(val).isValid()) {
                                const selectedDate = dayjs.tz(
                                  val,
                                  'YYYY-MM-DD',
                                  'Australia/Sydney'
                                );
                                const todaySydney = dayjs()
                                  .tz('Australia/Sydney')
                                  .startOf('day');

                                if (selectedDate.isBefore(todaySydney)) {
                                  setErrorMessageStartDate({
                                    helperText: 'Past date cannot be selected',
                                    error: true,
                                    index: index,
                                  });
                                } else if (
                                  selectedDate.isSame(todaySydney, 'day')
                                ) {
                                  setErrorMessageStartDate({
                                    helperText:
                                      "Today's date is not allowed. Choose a future date.",
                                    error: true,
                                    index: index,
                                  });
                                } else {
                                  setErrorMessageStartDate({
                                    helperText: '',
                                    error: false,
                                    index: index,
                                  });
                                }
                              } else if (val) {
                                setErrorMessageStartDate({
                                  helperText: 'Please select a valid date',
                                  error: true,
                                  index: index,
                                });
                              } else {
                                setErrorMessageStartDate({
                                  helperText: '',
                                  error: false,
                                  index: index,
                                });
                              }
                              validateOccurrence(
                                newStartDate,
                                inspection.endDate,
                                inspection.day,
                                index
                              );
                              const count = getOccurrenceCount(
                                val,
                                inspection.endDate,
                                inspection.day
                              );
                              handleInspectionChange(
                                index,
                                'occurrence',
                                count
                              );
                            }}
                            //             onChange={(newValue) => {
                            //               const selectedDate = dayjs(newValue);
                            //               const today = dayjs().tz('Australia/Sydney').startOf('day');

                            //               if (!selectedDate || !selectedDate.isValid()) {
                            //                 return;
                            //               }

                            //               if (selectedDate.isBefore(today)) {
                            //                 setErrorMessageStartDate({
                            //                   helperText: "Past date cannot be selected",
                            //                   error: true,
                            //                   index: index
                            //                 });
                            //                 return;
                            //               }

                            //               const val = selectedDate.format("YYYY-MM-DD");

                            //               // ✅ Reset Time field when Date is changed
                            //               setInspectiontime(
                            //                 handleInspectionChange(index, "time", null)
                            //               );

                            //               setCurrentSydneyDate(dayjs().tz('Australia/Sydney').add(3, 'hour').add(5, 'minute'));

                            //               setInspectionstartdate(
                            //                 handleInspectionChange(index, "startDate", val)
                            //               );

                            //               setErrorMessageStartDate({
                            //                 helperText: "",
                            //                 error: false,
                            //                 index: index
                            //               });

                            //               if (inspection.endDate && selectedDate.isSameOrAfter(dayjs(inspection.endDate))) {
                            //                 setInspectionenddate(
                            //                   handleInspectionChange(index, "endDate", "")
                            //                 );
                            //               }

                            //               setMinEndDate(newValue);
                            //             }}
                            slots={{
                              openPickerIcon: Dateicon,
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                      {errorMessageStartDate.error &&
                        errorMessageStartDate.index == index && (
                          <FormHelperText
                            style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                          >
                            {errorMessageStartDate.helperText}
                          </FormHelperText>
                        )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={3}
                      lg={3}
                      xl={3}
                      sx={
                        fromHeader != 'no'
                          ? {
                              filter: 'blur(1px)',
                              pointerEvents: 'none',
                              opacity: 1,
                            }
                          : {}
                      }
                    >
                      <FormLabel
                        sx={typography_textfield}
                        required={upcomingInspection?.length > 0 ? false : true}
                      >
                        Time
                      </FormLabel>
                      <div style={{ marginTop: '5px' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            minTime={currentSydneyTime ? dayjs(minDate) : null}
                            value={
                              inspection.time
                                ? dayjs(inspection.time, 'HH:mm')
                                : currentSydneyTime
                                ? dayjs(minDate)
                                : null
                            }
                            slotProps={{
                              textField: {
                                // required: true,
                                placeholder: 'hh:mm',
                                fullWidth: true,
                                error:
                                  errorMessageTime.error &&
                                  errorMessageTime.index == index,
                              },
                            }}
                            fullWidth
                            sx={
                              (pick_date,
                              {
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'rgba(0, 85, 255, 0.64)',
                                },
                                '& .MuiInputBase-input': {
                                  fontFamily: 'poppins',
                                },
                              })
                            }
                            // label="Pick Time"
                            views={['hours', 'minutes']}
                            onChange={(newValue) => {
                              let val = newValue
                                ? newValue.format('HH:mm')
                                : null;
                              setInspectiontime(
                                handleInspectionChange(index, 'time', val)
                              );
                              setErrorMessageTime({
                                helperText: '',
                                error: false,
                                index: index,
                              });
                            }}
                            slots={{
                              openPickerIcon: Timeicon,
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                      {errorMessageTime.error &&
                        errorMessageTime.index == index && (
                          <FormHelperText
                            style={{ color: '#d32f2f', fontFamily: 'poppins' }}
                          >
                            {errorMessageTime.helperText}
                          </FormHelperText>
                        )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={4}
                      lg={matches1250 ? 4 : 3}
                      xl={3}
                      sx={
                        fromHeader != 'no'
                          ? {
                              filter: 'blur(1px)',
                              pointerEvents: 'none',
                              opacity: 1,
                            }
                          : {}
                      }
                    >
                      <FormControl style={{ display: 'flex' }}>
                        <FormLabel
                          sx={typography_textfield}
                          required={
                            upcomingInspection?.length > 0 ? false : true
                          }
                        >
                          Duration
                        </FormLabel>
                        <InputLabel
                          focused={false}
                          shrink={false}
                          variant="h4"
                          htmlFor="duration-count-select"
                          sx={{
                            fontFamily: 'poppins',
                            marginTop: matchessm ? '24px' : '30px',
                            marginLeft: matches1400 ? '10px' : '20px',
                            color: 'rgba(0, 0, 0, 0.30)',
                            fontWeight: 300,
                            fontSize: matches1400 && '14px',
                            color: '#C5C5C5',
                            visibility:
                              inspection?.duration || openDurationIndex
                                ? 'hidden'
                                : 'visible',
                          }}
                        >
                          Select inspection duration time
                        </InputLabel>
                        <Select
                          // required
                          fullWidth
                          inputProps={{
                            id: 'duration-count-select',
                          }}
                          displayEmpty={String(inspection?.duration) == ''}
                          disableUnderline
                          error={
                            errorMessageDuration?.error &&
                            errorMessageDuration?.index == index
                          }
                          sx={
                            (select_dropdown,
                            {
                              marginTop: '5px',
                              fontFamily: 'poppins',
                              '.MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgba(0, 85, 255, 0.64)',
                              },
                            })
                          }
                          IconComponent={ExpandMoreIcon}
                          value={hideSelect ? '' : inspection?.duration || ''}
                          defaultValue={''}
                          onChange={(event) => {
                            setInspectionduration(
                              handleInspectionChange(
                                index,
                                'duration',
                                event.target.value
                              )
                            );
                            setErrorMessageDuration({
                              helperText: '',
                              error: false,
                              index: index,
                            });
                          }}
                          open={openDurationIndex === index}
                          onClose={() =>
                            setTimeout(() => DurationHandleClose(), 50)
                          }
                          onMouseDown={() => DurationHandleOpen(index)}
                          onFocus={() => DurationHandleOpen(index)}
                          onBlur={DurationHandleClose}
                        >
                          {/* <MenuItem
            sx={{
              fontFamily: "Poppins !important",
              fontSize: "16px",
              fontWeight: "300",
              display:'none'
            }}
            value=""
          >
           </MenuItem>  */}

                          {durationList?.map((item, index) => (
                            <MenuItem
                              key={index}
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontSize: '16px',
                                fontWeight: '300',
                              }}
                              value={item}
                            >
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errorMessageDuration.error &&
                        errorMessageDuration?.index == index && (
                          <FormHelperText
                            style={{
                              color: '#d32f2f',
                              fontFamily: 'poppins',
                              ml: '30px',
                            }}
                          >
                            {errorMessageDuration.helperText}
                          </FormHelperText>
                        )}
                    </Grid>
                    {index != 0 && (
                      <Grid
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        sx={{ cursor: 'pointer', alignSelf: 'end' }}
                      >
                        <img
                          alt="DeleteIcon"
                          src={DeleteIcon}
                          height={'30px'}
                          width={'30px'}
                          style={{ objectFit: 'contain' }}
                          onClick={() => handleInspectionDelete(index)}
                        />
                      </Grid>
                    )}
                  </Grid>
                </>

                <>
                  <Grid
                    container
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    spacing={2}
                  >
                    {inspection.recurring ? (
                      <>
                        <>
                          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <FormLabel
                              sx={typography_textfield}
                              required={
                                upcomingInspection?.length > 0 ? false : true
                              }
                            >
                              Ending Date
                            </FormLabel>
                            <div>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  sx={
                                    (pick_date,
                                    {
                                      '.MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'rgba(0, 85, 255, 0.64)',
                                      },
                                      '& .MuiInputBase-input': {
                                        fontFamily: 'poppins',
                                      },
                                    })
                                  }
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      error:
                                        errorMessageEndingDate.error &&
                                        errorMessageEndingDate.index == index,
                                    },
                                  }}
                                  minDate={
                                    inspection?.startDate
                                      ? dayjs(inspection.startDate).add(
                                          1,
                                          'day'
                                        )
                                      : dayjs()
                                  }
                                  value={
                                    inspection?.endDate
                                      ? dayjs(inspection.endDate)
                                      : null
                                  }
                                  format="DD-MM-YYYY"
                                  onChange={(newValue) => {
                                    const newEndDate = newValue
                                      ? newValue.format('YYYY-MM-DD')
                                      : null;
                                    let val = newValue
                                      ? newValue.format('YYYY-MM-DD')
                                      : null;
                                    setInspectionenddate(
                                      handleInspectionChange(
                                        index,
                                        'endDate',
                                        val
                                      )
                                    );
                                    setErrorMessageEndingDate({
                                      helperText: '',
                                      error: false,
                                      index: index,
                                    });
                                    validateOccurrence(
                                      inspection.startDate,
                                      newEndDate,
                                      inspection.day,
                                      index
                                    );
                                    const count = getOccurrenceCount(
                                      inspection.startDate,
                                      val,
                                      inspection.day
                                    );
                                    handleInspectionChange(
                                      index,
                                      'occurrence',
                                      count
                                    );
                                  }}
                                  slots={{
                                    openPickerIcon: Dateicon,
                                  }}
                                />
                              </LocalizationProvider>
                            </div>
                            <div>
                              {errorMessageEndingDate.error &&
                                errorMessageEndingDate.index == index && (
                                  <FormHelperText
                                    style={{
                                      color: '#d32f2f',
                                      fontFamily: 'poppins',
                                    }}
                                  >
                                    {errorMessageEndingDate.helperText}
                                  </FormHelperText>
                                )}
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <FormLabel sx={typography_textfield}>
                              Number of Occurrences
                            </FormLabel>

                            <TextField
                              fullWidth
                              value={inspection?.occurrence || 0}
                              InputProps={{
                                readOnly: true,
                                style: { fontFamily: 'poppins' },
                              }}
                              sx={{
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'rgba(0, 85, 255, 0.64)',
                                },
                              }}
                            />
                          </Grid>
                        </>
                      </>
                    ) : null}
                  </Grid>
                </>
              </>
            ))}
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              sx={
                fromHeader != 'no'
                  ? { filter: 'blur(1px)', pointerEvents: 'none', opacity: 1 }
                  : {}
              }
            >
              {occurenceDay != '' && (
                <Typography
                  sx={{
                    margin: '5px 0',
                    color: 'red',
                    fontSize: '14px',
                    fontFamily: 'poppins',
                  }}
                >
                  {occurenceDay}
                </Typography>
              )}
              {greaterDate != '' && (
                <FormHelperText
                  style={{
                    color: '#d32f2f',
                    margin: '5px 0',

                    fontFamily: 'poppins',
                    textAlign: 'left',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    marginTop: '-6px',
                  }}
                >
                  {greaterDate}
                </FormHelperText>
              )}
              {selectDate != '' && (
                <Typography
                  sx={{
                    margin: '5px 0',
                    color: 'red',
                    fontSize: '14px',
                    fontFamily: 'poppins',
                  }}
                >
                  {selectDate}
                </Typography>
              )}
              {addInspection != '' && (
                <Typography
                  sx={{
                    margin: '5px 0',
                    color: 'red',
                    fontSize: '14px',
                    fontFamily: 'poppins',
                  }}
                >
                  {addInspection}
                </Typography>
              )}
              <Grid
                style={{ display: 'flex' }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                gap={'20px'}
              >
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Button
                    disabled={addInspectionLoader}
                    onClick={handleClickInspection}
                    style={{
                      //  marginTop: "20px",
                      // marginLeft: "15px",
                      width: '72px',
                      height: '59px',
                      fontFamily: 'Poppins',
                      // border: "1px solid rgba(175, 5, 255, 1)",
                      textTransform: 'inherit',
                      borderRadius: '5px',
                      color: '#737497',
                      background: '#f0e9fa',
                      // cursor: "not-allowed",
                      marginRight: '25px',
                      fontSize: '36px',
                      fontWeight: 300,
                    }}
                  >
                    +
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={3}
                  lg={3}
                  xl={3}
                  display={'flex'}
                  justifyContent={'right'}
                  alignItems={'center'}
                >
                  <Button
                    disabled={addInspectionLoader || !isBtnEnable()}
                    onClick={handleSubmitInspection}
                    required
                    ref={swalcontinue}
                    style={{
                      marginRight: '10px',
                      fontFamily: 'Poppins',
                      border: '1px solid rgba(175, 5, 255, 1)',
                      textTransform: 'inherit',
                      borderRadius: '5px',
                      color: 'white',
                      // background: fromHeader != 'no' ? 'grey' : '#6C2AD2',
                      background:
                        addInspectionLoader ||
                        !isBtnEnable() ||
                        fromHeader != 'no'
                          ? 'grey'
                          : '#6C2AD2',
                      opacity: addInspectionLoader || !isBtnEnable() ? 0.5 : 1,
                      cursor:
                        addInspectionLoader || !isBtnEnable()
                          ? 'not-allowed'
                          : 'pointer',
                      fontSize: '16px',
                      fontWeight: 500,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {inspection.length > 1 || recurring
                      ? 'Save Inspections'
                      : 'Save Inspection'}
                  </Button>
                  {addInspectionLoader && (
                    <img
                      alt="Logo"
                      src={Loading}
                      className="loaderImage"
                      style={{ height: '40px', width: '40px' }}
                    />
                  )}
                </Grid>
                {/* {addInspectionLoader &&  */}
                {/* <CircularProgress
                  // size={30}
                  style={{
                    // position: 'relative',
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    // margin:"auto 0 auto 15px",
                    color: "#6C2AD2",
                  }}
                /> */}
                {/* } */}
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}></Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              sx={{
                marginTop: '10px',
                ...(fromHeader != 'no' && {
                  filter: 'blur(1px)',
                  pointerEvents: 'none',
                  opacity: 1,
                }),
              }}
            >
              <FormLabel
                sx={upcoming_instructions}
                variant="h6"
                marginTop={'10px'}
              >
                Upcoming Inspections
              </FormLabel>

              <TableContainer
                component={Paper}
                sx={{
                  marginTop: '20px',
                  width: matchesmd ? '95%' : '90%',
                  ...(fromHeader != 'no' && {
                    filter: 'blur(1px)',
                    pointerEvents: 'none',
                    opacity: 1,
                  }),
                }}
              >
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.TableFont}>Day</TableCell>
                      <TableCell className={classes.TableFont}>Date</TableCell>
                      <TableCell className={classes.TableFont}>Time</TableCell>
                      <TableCell className={classes.TableFont}>
                        Duration
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: '14px' }}
                        className={classes.TableFont}
                      >
                        Remove
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {upcomingInspection?.length > 0 ? (
                      upcomingInspection.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <TableCell
                            className={classes.TableFont}
                            component="th"
                            scope="row"
                          >
                            {row.day}{' '}
                          </TableCell>
                          <TableCell className={classes.TableFont}>
                            {row.date} {row.year}
                          </TableCell>
                          <TableCell className={classes.TableFont}>
                            {row.time}
                          </TableCell>
                          <TableCell className={classes.TableFont}>
                            {row.duration}
                          </TableCell>
                          <TableCell>
                            <IconButton
                              onClick={() => DeleteIns(row.insId)}
                              disabled={loading}
                            >
                              <ClearIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={5}
                          sx={{
                            textAlign: 'center',
                            fontFamily: 'poppins',
                            padding: '25px',
                          }}
                        >
                          No inspections scheduled
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              sx={{
                marginTop: '10px',
                ...(fromHeader != 'no' && {
                  filter: 'blur(1px)',
                  pointerEvents: 'none',
                  opacity: 1,
                }),
              }}
            >
              <FormLabel sx={upcoming_instructions} variant="h6">
                Past Inspections
              </FormLabel>
              <TableContainer
                component={Paper}
                sx={{ marginTop: '20px', width: matchesmd ? '95%' : '90%' }}
              >
                <Table sx={{ minWidth: '100%' }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.TableFont}>Day</TableCell>
                      <TableCell className={classes.TableFont}>Date</TableCell>
                      <TableCell className={classes.TableFont}>Time</TableCell>
                      <TableCell className={classes.TableFont}>
                        Duration
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: '14px' }}
                        className={classes.TableFont}
                      >
                        Remove
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        sx={{
                          textAlign: 'center',
                          fontFamily: 'poppins',
                          padding: '25px',
                        }}
                      >
                        No inspections completed
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            <Grid container sx={{ paddingX: '16px', paddingTop: '15px' }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={4}
                xl={4}
                display={'flex'}
                alignItems={'center'}
              >
                <Typography className={classes.PropertyTitle}>
                  Tenancy Details
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: matches600 ? '50px' : '100px',
                flexWrap: 'wrap',
                paddingX: '16px',
                marginBottom: '30px',
              }}
            >
              <Grid
                item
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}
              >
                <Stack flexDirection={'row'} alignItems={'center'}>
                  <Typography sx={typography_textfield}>
                    Tenanted &nbsp; &nbsp;
                  </Typography>

                  {/* <Typography>
                    <input
                      required={!yesChecked && !noChecked}
                      name="option"
                      type="checkbox"
                      checked={yesChecked}
                      onChange={handleYesCheckboxChange}
                    />
                  </Typography>
                  <Typography sx={checkbox_style}>
                    &nbsp; Yes
                  </Typography> */}

                  <Typography sx={checkbox_style}>&nbsp; No &nbsp;</Typography>
                  {yesChecked ? (
                    <IconButton onClick={handleYesCheckboxChange}>
                      <ToggleOn />
                    </IconButton>
                  ) : (
                    <IconButton onClick={handleYesCheckboxChange}>
                      <ToggleOff />
                    </IconButton>
                  )}
                  <Typography sx={checkbox_style}>&nbsp; Yes</Typography>
                </Stack>
              </Grid>
              {/* <Grid
                item
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <Typography sx={typography_textfield_legalrep} variant="h6">
                  Publish to Listing
                </Typography>
                <Grid>
                  <input
                    type="checkbox"
                    // checked={inspection.recurring}
                    // onClick={() => setRecurring(!recurring)}
                    // onChange={() => {
                    //   handleInspectionChange(index, "recurring", !inspection.recurring);
                    //   setRecurring(!recurring);
                    // }}
                  ></input>
                </Grid>
              </Grid> */}
            </Grid>
            {yesChecked === true && (
              <>
                <Grid container sx={{ padding: '10px 16px' }}>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Typography sx={typography_textfield} variant="h6">
                      Lease Expiry
                    </Typography>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        marginTop: '5px',
                      }}
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          sx={
                            (pick_date,
                            {
                              '.MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgba(0, 85, 255, 0.64)',
                              },
                            })
                          }
                          // style={{width:"90%"}}
                          minDate={dayjs()}
                          value={leaseExpiry ? dayjs(leaseExpiry) : null}
                          format="DD-MM-YYYY"
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: leaseVal != '' && true,
                              helperText: leaseVal,
                            },
                          }}
                          onChange={(newValue) => {
                            let val = newValue
                              ? newValue.format('YYYY-MM-DD')
                              : null;
                            setLeaseExpiry(val);
                          }}
                          slots={{
                            openPickerIcon: Dateicon,
                          }}
                        />
                      </LocalizationProvider>
                      <input
                        style={{ marginLeft: '10px' }}
                        type="checkbox"
                        checked={publishlease}
                        onClick={() => setPublishlease(!publishlease)}
                      ></input>
                    </div>
                  </Grid>
                </Grid>
                <Grid container sx={{ paddingX: '16px' }}>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Typography sx={typography_textfield} variant="h6">
                      Rental Price p.w
                    </Typography>
                    <Box
                      sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                    >
                      <TextField
                        sx={textboxmargin}
                        fullWidth
                        // style={{width:"88%"}}
                        helperText={errorMessageRentalPrice.helperText}
                        error={errorMessageRentalPrice.error}
                        placeholder="Example: $900"
                        id="heading"
                        // type="number"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        onKeyPress={handleKeyPress}
                        className={classes.noSpinArrows}
                        value={formattedRentalPrice}
                        name="heading"
                        onChange={(event) => {
                          let inputValue = event.target.value ?? '';
                          if (typeof inputValue === 'string') {
                            inputValue = inputValue.replace(/\D/g, '');
                            setRentalPrice(inputValue);
                          }
                        }}
                      />
                      {errorMessageRentalPrice && (
                        <div>{errorMessageRentalPrice.error}</div>
                      )}
                      <input
                        style={{ marginLeft: '10px' }}
                        type="checkbox"
                        checked={publishrent}
                        onClick={() => setPublishrent(!publishrent)}
                      ></input>
                    </Box>
                  </Grid>
                </Grid>
              </>
            )}

            <Grid
              sx={{ marginBottom: matches700 && '50px' }}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Box
                // className={classes.buttonBox}
                sx={{
                  display: 'flex',
                  justifyContent: 'end',
                  gap: '20px',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                }}
              >
                <Button
                  disabled={loading}
                  variant="outlined"
                  // className={classes.cancelBtn}
                  sx={{
                    ...poppins500,
                    fontSize: '16px',
                    color: 'black',
                    // width: "210px",
                    // height: "48px",
                    background: '#FFFFFF',
                    whiteSpace: 'nowrap',
                    border: '1px solid #DFDFDF',
                    borderRadius: '8px',
                    textTransform: 'inherit',
                    padding: matches700 ? '5px 25px' : '12px 76px 12px 76px',
                    ' &:hover': {
                      backgroundColor: '#FFFFFF !important',
                      color: '#6C2AD2',
                      border: '1px solid #6C2AD2 !important ',
                    },
                  }}
                  onClick={() => {
                    onClose();
                    setValue(0);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  disabled={loading}
                  variant="outlined"
                  sx={{
                    backgroundColor: '#965CF0 !important',
                    ...poppins500,
                    color: '#FFFFFF !important',
                    fontSize: '16px',
                    borderRadius: '8px',
                    whiteSpace: 'nowrap',
                    textTransform: 'inherit',
                    padding: matches700 ? '5px 25px' : '12px 76px 12px 76px',
                    border: '1px solid #AF05FF !important',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    ' &:hover': {
                      backgroundColor: '#965CF0 !important',
                      border: '1px solid #AF05FF !important ',
                    },
                    '&.Mui-disabled': {
                      backgroundColor: '#e0e0e0 !important',
                      color: '#9e9e9e !important',
                      border: '1px solid #e0e0e0 !important',
                    },
                  }}
                  onClick={propertydetails}
                >
                  {fromHeader == 'no' || fromHeader == 'property'
                    ? 'Next'
                    : 'Submit'}
                </Button>
                {loading && (
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '40px', width: '40px' }}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </form>
      <Dialog open={pdfErrorOpen} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontFamily: 'Poppins', fontSize: '24px' }}>
          File exceeds 15mb limit!
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography sx={{ fontFamily: 'Poppins', fontSize: '14px' }}>
              {/* Document exceeds the limit! (20Mb) Please contact retreX support */}
              {pdfErrorFile} exceeds the limit! Please contact retreX support
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            className={classes.ModalnextBtn}
            sx={{ fontFamily: 'Poppins', fontSize: '16px' }}
            onClick={() => {
              setPdfErrorOpen(false);
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      {/* confirm to add owner details */}
      <Dialog
        open={addMoreField}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '20px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Add Details
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                marginTop: '10px',
                paddingLeft: '12px',
              }}
            >
              Do you want to add Owner Details?
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                onClick={closeAddFieldConfirmBox}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                onClick={confirmAddmoreField}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                // endIcon={ deleteOfferLoading && <CircularProgress size={25} sx={{color:"white"}} />}
              >
                Confirm
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <AddAppraisalDialog
        open={openPropPrefill}
        onClose={ClosePropPrefill}
        onSelect={handlePropertySelect}
        responseData={responseData}
        addresses={addresses}
      />
    </>
  );
}
